(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2270],{

/***/ 54986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// https://github.com/zloirock/core-js/issues/280
var userAgent = __webpack_require__(88113);

// eslint-disable-next-line unicorn/no-unsafe-regex -- safe
module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);


/***/ }),

/***/ 76650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var repeat = __webpack_require__(38415);
var requireObjectCoercible = __webpack_require__(84488);

var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString(requireObjectCoercible($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString(fillString);
    var intMaxLength = toLength(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};


/***/ }),

/***/ 38415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(99958);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ 66528:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var $padEnd = (__webpack_require__(76650).end);
var WEBKIT_BUG = __webpack_require__(54986);

// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 42270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth_AccountForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(68304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(88674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/url-polyfill/url-polyfill.js
var url_polyfill = __webpack_require__(38264);
// EXTERNAL MODULE: ./node_modules/url-search-params-polyfill/index.js
var url_search_params_polyfill = __webpack_require__(35449);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/growth/auth/NamelessAccountContext.mjs
function cov_zwvtdzmpk() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/growth/auth/NamelessAccountContext.tsx";
    var hash = "8547c54334477fbeff8b44d3c3ea4353b6e26697";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/growth/auth/NamelessAccountContext.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 10,
                    column: 38
                },
                end: {
                    line: 18,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 22,
                    column: 4
                },
                end: {
                    line: 41,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 29,
                    column: 2
                },
                end: {
                    line: 40,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 6
                    },
                    end: {
                        line: 41,
                        column: 1
                    }
                },
                line: 28
            }
        },
        branchMap: {},
        s: {
            "0": 0,
            "1": 0,
            "2": 0
        },
        f: {
            "0": 0
        },
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "8547c54334477fbeff8b44d3c3ea4353b6e26697"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_zwvtdzmpk = function cov_zwvtdzmpk() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_zwvtdzmpk();

var NamelessAccountContext = (cov_zwvtdzmpk().s[0]++, /*#__PURE__*/ react.createContext(// Default values for context
{
    shouldRegisterOnEmailSubmit: false,
    onPasswordFormLoad: undefined,
    onAccountUpdate: undefined,
    emailRegistrationError: ""
}));
cov_zwvtdzmpk().s[1]++;
var NamelessAccountContextProvider = function NamelessAccountContextProvider(_ref) {
    var shouldRegisterOnEmailSubmit = _ref.shouldRegisterOnEmailSubmit, onPasswordFormLoad = _ref.onPasswordFormLoad, onAccountUpdate = _ref.onAccountUpdate, emailRegistrationError = _ref.emailRegistrationError, children = _ref.children;
    cov_zwvtdzmpk().f[0]++;
    cov_zwvtdzmpk().s[2]++;
    return /*#__PURE__*/ React.createElement(NamelessAccountContext.Provider, {
        value: {
            shouldRegisterOnEmailSubmit: shouldRegisterOnEmailSubmit,
            onPasswordFormLoad: onPasswordFormLoad,
            onAccountUpdate: onAccountUpdate,
            emailRegistrationError: emailRegistrationError
        }
    }, children);
}; //# sourceMappingURL=NamelessAccountContext.mjs.map

// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(60285);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.to-json.js
var web_url_to_json = __webpack_require__(83753);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(41637);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/EmailInput.js
var EmailInput = __webpack_require__(4958);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/AccountFormControls.js
var AccountFormControls = __webpack_require__(62566);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/shared.mjs
var shared = __webpack_require__(68759);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/AccountEmailForm.mjs










function cov_586ootbo1() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/AccountEmailForm.tsx";
    var hash = "f5eb4decf914878a01e1f9ddf34d2c04dbda1b28";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/AccountEmailForm.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 31,
                    column: 25
                },
                end: {
                    line: 145,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 46,
                    column: 44
                },
                end: {
                    line: 46,
                    column: 74
                }
            },
            "2": {
                start: {
                    line: 47,
                    column: 30
                },
                end: {
                    line: 47,
                    column: 60
                }
            },
            "3": {
                start: {
                    line: 49,
                    column: 36
                },
                end: {
                    line: 49,
                    column: 60
                }
            },
            "4": {
                start: {
                    line: 51,
                    column: 30
                },
                end: {
                    line: 59,
                    column: 5
                }
            },
            "5": {
                start: {
                    line: 52,
                    column: 18
                },
                end: {
                    line: 52,
                    column: 47
                }
            },
            "6": {
                start: {
                    line: 53,
                    column: 21
                },
                end: {
                    line: 53,
                    column: 58
                }
            },
            "7": {
                start: {
                    line: 56,
                    column: 6
                },
                end: {
                    line: 58,
                    column: 7
                }
            },
            "8": {
                start: {
                    line: 57,
                    column: 8
                },
                end: {
                    line: 57,
                    column: 61
                }
            },
            "9": {
                start: {
                    line: 61,
                    column: 4
                },
                end: {
                    line: 64,
                    column: 11
                }
            },
            "10": {
                start: {
                    line: 62,
                    column: 6
                },
                end: {
                    line: 62,
                    column: 26
                }
            },
            "11": {
                start: {
                    line: 66,
                    column: 25
                },
                end: {
                    line: 74,
                    column: 5
                }
            },
            "12": {
                start: {
                    line: 67,
                    column: 6
                },
                end: {
                    line: 67,
                    column: 25
                }
            },
            "13": {
                start: {
                    line: 68,
                    column: 6
                },
                end: {
                    line: 70,
                    column: 7
                }
            },
            "14": {
                start: {
                    line: 69,
                    column: 8
                },
                end: {
                    line: 69,
                    column: 24
                }
            },
            "15": {
                start: {
                    line: 71,
                    column: 6
                },
                end: {
                    line: 73,
                    column: 7
                }
            },
            "16": {
                start: {
                    line: 72,
                    column: 8
                },
                end: {
                    line: 72,
                    column: 28
                }
            },
            "17": {
                start: {
                    line: 76,
                    column: 33
                },
                end: {
                    line: 81,
                    column: 5
                }
            },
            "18": {
                start: {
                    line: 77,
                    column: 6
                },
                end: {
                    line: 77,
                    column: 40
                }
            },
            "19": {
                start: {
                    line: 78,
                    column: 6
                },
                end: {
                    line: 80,
                    column: 7
                }
            },
            "20": {
                start: {
                    line: 79,
                    column: 8
                },
                end: {
                    line: 79,
                    column: 28
                }
            },
            "21": {
                start: {
                    line: 84,
                    column: 23
                },
                end: {
                    line: 84,
                    column: 41
                }
            },
            "22": {
                start: {
                    line: 87,
                    column: 36
                },
                end: {
                    line: 90,
                    column: 5
                }
            },
            "23": {
                start: {
                    line: 88,
                    column: 6
                },
                end: {
                    line: 88,
                    column: 22
                }
            },
            "24": {
                start: {
                    line: 89,
                    column: 6
                },
                end: {
                    line: 89,
                    column: 26
                }
            },
            "25": {
                start: {
                    line: 92,
                    column: 4
                },
                end: {
                    line: 143,
                    column: 6
                }
            },
            "26": {
                start: {
                    line: 120,
                    column: 16
                },
                end: {
                    line: 120,
                    column: 85
                }
            },
            "27": {
                start: {
                    line: 147,
                    column: 0
                },
                end: {
                    line: 147,
                    column: 50
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 32,
                        column: 2
                    },
                    end: {
                        line: 32,
                        column: 3
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 7
                    },
                    end: {
                        line: 144,
                        column: 3
                    }
                },
                line: 45
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 51,
                        column: 30
                    },
                    end: {
                        line: 51,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 51,
                        column: 36
                    },
                    end: {
                        line: 59,
                        column: 5
                    }
                },
                line: 51
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 61,
                        column: 14
                    },
                    end: {
                        line: 61,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 61,
                        column: 20
                    },
                    end: {
                        line: 64,
                        column: 5
                    }
                },
                line: 61
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 66,
                        column: 25
                    },
                    end: {
                        line: 66,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 66,
                        column: 66
                    },
                    end: {
                        line: 74,
                        column: 5
                    }
                },
                line: 66
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 76,
                        column: 33
                    },
                    end: {
                        line: 76,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 76,
                        column: 47
                    },
                    end: {
                        line: 81,
                        column: 5
                    }
                },
                line: 76
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 87,
                        column: 36
                    },
                    end: {
                        line: 87,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 87,
                        column: 87
                    },
                    end: {
                        line: 90,
                        column: 5
                    }
                },
                line: 87
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 119,
                        column: 24
                    },
                    end: {
                        line: 119,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 120,
                        column: 16
                    },
                    end: {
                        line: 120,
                        column: 85
                    }
                },
                line: 120
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 34,
                        column: 6
                    },
                    end: {
                        line: 34,
                        column: 31
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 34,
                            column: 27
                        },
                        end: {
                            line: 34,
                            column: 31
                        }
                    }
                ],
                line: 34
            },
            "1": {
                loc: {
                    start: {
                        line: 39,
                        column: 13
                    },
                    end: {
                        line: 39,
                        column: 30
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 39,
                            column: 28
                        },
                        end: {
                            line: 39,
                            column: 30
                        }
                    }
                ],
                line: 39
            },
            "2": {
                loc: {
                    start: {
                        line: 56,
                        column: 6
                    },
                    end: {
                        line: 58,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 56,
                            column: 6
                        },
                        end: {
                            line: 58,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 56
            },
            "3": {
                loc: {
                    start: {
                        line: 57,
                        column: 24
                    },
                    end: {
                        line: 57,
                        column: 59
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 57,
                            column: 24
                        },
                        end: {
                            line: 57,
                            column: 43
                        }
                    },
                    {
                        start: {
                            line: 57,
                            column: 47
                        },
                        end: {
                            line: 57,
                            column: 59
                        }
                    }
                ],
                line: 57
            },
            "4": {
                loc: {
                    start: {
                        line: 68,
                        column: 6
                    },
                    end: {
                        line: 70,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 68,
                            column: 6
                        },
                        end: {
                            line: 70,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 68
            },
            "5": {
                loc: {
                    start: {
                        line: 71,
                        column: 6
                    },
                    end: {
                        line: 73,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 71,
                            column: 6
                        },
                        end: {
                            line: 73,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 71
            },
            "6": {
                loc: {
                    start: {
                        line: 71,
                        column: 10
                    },
                    end: {
                        line: 71,
                        column: 48
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 71,
                            column: 10
                        },
                        end: {
                            line: 71,
                            column: 13
                        }
                    },
                    {
                        start: {
                            line: 71,
                            column: 17
                        },
                        end: {
                            line: 71,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 71,
                            column: 37
                        },
                        end: {
                            line: 71,
                            column: 48
                        }
                    }
                ],
                line: 71
            },
            "7": {
                loc: {
                    start: {
                        line: 78,
                        column: 6
                    },
                    end: {
                        line: 80,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 78,
                            column: 6
                        },
                        end: {
                            line: 80,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 78
            },
            "8": {
                loc: {
                    start: {
                        line: 78,
                        column: 10
                    },
                    end: {
                        line: 78,
                        column: 72
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 78,
                            column: 10
                        },
                        end: {
                            line: 78,
                            column: 30
                        }
                    },
                    {
                        start: {
                            line: 78,
                            column: 34
                        },
                        end: {
                            line: 78,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 78,
                            column: 41
                        },
                        end: {
                            line: 78,
                            column: 57
                        }
                    },
                    {
                        start: {
                            line: 78,
                            column: 61
                        },
                        end: {
                            line: 78,
                            column: 72
                        }
                    }
                ],
                line: 78
            },
            "9": {
                loc: {
                    start: {
                        line: 84,
                        column: 23
                    },
                    end: {
                        line: 84,
                        column: 41
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 84,
                            column: 23
                        },
                        end: {
                            line: 84,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 84,
                            column: 35
                        },
                        end: {
                            line: 84,
                            column: 41
                        }
                    }
                ],
                line: 84
            },
            "10": {
                loc: {
                    start: {
                        line: 95,
                        column: 11
                    },
                    end: {
                        line: 128,
                        column: 11
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 96,
                            column: 12
                        },
                        end: {
                            line: 113,
                            column: 14
                        }
                    },
                    {
                        start: {
                            line: 115,
                            column: 12
                        },
                        end: {
                            line: 127,
                            column: 14
                        }
                    }
                ],
                line: 95
            },
            "11": {
                loc: {
                    start: {
                        line: 102,
                        column: 21
                    },
                    end: {
                        line: 102,
                        column: 57
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 102,
                            column: 21
                        },
                        end: {
                            line: 102,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 102,
                            column: 54
                        },
                        end: {
                            line: 102,
                            column: 57
                        }
                    }
                ],
                line: 102
            },
            "12": {
                loc: {
                    start: {
                        line: 120,
                        column: 25
                    },
                    end: {
                        line: 120,
                        column: 84
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 120,
                            column: 57
                        },
                        end: {
                            line: 120,
                            column: 59
                        }
                    },
                    {
                        start: {
                            line: 120,
                            column: 62
                        },
                        end: {
                            line: 120,
                            column: 84
                        }
                    }
                ],
                line: 120
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0,
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "f5eb4decf914878a01e1f9ddf34d2c04dbda1b28"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_586ootbo1 = function cov_586ootbo1() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_586ootbo1();







function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}



var AccountEmailForm = (cov_586ootbo1().s[0]++, /*#__PURE__*/ (0,react.forwardRef)(function(_ref, ref) {
    var _ref$showForgotPasswo = _ref.showForgotPassword, showForgotPassword = _ref$showForgotPasswo === void 0 ? (cov_586ootbo1().b[0][0]++, true) : _ref$showForgotPasswo, analyticsName = _ref.analyticsName, loading = _ref.loading, openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab, onSubmit = _ref.onSubmit, _ref$email = _ref.email, initialEmail = _ref$email === void 0 ? (cov_586ootbo1().b[1][0]++, "") : _ref$email, CustomEmailInput = _ref.CustomEmailInput, customEmailValidityCheck = _ref.customEmailValidityCheck, customEmailValidityCheckDelay = _ref.customEmailValidityCheckDelay;
    cov_586ootbo1().f[0]++;
    var _ref2 = (cov_586ootbo1().s[1]++, (0,react.useState)(initialEmail)), _ref3 = _slicedToArray(_ref2, 2), prefillEmail = _ref3[0], setPrefillEmail = _ref3[1];
    var _ref4 = (cov_586ootbo1().s[2]++, (0,react.useState)(initialEmail)), _ref5 = _slicedToArray(_ref4, 2), email = _ref5[0], setEmail = _ref5[1];
    var _ref6 = (cov_586ootbo1().s[3]++, (0,react.useState)(false)), _ref7 = _slicedToArray(_ref6, 2), hasError = _ref7[0], setHasError = _ref7[1];
    cov_586ootbo1().s[4]++;
    var maybePrefillEmail = function maybePrefillEmail() {
        cov_586ootbo1().f[1]++;
        var url = (cov_586ootbo1().s[5]++, new URL(window.location.href));
        var params = (cov_586ootbo1().s[6]++, new URLSearchParams(url.searchParams));
        // Update state on mount only if there is a query param override
        cov_586ootbo1().s[7]++;
        if (params.get("email")) {
            cov_586ootbo1().b[2][0]++;
            cov_586ootbo1().s[8]++;
            setPrefillEmail((cov_586ootbo1().b[3][0]++, params.get("email")) || (cov_586ootbo1().b[3][1]++, initialEmail));
        } else {
            cov_586ootbo1().b[2][1]++;
        }
    };
    cov_586ootbo1().s[9]++;
    (0,react.useEffect)(function() {
        cov_586ootbo1().f[2]++;
        cov_586ootbo1().s[10]++;
        maybePrefillEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    cov_586ootbo1().s[11]++;
    var handleSubmit = function handleSubmit(e) {
        cov_586ootbo1().f[3]++;
        cov_586ootbo1().s[12]++;
        e.preventDefault();
        cov_586ootbo1().s[13]++;
        if (!hasError) {
            cov_586ootbo1().b[4][0]++;
            cov_586ootbo1().s[14]++;
            onSubmit(email);
        } else {
            cov_586ootbo1().b[4][1]++;
        }
        cov_586ootbo1().s[15]++;
        if ((cov_586ootbo1().b[6][0]++, ref) && (cov_586ootbo1().b[6][1]++, "current" in ref) && (cov_586ootbo1().b[6][2]++, ref.current)) {
            cov_586ootbo1().b[5][0]++;
            cov_586ootbo1().s[16]++;
            ref.current.focus();
        } else {
            cov_586ootbo1().b[5][1]++;
        }
    };
    cov_586ootbo1().s[17]++;
    var handleValidityChange = function handleValidityChange(validity) {
        cov_586ootbo1().f[4]++;
        cov_586ootbo1().s[18]++;
        setHasError(validity !== "valid");
        cov_586ootbo1().s[19]++;
        if ((cov_586ootbo1().b[8][0]++, validity !== "valid") && (cov_586ootbo1().b[8][1]++, ref) && (cov_586ootbo1().b[8][2]++, "current" in ref) && (cov_586ootbo1().b[8][3]++, ref.current)) {
            cov_586ootbo1().b[7][0]++;
            cov_586ootbo1().s[20]++;
            ref.current.focus();
        } else {
            cov_586ootbo1().b[7][1]++;
        }
    };
    // Disable the form if it has an error or if email is not set.
    var isDisabled = (cov_586ootbo1().s[21]++, (cov_586ootbo1().b[9][0]++, hasError) || (cov_586ootbo1().b[9][1]++, !email));
    // Handler for custom email input (legacy format)
    cov_586ootbo1().s[22]++;
    var handleCustomEmailChange = function handleCustomEmailChange(event, value, valid) {
        cov_586ootbo1().f[5]++;
        cov_586ootbo1().s[23]++;
        setEmail(value);
        cov_586ootbo1().s[24]++;
        setHasError(!valid);
    };
    cov_586ootbo1().s[25]++;
    return /*#__PURE__*/ react.createElement(shared/* Form */.l0, {
        onSubmitCapture: handleSubmit
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$4x"
    }, CustomEmailInput ? (cov_586ootbo1().b[10][0]++, /*#__PURE__*/ react.createElement(CustomEmailInput, {
        analyticsName: analyticsName,
        required: true,
        unboundedWidth: false,
        value: prefillEmail,
        onChange: handleCustomEmailChange,
        delay: (cov_586ootbo1().b[11][0]++, customEmailValidityCheckDelay) || (cov_586ootbo1().b[11][1]++, 500),
        label: "Email",
        type: "email",
        id: "email-login-input",
        name: "email",
        minLength: 3,
        errorMessage: "Please enter a valid email address",
        placeholder: "",
        width: "100%",
        customEmailValidityCheck: customEmailValidityCheck,
        autoComplete: "email"
    })) : (cov_586ootbo1().b[10][1]++, /*#__PURE__*/ react.createElement(EmailInput/* EmailInput */.U, {
        ref: ref,
        analyticsName: analyticsName,
        title: "Email",
        getValue: function getValue(value) {
            cov_586ootbo1().f[6]++;
            cov_586ootbo1().s[26]++;
            return setEmail(isNil_default()(value.unformattedValue) ? (cov_586ootbo1().b[12][0]++, "") : (cov_586ootbo1().b[12][1]++, value.unformattedValue));
        },
        onValidationChange: handleValidityChange,
        prefilledValue: prefillEmail,
        fieldRequiredError: "This field is required",
        invalidEmailError: "Please enter a valid email address",
        size: "medium"
    })), /*#__PURE__*/ react.createElement(AccountFormControls/* AccountFormControls */.W, {
        actionText: "Continue with email",
        analyticsName: analyticsName,
        loading: loading,
        disabled: isDisabled,
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        submitA11yProps: {
            "aria-label": ""
        },
        showForgotPassword: showForgotPassword,
        forgotPasswordText: "Forgot your password?",
        forgotPasswordAriaNewWindow: "Opens a new window with the forgot password page",
        forgotPasswordAriaSameWindow: "Opens the forgot password page"
    })));
}));
cov_586ootbo1().s[27]++;
AccountEmailForm.displayName = "AccountEmailForm";
/* harmony default export */ var auth_AccountEmailForm = (AccountEmailForm); //# sourceMappingURL=AccountEmailForm.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/AccountFormSubHeader.mjs
function cov_1v4o93cm16() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/AccountFormSubHeader.tsx";
    var hash = "41c06801c95d6149e3014956ecee135f22700610";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/AccountFormSubHeader.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 16,
                    column: 67
                },
                end: {
                    line: 52,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 26,
                    column: 21
                },
                end: {
                    line: 26,
                    column: 61
                }
            },
            "2": {
                start: {
                    line: 27,
                    column: 24
                },
                end: {
                    line: 27,
                    column: 83
                }
            },
            "3": {
                start: {
                    line: 29,
                    column: 2
                },
                end: {
                    line: 51,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 16,
                        column: 67
                    },
                    end: {
                        line: 16,
                        column: 68
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 6
                    },
                    end: {
                        line: 52,
                        column: 1
                    }
                },
                line: 25
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 26,
                        column: 21
                    },
                    end: {
                        line: 26,
                        column: 61
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 26,
                            column: 34
                        },
                        end: {
                            line: 26,
                            column: 46
                        }
                    },
                    {
                        start: {
                            line: 26,
                            column: 49
                        },
                        end: {
                            line: 26,
                            column: 61
                        }
                    }
                ],
                line: 26
            },
            "1": {
                loc: {
                    start: {
                        line: 27,
                        column: 24
                    },
                    end: {
                        line: 27,
                        column: 83
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 27,
                            column: 37
                        },
                        end: {
                            line: 27,
                            column: 62
                        }
                    },
                    {
                        start: {
                            line: 27,
                            column: 65
                        },
                        end: {
                            line: 27,
                            column: 83
                        }
                    }
                ],
                line: 27
            },
            "2": {
                loc: {
                    start: {
                        line: 31,
                        column: 7
                    },
                    end: {
                        line: 35,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 31,
                            column: 7
                        },
                        end: {
                            line: 31,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 32,
                            column: 8
                        },
                        end: {
                            line: 34,
                            column: 15
                        }
                    }
                ],
                line: 31
            },
            "3": {
                loc: {
                    start: {
                        line: 36,
                        column: 7
                    },
                    end: {
                        line: 49,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 36,
                            column: 7
                        },
                        end: {
                            line: 36,
                            column: 24
                        }
                    },
                    {
                        start: {
                            line: 36,
                            column: 28
                        },
                        end: {
                            line: 36,
                            column: 46
                        }
                    },
                    {
                        start: {
                            line: 36,
                            column: 50
                        },
                        end: {
                            line: 36,
                            column: 73
                        }
                    },
                    {
                        start: {
                            line: 37,
                            column: 8
                        },
                        end: {
                            line: 48,
                            column: 15
                        }
                    }
                ],
                line: 36
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0
        },
        f: {
            "0": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0,
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "41c06801c95d6149e3014956ecee135f22700610"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_1v4o93cm16 = function cov_1v4o93cm16() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1v4o93cm16();


cov_1v4o93cm16().s[0]++;
var AccountFormSubHeader = function AccountFormSubHeader(_ref) {
    var loginSubHeaderText = _ref.loginSubHeaderText, registrationSubHeaderText = _ref.registrationSubHeaderText, email = _ref.email, onValidEmailReset = _ref.onValidEmailReset, hasSubmittedEmail = _ref.hasSubmittedEmail, isNewHuman = _ref.isNewHuman, hidePasswordField = _ref.hidePasswordField, phoneNumberInputHidden = _ref.phoneNumberInputHidden;
    cov_1v4o93cm16().f[0]++;
    var actionText = (cov_1v4o93cm16().s[1]++, isNewHuman ? (cov_1v4o93cm16().b[0][0]++, "Signing up") : (cov_1v4o93cm16().b[0][1]++, "Signing in"));
    var subHeaderText = (cov_1v4o93cm16().s[2]++, isNewHuman ? (cov_1v4o93cm16().b[1][0]++, registrationSubHeaderText) : (cov_1v4o93cm16().b[1][1]++, loginSubHeaderText));
    cov_1v4o93cm16().s[3]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, null, (cov_1v4o93cm16().b[2][0]++, subHeaderText) && (cov_1v4o93cm16().b[2][1]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$subheaderSmall",
        marginTop: "$5x",
        marginBottom: "$5x",
        tag: "h2"
    }, subHeaderText)), (cov_1v4o93cm16().b[3][0]++, hasSubmittedEmail) && (cov_1v4o93cm16().b[3][1]++, !hidePasswordField) && (cov_1v4o93cm16().b[3][2]++, !phoneNumberInputHidden) && (cov_1v4o93cm16().b[3][3]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$bodySmall",
        tag: "p",
        gap: "$2x"
    }, actionText, " as", " ", /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: "_",
        size: "small",
        variant: "secondary",
        analyticsName: "Reset email",
        onPress: onValidEmailReset
    }, email))));
};
/* harmony default export */ var auth_AccountFormSubHeader = (AccountFormSubHeader); //# sourceMappingURL=AccountFormSubHeader.mjs.map

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__(26833);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(73210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(2490);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(59849);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/NameInput.js
var NameInput = __webpack_require__(38251);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/AccountPasswordInput.js
var AccountPasswordInput = __webpack_require__(30342);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/PhoneInput.js
var PhoneInput = __webpack_require__(66213);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/SimpleCheckbox.js
var SimpleCheckbox = __webpack_require__(44468);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/AccountPasswordForm.mjs

function cov_eyrv5w61a() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/AccountPasswordForm.tsx";
    var hash = "68e8343927547e09a466dc1bbba4026ac232f0a8";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/AccountPasswordForm.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 76,
                    column: 28
                },
                end: {
                    line: 470,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 106,
                    column: 20
                },
                end: {
                    line: 106,
                    column: 54
                }
            },
            "2": {
                start: {
                    line: 108,
                    column: 36
                },
                end: {
                    line: 108,
                    column: 60
                }
            },
            "3": {
                start: {
                    line: 109,
                    column: 28
                },
                end: {
                    line: 109,
                    column: 63
                }
            },
            "4": {
                start: {
                    line: 110,
                    column: 41
                },
                end: {
                    line: 110,
                    column: 65
                }
            },
            "5": {
                start: {
                    line: 111,
                    column: 52
                },
                end: {
                    line: 111,
                    column: 76
                }
            },
            "6": {
                start: {
                    line: 112,
                    column: 30
                },
                end: {
                    line: 112,
                    column: 66
                }
            },
            "7": {
                start: {
                    line: 113,
                    column: 46
                },
                end: {
                    line: 113,
                    column: 70
                }
            },
            "8": {
                start: {
                    line: 114,
                    column: 43
                },
                end: {
                    line: 114,
                    column: 87
                }
            },
            "9": {
                start: {
                    line: 115,
                    column: 36
                },
                end: {
                    line: 115,
                    column: 56
                }
            },
            "10": {
                start: {
                    line: 116,
                    column: 40
                },
                end: {
                    line: 120,
                    column: 10
                }
            },
            "11": {
                start: {
                    line: 122,
                    column: 26
                },
                end: {
                    line: 136,
                    column: 5
                }
            },
            "12": {
                start: {
                    line: 124,
                    column: 8
                },
                end: {
                    line: 126,
                    column: 9
                }
            },
            "13": {
                start: {
                    line: 125,
                    column: 10
                },
                end: {
                    line: 125,
                    column: 71
                }
            },
            "14": {
                start: {
                    line: 130,
                    column: 8
                },
                end: {
                    line: 133,
                    column: 10
                }
            },
            "15": {
                start: {
                    line: 138,
                    column: 32
                },
                end: {
                    line: 149,
                    column: 37
                }
            },
            "16": {
                start: {
                    line: 139,
                    column: 18
                },
                end: {
                    line: 139,
                    column: 47
                }
            },
            "17": {
                start: {
                    line: 140,
                    column: 21
                },
                end: {
                    line: 140,
                    column: 58
                }
            },
            "18": {
                start: {
                    line: 141,
                    column: 26
                },
                end: {
                    line: 141,
                    column: 67
                }
            },
            "19": {
                start: {
                    line: 142,
                    column: 34
                },
                end: {
                    line: 142,
                    column: 60
                }
            },
            "20": {
                start: {
                    line: 144,
                    column: 6
                },
                end: {
                    line: 148,
                    column: 7
                }
            },
            "21": {
                start: {
                    line: 145,
                    column: 8
                },
                end: {
                    line: 145,
                    column: 36
                }
            },
            "22": {
                start: {
                    line: 146,
                    column: 8
                },
                end: {
                    line: 146,
                    column: 40
                }
            },
            "23": {
                start: {
                    line: 147,
                    column: 8
                },
                end: {
                    line: 147,
                    column: 32
                }
            },
            "24": {
                start: {
                    line: 151,
                    column: 4
                },
                end: {
                    line: 156,
                    column: 39
                }
            },
            "25": {
                start: {
                    line: 152,
                    column: 6
                },
                end: {
                    line: 152,
                    column: 28
                }
            },
            "26": {
                start: {
                    line: 153,
                    column: 6
                },
                end: {
                    line: 155,
                    column: 7
                }
            },
            "27": {
                start: {
                    line: 154,
                    column: 8
                },
                end: {
                    line: 154,
                    column: 37
                }
            },
            "28": {
                start: {
                    line: 158,
                    column: 35
                },
                end: {
                    line: 158,
                    column: 95
                }
            },
            "29": {
                start: {
                    line: 158,
                    column: 49
                },
                end: {
                    line: 158,
                    column: 95
                }
            },
            "30": {
                start: {
                    line: 160,
                    column: 57
                },
                end: {
                    line: 170,
                    column: 5
                }
            },
            "31": {
                start: {
                    line: 161,
                    column: 6
                },
                end: {
                    line: 161,
                    column: 20
                }
            },
            "32": {
                start: {
                    line: 162,
                    column: 26
                },
                end: {
                    line: 162,
                    column: 52
                }
            },
            "33": {
                start: {
                    line: 163,
                    column: 26
                },
                end: {
                    line: 163,
                    column: 44
                }
            },
            "34": {
                start: {
                    line: 165,
                    column: 6
                },
                end: {
                    line: 169,
                    column: 7
                }
            },
            "35": {
                start: {
                    line: 166,
                    column: 8
                },
                end: {
                    line: 166,
                    column: 57
                }
            },
            "36": {
                start: {
                    line: 168,
                    column: 8
                },
                end: {
                    line: 168,
                    column: 50
                }
            },
            "37": {
                start: {
                    line: 172,
                    column: 58
                },
                end: {
                    line: 177,
                    column: 5
                }
            },
            "38": {
                start: {
                    line: 173,
                    column: 34
                },
                end: {
                    line: 173,
                    column: 54
                }
            },
            "39": {
                start: {
                    line: 175,
                    column: 6
                },
                end: {
                    line: 175,
                    column: 22
                }
            },
            "40": {
                start: {
                    line: 176,
                    column: 6
                },
                end: {
                    line: 176,
                    column: 30
                }
            },
            "41": {
                start: {
                    line: 179,
                    column: 40
                },
                end: {
                    line: 181,
                    column: 5
                }
            },
            "42": {
                start: {
                    line: 180,
                    column: 6
                },
                end: {
                    line: 180,
                    column: 42
                }
            },
            "43": {
                start: {
                    line: 183,
                    column: 61
                },
                end: {
                    line: 190,
                    column: 5
                }
            },
            "44": {
                start: {
                    line: 185,
                    column: 6
                },
                end: {
                    line: 185,
                    column: 33
                }
            },
            "45": {
                start: {
                    line: 188,
                    column: 6
                },
                end: {
                    line: 188,
                    column: 72
                }
            },
            "46": {
                start: {
                    line: 189,
                    column: 6
                },
                end: {
                    line: 189,
                    column: 28
                }
            },
            "47": {
                start: {
                    line: 192,
                    column: 25
                },
                end: {
                    line: 225,
                    column: 5
                }
            },
            "48": {
                start: {
                    line: 193,
                    column: 6
                },
                end: {
                    line: 193,
                    column: 25
                }
            },
            "49": {
                start: {
                    line: 195,
                    column: 6
                },
                end: {
                    line: 197,
                    column: 7
                }
            },
            "50": {
                start: {
                    line: 196,
                    column: 8
                },
                end: {
                    line: 196,
                    column: 15
                }
            },
            "51": {
                start: {
                    line: 199,
                    column: 6
                },
                end: {
                    line: 207,
                    column: 7
                }
            },
            "52": {
                start: {
                    line: 206,
                    column: 8
                },
                end: {
                    line: 206,
                    column: 15
                }
            },
            "53": {
                start: {
                    line: 209,
                    column: 6
                },
                end: {
                    line: 218,
                    column: 7
                }
            },
            "54": {
                start: {
                    line: 210,
                    column: 8
                },
                end: {
                    line: 215,
                    column: 9
                }
            },
            "55": {
                start: {
                    line: 211,
                    column: 10
                },
                end: {
                    line: 211,
                    column: 62
                }
            },
            "56": {
                start: {
                    line: 214,
                    column: 10
                },
                end: {
                    line: 214,
                    column: 44
                }
            },
            "57": {
                start: {
                    line: 217,
                    column: 8
                },
                end: {
                    line: 217,
                    column: 26
                }
            },
            "58": {
                start: {
                    line: 220,
                    column: 6
                },
                end: {
                    line: 224,
                    column: 9
                }
            },
            "59": {
                start: {
                    line: 228,
                    column: 6
                },
                end: {
                    line: 230,
                    column: 87
                }
            },
            "60": {
                start: {
                    line: 232,
                    column: 21
                },
                end: {
                    line: 232,
                    column: 30
                }
            },
            "61": {
                start: {
                    line: 233,
                    column: 4
                },
                end: {
                    line: 237,
                    column: 5
                }
            },
            "62": {
                start: {
                    line: 234,
                    column: 6
                },
                end: {
                    line: 234,
                    column: 26
                }
            },
            "63": {
                start: {
                    line: 235,
                    column: 11
                },
                end: {
                    line: 237,
                    column: 5
                }
            },
            "64": {
                start: {
                    line: 236,
                    column: 6
                },
                end: {
                    line: 236,
                    column: 30
                }
            },
            "65": {
                start: {
                    line: 239,
                    column: 4
                },
                end: {
                    line: 241,
                    column: 5
                }
            },
            "66": {
                start: {
                    line: 240,
                    column: 6
                },
                end: {
                    line: 240,
                    column: 42
                }
            },
            "67": {
                start: {
                    line: 243,
                    column: 40
                },
                end: {
                    line: 243,
                    column: 70
                }
            },
            "68": {
                start: {
                    line: 244,
                    column: 26
                },
                end: {
                    line: 244,
                    column: 67
                }
            },
            "69": {
                start: {
                    line: 245,
                    column: 26
                },
                end: {
                    line: 245,
                    column: 98
                }
            },
            "70": {
                start: {
                    line: 247,
                    column: 43
                },
                end: {
                    line: 247,
                    column: 80
                }
            },
            "71": {
                start: {
                    line: 249,
                    column: 43
                },
                end: {
                    line: 249,
                    column: 74
                }
            },
            "72": {
                start: {
                    line: 251,
                    column: 4
                },
                end: {
                    line: 258,
                    column: 47
                }
            },
            "73": {
                start: {
                    line: 252,
                    column: 6
                },
                end: {
                    line: 256,
                    column: 7
                }
            },
            "74": {
                start: {
                    line: 253,
                    column: 8
                },
                end: {
                    line: 255,
                    column: 9
                }
            },
            "75": {
                start: {
                    line: 254,
                    column: 10
                },
                end: {
                    line: 254,
                    column: 30
                }
            },
            "76": {
                start: {
                    line: 261,
                    column: 35
                },
                end: {
                    line: 263,
                    column: 5
                }
            },
            "77": {
                start: {
                    line: 262,
                    column: 6
                },
                end: {
                    line: 262,
                    column: 26
                }
            },
            "78": {
                start: {
                    line: 265,
                    column: 36
                },
                end: {
                    line: 267,
                    column: 5
                }
            },
            "79": {
                start: {
                    line: 266,
                    column: 6
                },
                end: {
                    line: 266,
                    column: 27
                }
            },
            "80": {
                start: {
                    line: 269,
                    column: 39
                },
                end: {
                    line: 271,
                    column: 5
                }
            },
            "81": {
                start: {
                    line: 270,
                    column: 6
                },
                end: {
                    line: 270,
                    column: 30
                }
            },
            "82": {
                start: {
                    line: 273,
                    column: 4
                },
                end: {
                    line: 468,
                    column: 6
                }
            },
            "83": {
                start: {
                    line: 341,
                    column: 22
                },
                end: {
                    line: 341,
                    column: 100
                }
            },
            "84": {
                start: {
                    line: 371,
                    column: 47
                },
                end: {
                    line: 371,
                    column: 62
                }
            },
            "85": {
                start: {
                    line: 387,
                    column: 24
                },
                end: {
                    line: 389,
                    column: 25
                }
            },
            "86": {
                start: {
                    line: 388,
                    column: 26
                },
                end: {
                    line: 388,
                    column: 52
                }
            },
            "87": {
                start: {
                    line: 472,
                    column: 0
                },
                end: {
                    line: 472,
                    column: 56
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 77,
                        column: 2
                    },
                    end: {
                        line: 77,
                        column: 3
                    }
                },
                loc: {
                    start: {
                        line: 105,
                        column: 7
                    },
                    end: {
                        line: 469,
                        column: 3
                    }
                },
                line: 105
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 123,
                        column: 6
                    },
                    end: {
                        line: 123,
                        column: 7
                    }
                },
                loc: {
                    start: {
                        line: 123,
                        column: 26
                    },
                    end: {
                        line: 134,
                        column: 7
                    }
                },
                line: 123
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 138,
                        column: 44
                    },
                    end: {
                        line: 138,
                        column: 45
                    }
                },
                loc: {
                    start: {
                        line: 138,
                        column: 50
                    },
                    end: {
                        line: 149,
                        column: 5
                    }
                },
                line: 138
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 151,
                        column: 14
                    },
                    end: {
                        line: 151,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 151,
                        column: 20
                    },
                    end: {
                        line: 156,
                        column: 5
                    }
                },
                line: 151
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 158,
                        column: 35
                    },
                    end: {
                        line: 158,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 158,
                        column: 49
                    },
                    end: {
                        line: 158,
                        column: 95
                    }
                },
                line: 158
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 160,
                        column: 57
                    },
                    end: {
                        line: 160,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 160,
                        column: 67
                    },
                    end: {
                        line: 170,
                        column: 5
                    }
                },
                line: 160
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 172,
                        column: 58
                    },
                    end: {
                        line: 172,
                        column: 59
                    }
                },
                loc: {
                    start: {
                        line: 172,
                        column: 69
                    },
                    end: {
                        line: 177,
                        column: 5
                    }
                },
                line: 172
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 179,
                        column: 40
                    },
                    end: {
                        line: 179,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 179,
                        column: 87
                    },
                    end: {
                        line: 181,
                        column: 5
                    }
                },
                line: 179
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 183,
                        column: 61
                    },
                    end: {
                        line: 183,
                        column: 62
                    }
                },
                loc: {
                    start: {
                        line: 183,
                        column: 75
                    },
                    end: {
                        line: 190,
                        column: 5
                    }
                },
                line: 183
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 192,
                        column: 25
                    },
                    end: {
                        line: 192,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 192,
                        column: 75
                    },
                    end: {
                        line: 225,
                        column: 5
                    }
                },
                line: 192
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 251,
                        column: 14
                    },
                    end: {
                        line: 251,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 251,
                        column: 20
                    },
                    end: {
                        line: 258,
                        column: 5
                    }
                },
                line: 251
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 261,
                        column: 35
                    },
                    end: {
                        line: 261,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 261,
                        column: 88
                    },
                    end: {
                        line: 263,
                        column: 5
                    }
                },
                line: 261
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 265,
                        column: 36
                    },
                    end: {
                        line: 265,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 265,
                        column: 89
                    },
                    end: {
                        line: 267,
                        column: 5
                    }
                },
                line: 265
            },
            "13": {
                name: "(anonymous_13)",
                decl: {
                    start: {
                        line: 269,
                        column: 39
                    },
                    end: {
                        line: 269,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 269,
                        column: 92
                    },
                    end: {
                        line: 271,
                        column: 5
                    }
                },
                line: 269
            },
            "14": {
                name: "(anonymous_14)",
                decl: {
                    start: {
                        line: 340,
                        column: 28
                    },
                    end: {
                        line: 340,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 340,
                        column: 34
                    },
                    end: {
                        line: 342,
                        column: 21
                    }
                },
                line: 340
            },
            "15": {
                name: "(anonymous_15)",
                decl: {
                    start: {
                        line: 371,
                        column: 36
                    },
                    end: {
                        line: 371,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 371,
                        column: 47
                    },
                    end: {
                        line: 371,
                        column: 62
                    }
                },
                line: 371
            },
            "16": {
                name: "(anonymous_16)",
                decl: {
                    start: {
                        line: 386,
                        column: 31
                    },
                    end: {
                        line: 386,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 386,
                        column: 47
                    },
                    end: {
                        line: 390,
                        column: 23
                    }
                },
                line: 386
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 92,
                        column: 6
                    },
                    end: {
                        line: 92,
                        column: 37
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 92,
                            column: 33
                        },
                        end: {
                            line: 92,
                            column: 37
                        }
                    }
                ],
                line: 92
            },
            "1": {
                loc: {
                    start: {
                        line: 93,
                        column: 6
                    },
                    end: {
                        line: 93,
                        column: 36
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 93,
                            column: 31
                        },
                        end: {
                            line: 93,
                            column: 36
                        }
                    }
                ],
                line: 93
            },
            "2": {
                loc: {
                    start: {
                        line: 109,
                        column: 45
                    },
                    end: {
                        line: 109,
                        column: 62
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 109,
                            column: 45
                        },
                        end: {
                            line: 109,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 109,
                            column: 60
                        },
                        end: {
                            line: 109,
                            column: 62
                        }
                    }
                ],
                line: 109
            },
            "3": {
                loc: {
                    start: {
                        line: 112,
                        column: 47
                    },
                    end: {
                        line: 112,
                        column: 65
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 112,
                            column: 47
                        },
                        end: {
                            line: 112,
                            column: 59
                        }
                    },
                    {
                        start: {
                            line: 112,
                            column: 63
                        },
                        end: {
                            line: 112,
                            column: 65
                        }
                    }
                ],
                line: 112
            },
            "4": {
                loc: {
                    start: {
                        line: 124,
                        column: 8
                    },
                    end: {
                        line: 126,
                        column: 9
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 124,
                            column: 8
                        },
                        end: {
                            line: 126,
                            column: 9
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 124
            },
            "5": {
                loc: {
                    start: {
                        line: 124,
                        column: 12
                    },
                    end: {
                        line: 124,
                        column: 40
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 124,
                            column: 12
                        },
                        end: {
                            line: 124,
                            column: 24
                        }
                    },
                    {
                        start: {
                            line: 124,
                            column: 28
                        },
                        end: {
                            line: 124,
                            column: 40
                        }
                    }
                ],
                line: 124
            },
            "6": {
                loc: {
                    start: {
                        line: 141,
                        column: 26
                    },
                    end: {
                        line: 141,
                        column: 67
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 141,
                            column: 26
                        },
                        end: {
                            line: 141,
                            column: 51
                        }
                    },
                    {
                        start: {
                            line: 141,
                            column: 55
                        },
                        end: {
                            line: 141,
                            column: 67
                        }
                    }
                ],
                line: 141
            },
            "7": {
                loc: {
                    start: {
                        line: 144,
                        column: 6
                    },
                    end: {
                        line: 148,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 144,
                            column: 6
                        },
                        end: {
                            line: 148,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 144
            },
            "8": {
                loc: {
                    start: {
                        line: 144,
                        column: 10
                    },
                    end: {
                        line: 144,
                        column: 57
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 144,
                            column: 10
                        },
                        end: {
                            line: 144,
                            column: 28
                        }
                    },
                    {
                        start: {
                            line: 144,
                            column: 32
                        },
                        end: {
                            line: 144,
                            column: 57
                        }
                    }
                ],
                line: 144
            },
            "9": {
                loc: {
                    start: {
                        line: 146,
                        column: 17
                    },
                    end: {
                        line: 146,
                        column: 38
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 146,
                            column: 28
                        },
                        end: {
                            line: 146,
                            column: 30
                        }
                    },
                    {
                        start: {
                            line: 146,
                            column: 33
                        },
                        end: {
                            line: 146,
                            column: 38
                        }
                    }
                ],
                line: 146
            },
            "10": {
                loc: {
                    start: {
                        line: 153,
                        column: 6
                    },
                    end: {
                        line: 155,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 153,
                            column: 6
                        },
                        end: {
                            line: 155,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 153
            },
            "11": {
                loc: {
                    start: {
                        line: 158,
                        column: 49
                    },
                    end: {
                        line: 158,
                        column: 95
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 158,
                            column: 49
                        },
                        end: {
                            line: 158,
                            column: 69
                        }
                    },
                    {
                        start: {
                            line: 158,
                            column: 73
                        },
                        end: {
                            line: 158,
                            column: 95
                        }
                    }
                ],
                line: 158
            },
            "12": {
                loc: {
                    start: {
                        line: 162,
                        column: 26
                    },
                    end: {
                        line: 162,
                        column: 52
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 162,
                            column: 26
                        },
                        end: {
                            line: 162,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 162,
                            column: 41
                        },
                        end: {
                            line: 162,
                            column: 52
                        }
                    }
                ],
                line: 162
            },
            "13": {
                loc: {
                    start: {
                        line: 165,
                        column: 6
                    },
                    end: {
                        line: 169,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 165,
                            column: 6
                        },
                        end: {
                            line: 169,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: 167,
                            column: 13
                        },
                        end: {
                            line: 169,
                            column: 7
                        }
                    }
                ],
                line: 165
            },
            "14": {
                loc: {
                    start: {
                        line: 166,
                        column: 21
                    },
                    end: {
                        line: 166,
                        column: 55
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 166,
                            column: 35
                        },
                        end: {
                            line: 166,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 166,
                            column: 43
                        },
                        end: {
                            line: 166,
                            column: 55
                        }
                    }
                ],
                line: 166
            },
            "15": {
                loc: {
                    start: {
                        line: 168,
                        column: 21
                    },
                    end: {
                        line: 168,
                        column: 48
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 168,
                            column: 21
                        },
                        end: {
                            line: 168,
                            column: 32
                        }
                    },
                    {
                        start: {
                            line: 168,
                            column: 36
                        },
                        end: {
                            line: 168,
                            column: 48
                        }
                    }
                ],
                line: 168
            },
            "16": {
                loc: {
                    start: {
                        line: 188,
                        column: 18
                    },
                    end: {
                        line: 188,
                        column: 70
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 188,
                            column: 18
                        },
                        end: {
                            line: 188,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 188,
                            column: 37
                        },
                        end: {
                            line: 188,
                            column: 70
                        }
                    }
                ],
                line: 188
            },
            "17": {
                loc: {
                    start: {
                        line: 195,
                        column: 6
                    },
                    end: {
                        line: 197,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 195,
                            column: 6
                        },
                        end: {
                            line: 197,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 195
            },
            "18": {
                loc: {
                    start: {
                        line: 195,
                        column: 10
                    },
                    end: {
                        line: 195,
                        column: 69
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 195,
                            column: 10
                        },
                        end: {
                            line: 195,
                            column: 18
                        }
                    },
                    {
                        start: {
                            line: 195,
                            column: 23
                        },
                        end: {
                            line: 195,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 195,
                            column: 38
                        },
                        end: {
                            line: 195,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 195,
                            column: 54
                        },
                        end: {
                            line: 195,
                            column: 67
                        }
                    }
                ],
                line: 195
            },
            "19": {
                loc: {
                    start: {
                        line: 199,
                        column: 6
                    },
                    end: {
                        line: 207,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 199,
                            column: 6
                        },
                        end: {
                            line: 207,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 199
            },
            "20": {
                loc: {
                    start: {
                        line: 201,
                        column: 8
                    },
                    end: {
                        line: 204,
                        column: 34
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 201,
                            column: 8
                        },
                        end: {
                            line: 201,
                            column: 62
                        }
                    },
                    {
                        start: {
                            line: 202,
                            column: 8
                        },
                        end: {
                            line: 202,
                            column: 32
                        }
                    },
                    {
                        start: {
                            line: 203,
                            column: 8
                        },
                        end: {
                            line: 203,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 204,
                            column: 8
                        },
                        end: {
                            line: 204,
                            column: 34
                        }
                    }
                ],
                line: 201
            },
            "21": {
                loc: {
                    start: {
                        line: 209,
                        column: 6
                    },
                    end: {
                        line: 218,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 209,
                            column: 6
                        },
                        end: {
                            line: 218,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: 216,
                            column: 13
                        },
                        end: {
                            line: 218,
                            column: 7
                        }
                    }
                ],
                line: 209
            },
            "22": {
                loc: {
                    start: {
                        line: 210,
                        column: 8
                    },
                    end: {
                        line: 215,
                        column: 9
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 210,
                            column: 8
                        },
                        end: {
                            line: 215,
                            column: 9
                        }
                    },
                    {
                        start: {
                            line: 212,
                            column: 15
                        },
                        end: {
                            line: 215,
                            column: 9
                        }
                    }
                ],
                line: 210
            },
            "23": {
                loc: {
                    start: {
                        line: 210,
                        column: 12
                    },
                    end: {
                        line: 210,
                        column: 74
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 210,
                            column: 12
                        },
                        end: {
                            line: 210,
                            column: 47
                        }
                    },
                    {
                        start: {
                            line: 210,
                            column: 51
                        },
                        end: {
                            line: 210,
                            column: 74
                        }
                    }
                ],
                line: 210
            },
            "24": {
                loc: {
                    start: {
                        line: 228,
                        column: 6
                    },
                    end: {
                        line: 230,
                        column: 87
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 228,
                            column: 6
                        },
                        end: {
                            line: 228,
                            column: 14
                        }
                    },
                    {
                        start: {
                            line: 229,
                            column: 7
                        },
                        end: {
                            line: 229,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 229,
                            column: 30
                        },
                        end: {
                            line: 229,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 229,
                            column: 43
                        },
                        end: {
                            line: 229,
                            column: 64
                        }
                    },
                    {
                        start: {
                            line: 230,
                            column: 7
                        },
                        end: {
                            line: 230,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 230,
                            column: 23
                        },
                        end: {
                            line: 230,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 230,
                            column: 45
                        },
                        end: {
                            line: 230,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 230,
                            column: 54
                        },
                        end: {
                            line: 230,
                            column: 66
                        }
                    },
                    {
                        start: {
                            line: 230,
                            column: 72
                        },
                        end: {
                            line: 230,
                            column: 85
                        }
                    }
                ],
                line: 228
            },
            "25": {
                loc: {
                    start: {
                        line: 233,
                        column: 4
                    },
                    end: {
                        line: 237,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 233,
                            column: 4
                        },
                        end: {
                            line: 237,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 235,
                            column: 11
                        },
                        end: {
                            line: 237,
                            column: 5
                        }
                    }
                ],
                line: 233
            },
            "26": {
                loc: {
                    start: {
                        line: 235,
                        column: 11
                    },
                    end: {
                        line: 237,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 235,
                            column: 11
                        },
                        end: {
                            line: 237,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 235
            },
            "27": {
                loc: {
                    start: {
                        line: 239,
                        column: 4
                    },
                    end: {
                        line: 241,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 239,
                            column: 4
                        },
                        end: {
                            line: 241,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 239
            },
            "28": {
                loc: {
                    start: {
                        line: 243,
                        column: 40
                    },
                    end: {
                        line: 243,
                        column: 70
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 243,
                            column: 40
                        },
                        end: {
                            line: 243,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 243,
                            column: 60
                        },
                        end: {
                            line: 243,
                            column: 70
                        }
                    }
                ],
                line: 243
            },
            "29": {
                loc: {
                    start: {
                        line: 244,
                        column: 26
                    },
                    end: {
                        line: 244,
                        column: 67
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 244,
                            column: 26
                        },
                        end: {
                            line: 244,
                            column: 53
                        }
                    },
                    {
                        start: {
                            line: 244,
                            column: 57
                        },
                        end: {
                            line: 244,
                            column: 67
                        }
                    }
                ],
                line: 244
            },
            "30": {
                loc: {
                    start: {
                        line: 245,
                        column: 26
                    },
                    end: {
                        line: 245,
                        column: 98
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 245,
                            column: 39
                        },
                        end: {
                            line: 245,
                            column: 49
                        }
                    },
                    {
                        start: {
                            line: 245,
                            column: 52
                        },
                        end: {
                            line: 245,
                            column: 98
                        }
                    }
                ],
                line: 245
            },
            "31": {
                loc: {
                    start: {
                        line: 247,
                        column: 43
                    },
                    end: {
                        line: 247,
                        column: 80
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 247,
                            column: 43
                        },
                        end: {
                            line: 247,
                            column: 66
                        }
                    },
                    {
                        start: {
                            line: 247,
                            column: 70
                        },
                        end: {
                            line: 247,
                            column: 80
                        }
                    }
                ],
                line: 247
            },
            "32": {
                loc: {
                    start: {
                        line: 252,
                        column: 6
                    },
                    end: {
                        line: 256,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 252,
                            column: 6
                        },
                        end: {
                            line: 256,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 252
            },
            "33": {
                loc: {
                    start: {
                        line: 252,
                        column: 10
                    },
                    end: {
                        line: 252,
                        column: 48
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 252,
                            column: 10
                        },
                        end: {
                            line: 252,
                            column: 27
                        }
                    },
                    {
                        start: {
                            line: 252,
                            column: 31
                        },
                        end: {
                            line: 252,
                            column: 48
                        }
                    }
                ],
                line: 252
            },
            "34": {
                loc: {
                    start: {
                        line: 253,
                        column: 8
                    },
                    end: {
                        line: 255,
                        column: 9
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 253,
                            column: 8
                        },
                        end: {
                            line: 255,
                            column: 9
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 253
            },
            "35": {
                loc: {
                    start: {
                        line: 253,
                        column: 12
                    },
                    end: {
                        line: 253,
                        column: 50
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 253,
                            column: 12
                        },
                        end: {
                            line: 253,
                            column: 15
                        }
                    },
                    {
                        start: {
                            line: 253,
                            column: 19
                        },
                        end: {
                            line: 253,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 253,
                            column: 39
                        },
                        end: {
                            line: 253,
                            column: 50
                        }
                    }
                ],
                line: 253
            },
            "36": {
                loc: {
                    start: {
                        line: 278,
                        column: 15
                    },
                    end: {
                        line: 313,
                        column: 18
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 278,
                            column: 15
                        },
                        end: {
                            line: 278,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 279,
                            column: 16
                        },
                        end: {
                            line: 279,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 280,
                            column: 17
                        },
                        end: {
                            line: 313,
                            column: 17
                        }
                    }
                ],
                line: 278
            },
            "37": {
                loc: {
                    start: {
                        line: 280,
                        column: 17
                    },
                    end: {
                        line: 313,
                        column: 17
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 281,
                            column: 18
                        },
                        end: {
                            line: 297,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 299,
                            column: 18
                        },
                        end: {
                            line: 312,
                            column: 20
                        }
                    }
                ],
                line: 280
            },
            "38": {
                loc: {
                    start: {
                        line: 288,
                        column: 27
                    },
                    end: {
                        line: 288,
                        column: 70
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 288,
                            column: 43
                        },
                        end: {
                            line: 288,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 288,
                            column: 59
                        },
                        end: {
                            line: 288,
                            column: 70
                        }
                    }
                ],
                line: 288
            },
            "39": {
                loc: {
                    start: {
                        line: 293,
                        column: 33
                    },
                    end: {
                        line: 293,
                        column: 79
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 293,
                            column: 55
                        },
                        end: {
                            line: 293,
                            column: 74
                        }
                    },
                    {
                        start: {
                            line: 293,
                            column: 77
                        },
                        end: {
                            line: 293,
                            column: 79
                        }
                    }
                ],
                line: 293
            },
            "40": {
                loc: {
                    start: {
                        line: 294,
                        column: 34
                    },
                    end: {
                        line: 294,
                        column: 91
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 294,
                            column: 49
                        },
                        end: {
                            line: 294,
                            column: 79
                        }
                    },
                    {
                        start: {
                            line: 294,
                            column: 82
                        },
                        end: {
                            line: 294,
                            column: 91
                        }
                    }
                ],
                line: 294
            },
            "41": {
                loc: {
                    start: {
                        line: 304,
                        column: 31
                    },
                    end: {
                        line: 304,
                        column: 88
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 304,
                            column: 46
                        },
                        end: {
                            line: 304,
                            column: 76
                        }
                    },
                    {
                        start: {
                            line: 304,
                            column: 79
                        },
                        end: {
                            line: 304,
                            column: 88
                        }
                    }
                ],
                line: 304
            },
            "42": {
                loc: {
                    start: {
                        line: 305,
                        column: 27
                    },
                    end: {
                        line: 305,
                        column: 70
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 305,
                            column: 43
                        },
                        end: {
                            line: 305,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 305,
                            column: 59
                        },
                        end: {
                            line: 305,
                            column: 70
                        }
                    }
                ],
                line: 305
            },
            "43": {
                loc: {
                    start: {
                        line: 307,
                        column: 33
                    },
                    end: {
                        line: 307,
                        column: 79
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 307,
                            column: 55
                        },
                        end: {
                            line: 307,
                            column: 74
                        }
                    },
                    {
                        start: {
                            line: 307,
                            column: 77
                        },
                        end: {
                            line: 307,
                            column: 79
                        }
                    }
                ],
                line: 307
            },
            "44": {
                loc: {
                    start: {
                        line: 314,
                        column: 15
                    },
                    end: {
                        line: 349,
                        column: 18
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 314,
                            column: 15
                        },
                        end: {
                            line: 314,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 315,
                            column: 17
                        },
                        end: {
                            line: 349,
                            column: 17
                        }
                    }
                ],
                line: 314
            },
            "45": {
                loc: {
                    start: {
                        line: 315,
                        column: 17
                    },
                    end: {
                        line: 349,
                        column: 17
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 316,
                            column: 18
                        },
                        end: {
                            line: 332,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 334,
                            column: 18
                        },
                        end: {
                            line: 348,
                            column: 20
                        }
                    }
                ],
                line: 315
            },
            "46": {
                loc: {
                    start: {
                        line: 326,
                        column: 34
                    },
                    end: {
                        line: 326,
                        column: 83
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 326,
                            column: 54
                        },
                        end: {
                            line: 326,
                            column: 71
                        }
                    },
                    {
                        start: {
                            line: 326,
                            column: 74
                        },
                        end: {
                            line: 326,
                            column: 83
                        }
                    }
                ],
                line: 326
            },
            "47": {
                loc: {
                    start: {
                        line: 339,
                        column: 31
                    },
                    end: {
                        line: 339,
                        column: 69
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 339,
                            column: 31
                        },
                        end: {
                            line: 339,
                            column: 48
                        }
                    },
                    {
                        start: {
                            line: 339,
                            column: 52
                        },
                        end: {
                            line: 339,
                            column: 69
                        }
                    }
                ],
                line: 339
            },
            "48": {
                loc: {
                    start: {
                        line: 341,
                        column: 42
                    },
                    end: {
                        line: 341,
                        column: 98
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 341,
                            column: 42
                        },
                        end: {
                            line: 341,
                            column: 61
                        }
                    },
                    {
                        start: {
                            line: 341,
                            column: 65
                        },
                        end: {
                            line: 341,
                            column: 98
                        }
                    }
                ],
                line: 341
            },
            "49": {
                loc: {
                    start: {
                        line: 350,
                        column: 15
                    },
                    end: {
                        line: 395,
                        column: 15
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 350,
                            column: 15
                        },
                        end: {
                            line: 350,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 350,
                            column: 29
                        },
                        end: {
                            line: 350,
                            column: 52
                        }
                    },
                    {
                        start: {
                            line: 351,
                            column: 16
                        },
                        end: {
                            line: 394,
                            column: 22
                        }
                    }
                ],
                line: 350
            },
            "50": {
                loc: {
                    start: {
                        line: 352,
                        column: 19
                    },
                    end: {
                        line: 379,
                        column: 19
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 353,
                            column: 20
                        },
                        end: {
                            line: 366,
                            column: 22
                        }
                    },
                    {
                        start: {
                            line: 368,
                            column: 20
                        },
                        end: {
                            line: 378,
                            column: 22
                        }
                    }
                ],
                line: 352
            },
            "51": {
                loc: {
                    start: {
                        line: 380,
                        column: 19
                    },
                    end: {
                        line: 393,
                        column: 19
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 380,
                            column: 19
                        },
                        end: {
                            line: 380,
                            column: 64
                        }
                    },
                    {
                        start: {
                            line: 381,
                            column: 20
                        },
                        end: {
                            line: 392,
                            column: 22
                        }
                    }
                ],
                line: 380
            },
            "52": {
                loc: {
                    start: {
                        line: 387,
                        column: 24
                    },
                    end: {
                        line: 389,
                        column: 25
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 387,
                            column: 24
                        },
                        end: {
                            line: 389,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 387
            },
            "53": {
                loc: {
                    start: {
                        line: 398,
                        column: 18
                    },
                    end: {
                        line: 398,
                        column: 64
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 398,
                            column: 51
                        },
                        end: {
                            line: 398,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 398,
                            column: 59
                        },
                        end: {
                            line: 398,
                            column: 64
                        }
                    }
                ],
                line: 398
            },
            "54": {
                loc: {
                    start: {
                        line: 400,
                        column: 30
                    },
                    end: {
                        line: 400,
                        column: 76
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 400,
                            column: 63
                        },
                        end: {
                            line: 400,
                            column: 69
                        }
                    },
                    {
                        start: {
                            line: 400,
                            column: 72
                        },
                        end: {
                            line: 400,
                            column: 76
                        }
                    }
                ],
                line: 400
            },
            "55": {
                loc: {
                    start: {
                        line: 403,
                        column: 30
                    },
                    end: {
                        line: 403,
                        column: 75
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 403,
                            column: 63
                        },
                        end: {
                            line: 403,
                            column: 68
                        }
                    },
                    {
                        start: {
                            line: 403,
                            column: 71
                        },
                        end: {
                            line: 403,
                            column: 75
                        }
                    }
                ],
                line: 403
            },
            "56": {
                loc: {
                    start: {
                        line: 406,
                        column: 15
                    },
                    end: {
                        line: 408,
                        column: 15
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 406,
                            column: 15
                        },
                        end: {
                            line: 406,
                            column: 45
                        }
                    },
                    {
                        start: {
                            line: 407,
                            column: 16
                        },
                        end: {
                            line: 407,
                            column: 69
                        }
                    }
                ],
                line: 406
            },
            "57": {
                loc: {
                    start: {
                        line: 426,
                        column: 9
                    },
                    end: {
                        line: 450,
                        column: 9
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 426,
                            column: 9
                        },
                        end: {
                            line: 426,
                            column: 30
                        }
                    },
                    {
                        start: {
                            line: 427,
                            column: 10
                        },
                        end: {
                            line: 449,
                            column: 16
                        }
                    }
                ],
                line: 426
            },
            "58": {
                loc: {
                    start: {
                        line: 451,
                        column: 9
                    },
                    end: {
                        line: 466,
                        column: 9
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 451,
                            column: 9
                        },
                        end: {
                            line: 451,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 452,
                            column: 10
                        },
                        end: {
                            line: 465,
                            column: 23
                        }
                    }
                ],
                line: 451
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0,
            "64": 0,
            "65": 0,
            "66": 0,
            "67": 0,
            "68": 0,
            "69": 0,
            "70": 0,
            "71": 0,
            "72": 0,
            "73": 0,
            "74": 0,
            "75": 0,
            "76": 0,
            "77": 0,
            "78": 0,
            "79": 0,
            "80": 0,
            "81": 0,
            "82": 0,
            "83": 0,
            "84": 0,
            "85": 0,
            "86": 0,
            "87": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0
            ],
            "15": [
                0,
                0
            ],
            "16": [
                0,
                0
            ],
            "17": [
                0,
                0
            ],
            "18": [
                0,
                0,
                0,
                0
            ],
            "19": [
                0,
                0
            ],
            "20": [
                0,
                0,
                0,
                0
            ],
            "21": [
                0,
                0
            ],
            "22": [
                0,
                0
            ],
            "23": [
                0,
                0
            ],
            "24": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "25": [
                0,
                0
            ],
            "26": [
                0,
                0
            ],
            "27": [
                0,
                0
            ],
            "28": [
                0,
                0
            ],
            "29": [
                0,
                0
            ],
            "30": [
                0,
                0
            ],
            "31": [
                0,
                0
            ],
            "32": [
                0,
                0
            ],
            "33": [
                0,
                0
            ],
            "34": [
                0,
                0
            ],
            "35": [
                0,
                0,
                0
            ],
            "36": [
                0,
                0,
                0
            ],
            "37": [
                0,
                0
            ],
            "38": [
                0,
                0
            ],
            "39": [
                0,
                0
            ],
            "40": [
                0,
                0
            ],
            "41": [
                0,
                0
            ],
            "42": [
                0,
                0
            ],
            "43": [
                0,
                0
            ],
            "44": [
                0,
                0
            ],
            "45": [
                0,
                0
            ],
            "46": [
                0,
                0
            ],
            "47": [
                0,
                0
            ],
            "48": [
                0,
                0
            ],
            "49": [
                0,
                0,
                0
            ],
            "50": [
                0,
                0
            ],
            "51": [
                0,
                0
            ],
            "52": [
                0,
                0
            ],
            "53": [
                0,
                0
            ],
            "54": [
                0,
                0
            ],
            "55": [
                0,
                0
            ],
            "56": [
                0,
                0
            ],
            "57": [
                0,
                0
            ],
            "58": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "68e8343927547e09a466dc1bbba4026ac232f0a8"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_eyrv5w61a = function cov_eyrv5w61a() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_eyrv5w61a();
function AccountPasswordForm_slicedToArray(r, e) {
    return AccountPasswordForm_arrayWithHoles(r) || AccountPasswordForm_iterableToArrayLimit(r, e) || AccountPasswordForm_unsupportedIterableToArray(r, e) || AccountPasswordForm_nonIterableRest();
}
function AccountPasswordForm_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AccountPasswordForm_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return AccountPasswordForm_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? AccountPasswordForm_arrayLikeToArray(r, a) : void 0;
    }
}
function AccountPasswordForm_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function AccountPasswordForm_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function AccountPasswordForm_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

























var AccountPasswordForm = (cov_eyrv5w61a().s[0]++, /*#__PURE__*/ (0,react.forwardRef)(function(_ref, ref) {
    var initialName = _ref.name, initialPhone = _ref.phone, onRegister = _ref.onRegister, onLogin = _ref.onLogin, hidePasswordField = _ref.hidePasswordField, isNewHuman = _ref.isNewHuman, onboardingAccountPageCTA = _ref.onboardingAccountPageCTA, passwordFormActionText = _ref.passwordFormActionText, analyticsName = _ref.analyticsName, fullNameLabel = _ref.fullNameLabel, fullNamePlaceholder = _ref.fullNamePlaceholder, loading = _ref.loading, loginError = _ref.loginError, _ref$phoneNumberInput = _ref.phoneNumberInputOptional, phoneNumberInputOptional = _ref$phoneNumberInput === void 0 ? (cov_eyrv5w61a().b[0][0]++, true) : _ref$phoneNumberInput, _ref$phoneNumberInput2 = _ref.phoneNumberInputHidden, phoneNumberInputHidden = _ref$phoneNumberInput2 === void 0 ? (cov_eyrv5w61a().b[1][0]++, false) : _ref$phoneNumberInput2, showPasswordlessLogin = _ref.showPasswordlessLogin, onRequestPasswordlessLogin = _ref.onRequestPasswordlessLogin, isRequestingPasswordlessLogin = _ref.isRequestingPasswordlessLogin, openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab, fullNameOptional = _ref.fullNameOptional, fullNameHidden = _ref.fullNameHidden, CustomPasswordInput = _ref.CustomPasswordInput, CustomNameInput = _ref.CustomNameInput, CustomPhoneInput = _ref.CustomPhoneInput;
    cov_eyrv5w61a().f[0]++;
    var context = (cov_eyrv5w61a().s[1]++, (0,react.useContext)(NamelessAccountContext));
    var _ref2 = (cov_eyrv5w61a().s[2]++, (0,react.useState)(false)), _ref3 = AccountPasswordForm_slicedToArray(_ref2, 2), hasError = _ref3[0], setHasError = _ref3[1];
    var _ref4 = (cov_eyrv5w61a().s[3]++, (0,react.useState)((cov_eyrv5w61a().b[2][0]++, initialName) || (cov_eyrv5w61a().b[2][1]++, ""))), _ref5 = AccountPasswordForm_slicedToArray(_ref4, 2), name = _ref5[0], setName = _ref5[1];
    var _ref6 = (cov_eyrv5w61a().s[4]++, (0,react.useState)(false)), _ref7 = AccountPasswordForm_slicedToArray(_ref6, 2), hasNameError = _ref7[0], setNameError = _ref7[1];
    var _ref8 = (cov_eyrv5w61a().s[5]++, (0,react.useState)(false)), _ref9 = AccountPasswordForm_slicedToArray(_ref8, 2), hasPasswordError = _ref9[0], setHasPasswordError = _ref9[1];
    var _ref0 = (cov_eyrv5w61a().s[6]++, (0,react.useState)((cov_eyrv5w61a().b[3][0]++, initialPhone) || (cov_eyrv5w61a().b[3][1]++, ""))), _ref1 = AccountPasswordForm_slicedToArray(_ref0, 2), phone = _ref1[0], setPhone = _ref1[1];
    var _ref10 = (cov_eyrv5w61a().s[7]++, (0,react.useState)(false)), _ref11 = AccountPasswordForm_slicedToArray(_ref10, 2), smsSubscribed = _ref11[0], setSmsSubscribed = _ref11[1];
    var _ref12 = (cov_eyrv5w61a().s[8]++, (0,react.useState)(!phoneNumberInputOptional)), _ref13 = AccountPasswordForm_slicedToArray(_ref12, 2), hasPhoneError = _ref13[0], setPhoneError = _ref13[1];
    var _ref14 = (cov_eyrv5w61a().s[9]++, (0,react.useState)("")), _ref15 = AccountPasswordForm_slicedToArray(_ref14, 2), password = _ref15[0], setPassword = _ref15[1];
    var _ref16 = (cov_eyrv5w61a().s[10]++, (0,react.useState)({})), _ref17 = AccountPasswordForm_slicedToArray(_ref16, 2), lastSubmit = _ref17[0], setLastSubmit = _ref17[1];
    var getPhoneState = (cov_eyrv5w61a().s[11]++, (0,react.useCallback)(function(phone) {
        cov_eyrv5w61a().f[1]++;
        cov_eyrv5w61a().s[12]++;
        if ((cov_eyrv5w61a().b[5][0]++, isNil_default()(phone)) || (cov_eyrv5w61a().b[5][1]++, phone === "")) {
            cov_eyrv5w61a().b[4][0]++;
            cov_eyrv5w61a().s[13]++;
            return {
                hasError: !phoneNumberInputOptional,
                value: phone
            };
        } else {
            cov_eyrv5w61a().b[4][1]++;
        }
        // ValidatedTextInput with format="telephoneNumber" will handle phone validation
        // This is just for initial state - actual validation happens in the component
        cov_eyrv5w61a().s[14]++;
        return {
            hasError: false,
            // Let ValidatedTextInput handle validation
            value: phone
        };
    }, [
        phoneNumberInputOptional
    ]));
    var maybePrefillAccount = (cov_eyrv5w61a().s[15]++, (0,react.useCallback)(function() {
        cov_eyrv5w61a().f[2]++;
        var url = (cov_eyrv5w61a().s[16]++, new URL(window.location.href));
        var params = (cov_eyrv5w61a().s[17]++, new URLSearchParams(url.searchParams));
        var phoneNumber = (cov_eyrv5w61a().s[18]++, (cov_eyrv5w61a().b[6][0]++, params.get("phoneNumber")) || (cov_eyrv5w61a().b[6][1]++, initialPhone));
        var _ref18 = (cov_eyrv5w61a().s[19]++, getPhoneState(phoneNumber)), value = _ref18.value, hasError = _ref18.hasError;
        cov_eyrv5w61a().s[20]++;
        if ((cov_eyrv5w61a().b[8][0]++, params.get("name")) || (cov_eyrv5w61a().b[8][1]++, params.get("phoneNumber"))) {
            cov_eyrv5w61a().b[7][0]++;
            cov_eyrv5w61a().s[21]++;
            setName(params.get("name"));
            cov_eyrv5w61a().s[22]++;
            setPhone(hasError ? (cov_eyrv5w61a().b[9][0]++, "") : (cov_eyrv5w61a().b[9][1]++, value));
            cov_eyrv5w61a().s[23]++;
            setPhoneError(hasError);
        } else {
            cov_eyrv5w61a().b[7][1]++;
        }
    }, [
        getPhoneState,
        initialPhone
    ]));
    cov_eyrv5w61a().s[24]++;
    (0,react.useEffect)(function() {
        cov_eyrv5w61a().f[3]++;
        cov_eyrv5w61a().s[25]++;
        maybePrefillAccount();
        cov_eyrv5w61a().s[26]++;
        if (context.onPasswordFormLoad) {
            cov_eyrv5w61a().b[10][0]++;
            cov_eyrv5w61a().s[27]++;
            context.onPasswordFormLoad();
        } else {
            cov_eyrv5w61a().b[10][1]++;
        }
    }, [
        context,
        maybePrefillAccount
    ]);
    cov_eyrv5w61a().s[28]++;
    var validatePasswordLength = function validatePasswordLength(password) {
        cov_eyrv5w61a().f[4]++;
        cov_eyrv5w61a().s[29]++;
        return (cov_eyrv5w61a().b[11][0]++, password.length >= 5) && (cov_eyrv5w61a().b[11][1]++, password.length <= 128);
    };
    cov_eyrv5w61a().s[30]++;
    var onNameChange = function onNameChange(name) {
        cov_eyrv5w61a().f[5]++;
        cov_eyrv5w61a().s[31]++;
        setName(name);
        var isNameEmpty = (cov_eyrv5w61a().s[32]++, (cov_eyrv5w61a().b[12][0]++, isNil_default()(name)) || (cov_eyrv5w61a().b[12][1]++, name === ""));
        var isNameValid = (cov_eyrv5w61a().s[33]++, name.trim() !== "");
        cov_eyrv5w61a().s[34]++;
        if (fullNameOptional) {
            cov_eyrv5w61a().b[13][0]++;
            cov_eyrv5w61a().s[35]++;
            setNameError(isNameEmpty ? (cov_eyrv5w61a().b[14][0]++, false) : (cov_eyrv5w61a().b[14][1]++, !isNameValid));
        } else {
            cov_eyrv5w61a().b[13][1]++;
            cov_eyrv5w61a().s[36]++;
            setNameError((cov_eyrv5w61a().b[15][0]++, isNameEmpty) || (cov_eyrv5w61a().b[15][1]++, !isNameValid));
        }
    };
    cov_eyrv5w61a().s[37]++;
    var onPhoneChange = function onPhoneChange(phone) {
        cov_eyrv5w61a().f[6]++;
        var _ref19 = (cov_eyrv5w61a().s[38]++, getPhoneState(phone)), value = _ref19.value, hasError = _ref19.hasError;
        cov_eyrv5w61a().s[39]++;
        setPhone(value);
        cov_eyrv5w61a().s[40]++;
        setPhoneError(hasError);
    };
    cov_eyrv5w61a().s[41]++;
    var handlePhoneValidationChange = function handlePhoneValidationChange(validity) {
        cov_eyrv5w61a().f[7]++;
        cov_eyrv5w61a().s[42]++;
        setPhoneError(validity !== "valid");
    };
    cov_eyrv5w61a().s[43]++;
    var onPasswordChange = function onPasswordChange(password) {
        cov_eyrv5w61a().f[8]++;
        cov_eyrv5w61a().s[44]++;
        //Password is validated only on blur
        setHasPasswordError(false);
        //This is to disable submit based on onchange validation
        cov_eyrv5w61a().s[45]++;
        setHasError((cov_eyrv5w61a().b[16][0]++, isNil_default()(password)) || (cov_eyrv5w61a().b[16][1]++, !validatePasswordLength(password)));
        cov_eyrv5w61a().s[46]++;
        setPassword(password);
    };
    cov_eyrv5w61a().s[47]++;
    var handleSubmit = function handleSubmit(e) {
        cov_eyrv5w61a().f[9]++;
        cov_eyrv5w61a().s[48]++;
        e.preventDefault();
        cov_eyrv5w61a().s[49]++;
        if ((cov_eyrv5w61a().b[18][0]++, hasError) || (cov_eyrv5w61a().b[18][1]++, isNewHuman) && ((cov_eyrv5w61a().b[18][2]++, hasNameError) || (cov_eyrv5w61a().b[18][3]++, hasPhoneError))) {
            cov_eyrv5w61a().b[17][0]++;
            cov_eyrv5w61a().s[50]++;
            return;
        } else {
            cov_eyrv5w61a().b[17][1]++;
        }
        cov_eyrv5w61a().s[51]++;
        if (// Only check to return early if there is a previous submission
        (cov_eyrv5w61a().b[20][0]++, Object.values(lastSubmit).filter(Boolean).length !== 0) && (cov_eyrv5w61a().b[20][1]++, name === lastSubmit.name) && (cov_eyrv5w61a().b[20][2]++, password === lastSubmit.password) && (cov_eyrv5w61a().b[20][3]++, phone === lastSubmit.phone)) {
            cov_eyrv5w61a().b[19][0]++;
            cov_eyrv5w61a().s[52]++;
            return;
        } else {
            cov_eyrv5w61a().b[19][1]++;
        }
        cov_eyrv5w61a().s[53]++;
        if (isNewHuman) {
            cov_eyrv5w61a().b[21][0]++;
            cov_eyrv5w61a().s[54]++;
            if ((cov_eyrv5w61a().b[23][0]++, context.shouldRegisterOnEmailSubmit) && (cov_eyrv5w61a().b[23][1]++, context.onAccountUpdate)) {
                cov_eyrv5w61a().b[22][0]++;
                cov_eyrv5w61a().s[55]++;
                context.onAccountUpdate(name, phone, smsSubscribed);
            } else {
                cov_eyrv5w61a().b[22][1]++;
                cov_eyrv5w61a().s[56]++;
                // Registering on pw page does not support SMS opt-out
                onRegister(password, name, phone);
            }
        } else {
            cov_eyrv5w61a().b[21][1]++;
            cov_eyrv5w61a().s[57]++;
            onLogin(password);
        }
        cov_eyrv5w61a().s[58]++;
        setLastSubmit({
            name: name,
            password: password,
            phone: phone
        });
    };
    var shouldDisableSubmit = (cov_eyrv5w61a().s[59]++, (cov_eyrv5w61a().b[24][0]++, hasError) || (cov_eyrv5w61a().b[24][1]++, !hidePasswordField) && ((cov_eyrv5w61a().b[24][2]++, !password) || (cov_eyrv5w61a().b[24][3]++, password.length === 0)) || (cov_eyrv5w61a().b[24][4]++, isNewHuman) && ((cov_eyrv5w61a().b[24][5]++, !fullNameOptional) && ((cov_eyrv5w61a().b[24][6]++, !name) || (cov_eyrv5w61a().b[24][7]++, hasNameError)) || (cov_eyrv5w61a().b[24][8]++, hasPhoneError)));
    var actionText = (cov_eyrv5w61a().s[60]++, "Confirm");
    cov_eyrv5w61a().s[61]++;
    if (phoneNumberInputHidden) {
        cov_eyrv5w61a().b[25][0]++;
        cov_eyrv5w61a().s[62]++;
        actionText = "Next";
    } else {
        cov_eyrv5w61a().b[25][1]++;
        cov_eyrv5w61a().s[63]++;
        if (onboardingAccountPageCTA) {
            cov_eyrv5w61a().b[26][0]++;
            cov_eyrv5w61a().s[64]++;
            actionText = "Continue";
        } else {
            cov_eyrv5w61a().b[26][1]++;
        }
    }
    cov_eyrv5w61a().s[65]++;
    if (passwordFormActionText) {
        cov_eyrv5w61a().b[27][0]++;
        cov_eyrv5w61a().s[66]++;
        actionText = passwordFormActionText;
    } else {
        cov_eyrv5w61a().b[27][1]++;
    }
    var hasPasswordRequirementError = (cov_eyrv5w61a().s[67]++, (cov_eyrv5w61a().b[28][0]++, hasPasswordError) && (cov_eyrv5w61a().b[28][1]++, isNewHuman)), showPasswordError = (cov_eyrv5w61a().s[68]++, (cov_eyrv5w61a().b[29][0]++, hasPasswordRequirementError) || (cov_eyrv5w61a().b[29][1]++, loginError)), passwordErrorText = (cov_eyrv5w61a().s[69]++, loginError ? (cov_eyrv5w61a().b[30][0]++, loginError) : (cov_eyrv5w61a().b[30][1]++, "Your password does not meet the requirements"));
    var shouldRenderDisclaimerAboveCTA = (cov_eyrv5w61a().s[70]++, (cov_eyrv5w61a().b[31][0]++, !phoneNumberInputHidden) && (cov_eyrv5w61a().b[31][1]++, isNewHuman));
    var shouldRenderDisclaimerBelowCTA = (cov_eyrv5w61a().s[71]++, !shouldRenderDisclaimerAboveCTA);
    cov_eyrv5w61a().s[72]++;
    (0,react.useEffect)(function() {
        cov_eyrv5w61a().f[10]++;
        cov_eyrv5w61a().s[73]++;
        if ((cov_eyrv5w61a().b[33][0]++, showPasswordError) && (cov_eyrv5w61a().b[33][1]++, passwordErrorText)) {
            cov_eyrv5w61a().b[32][0]++;
            cov_eyrv5w61a().s[74]++;
            if ((cov_eyrv5w61a().b[35][0]++, ref) && (cov_eyrv5w61a().b[35][1]++, "current" in ref) && (cov_eyrv5w61a().b[35][2]++, ref.current)) {
                cov_eyrv5w61a().b[34][0]++;
                cov_eyrv5w61a().s[75]++;
                ref.current.focus();
            } else {
                cov_eyrv5w61a().b[34][1]++;
            }
        } else {
            cov_eyrv5w61a().b[32][1]++;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showPasswordError,
        passwordErrorText
    ]);
    // Handlers for custom inputs (legacy format)
    cov_eyrv5w61a().s[76]++;
    var handleCustomNameChange = function handleCustomNameChange(_event, value, _valid) {
        cov_eyrv5w61a().f[11]++;
        cov_eyrv5w61a().s[77]++;
        onNameChange(value);
    };
    cov_eyrv5w61a().s[78]++;
    var handleCustomPhoneChange = function handleCustomPhoneChange(_event, value, _valid) {
        cov_eyrv5w61a().f[12]++;
        cov_eyrv5w61a().s[79]++;
        onPhoneChange(value);
    };
    cov_eyrv5w61a().s[80]++;
    var handleCustomPasswordChange = function handleCustomPasswordChange(_event, value, _valid) {
        cov_eyrv5w61a().f[13]++;
        cov_eyrv5w61a().s[81]++;
        onPasswordChange(value);
    };
    cov_eyrv5w61a().s[82]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, null, /*#__PURE__*/ react.createElement(shared/* Form */.l0, {
        onSubmitCapture: handleSubmit
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        marginBottom: "$20x"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$20x"
    }, (cov_eyrv5w61a().b[36][0]++, isNewHuman) && (cov_eyrv5w61a().b[36][1]++, !fullNameHidden) && (cov_eyrv5w61a().b[36][2]++, CustomNameInput ? (cov_eyrv5w61a().b[37][0]++, /*#__PURE__*/ react.createElement(CustomNameInput, {
        analyticsName: analyticsName,
        required: !fullNameOptional,
        unboundedWidth: false,
        value: name,
        onChange: handleCustomNameChange,
        delay: 500,
        label: fullNameLabel ? (cov_eyrv5w61a().b[38][0]++, fullNameLabel) : (cov_eyrv5w61a().b[38][1]++, "Full name"),
        type: "text",
        id: "name",
        name: "name",
        className: "od-register-name",
        placeholder: fullNamePlaceholder ? (cov_eyrv5w61a().b[39][0]++, fullNamePlaceholder) : (cov_eyrv5w61a().b[39][1]++, ""),
        errorMessage: hasNameError ? (cov_eyrv5w61a().b[40][0]++, "Please enter your full name.") : (cov_eyrv5w61a().b[40][1]++, undefined),
        autoComplete: "name",
        autoFocus: true
    })) : (cov_eyrv5w61a().b[37][1]++, /*#__PURE__*/ react.createElement(NameInput/* NameInput */.R, {
        analyticsName: analyticsName,
        autoComplete: "name",
        autoFocus: true,
        errorText: hasNameError ? (cov_eyrv5w61a().b[41][0]++, "Please enter your full name.") : (cov_eyrv5w61a().b[41][1]++, undefined),
        title: fullNameLabel ? (cov_eyrv5w61a().b[42][0]++, fullNameLabel) : (cov_eyrv5w61a().b[42][1]++, "Full name"),
        onChangeText: onNameChange,
        placeholder: fullNamePlaceholder ? (cov_eyrv5w61a().b[43][0]++, fullNamePlaceholder) : (cov_eyrv5w61a().b[43][1]++, ""),
        required: !fullNameOptional,
        prefilledValue: name,
        invalidNameError: "Please enter your full name.",
        size: "medium"
    }))), (cov_eyrv5w61a().b[44][0]++, !hidePasswordField) && (cov_eyrv5w61a().b[44][1]++, CustomPasswordInput ? (cov_eyrv5w61a().b[45][0]++, /*#__PURE__*/ react.createElement(CustomPasswordInput, {
        analyticsName: analyticsName,
        required: true,
        unboundedWidth: false,
        value: password,
        onChange: handleCustomPasswordChange,
        delay: 500,
        label: "Password",
        autoFocus: !isNewHuman,
        className: "od-register-password",
        errorMessage: showPasswordError ? (cov_eyrv5w61a().b[46][0]++, passwordErrorText) : (cov_eyrv5w61a().b[46][1]++, undefined),
        error: !!showPasswordError,
        id: "password",
        name: "password",
        placeholder: "",
        type: "password"
    })) : (cov_eyrv5w61a().b[45][1]++, /*#__PURE__*/ react.createElement(AccountPasswordInput/* AccountPasswordInput */.j, {
        analyticsName: analyticsName,
        autoFocus: !isNewHuman,
        supportText: "Your password must be 6 to 128 characters long",
        errorText: (cov_eyrv5w61a().b[47][0]++, showPasswordError) && (cov_eyrv5w61a().b[47][1]++, passwordErrorText),
        onBlur: function onBlur() {
            cov_eyrv5w61a().f[14]++;
            cov_eyrv5w61a().s[83]++;
            setHasPasswordError((cov_eyrv5w61a().b[48][0]++, password.length > 0) && (cov_eyrv5w61a().b[48][1]++, !validatePasswordLength(password)));
        },
        title: "Password",
        ref: ref,
        onChangeText: onPasswordChange,
        prefilledValue: password,
        size: "medium"
    }))), (cov_eyrv5w61a().b[49][0]++, isNewHuman) && (cov_eyrv5w61a().b[49][1]++, !phoneNumberInputHidden) && (cov_eyrv5w61a().b[49][2]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$5x"
    }, CustomPhoneInput ? (cov_eyrv5w61a().b[50][0]++, /*#__PURE__*/ react.createElement(CustomPhoneInput, {
        analyticsName: analyticsName,
        required: !phoneNumberInputOptional,
        unboundedWidth: false,
        value: phone,
        onChange: handleCustomPhoneChange,
        delay: 500,
        label: "Phone number",
        type: "tel",
        id: "phone",
        className: "od-register-phone",
        name: "phone",
        autoComplete: "tel"
    })) : (cov_eyrv5w61a().b[50][1]++, /*#__PURE__*/ react.createElement(PhoneInput/* PhoneInput */.s, {
        analyticsName: analyticsName,
        title: "Phone number",
        onChangeText: function onChangeText(value) {
            cov_eyrv5w61a().f[15]++;
            cov_eyrv5w61a().s[84]++;
            return setPhone(value);
        },
        onValidationChange: handlePhoneValidationChange,
        required: !phoneNumberInputOptional,
        prefilledValue: phone,
        invalidPhoneError: "Please enter a valid phone number",
        fieldRequiredError: "This field is required",
        size: "medium"
    })), (cov_eyrv5w61a().b[51][0]++, analyticsName === "reception-fe-account-form") && (cov_eyrv5w61a().b[51][1]++, /*#__PURE__*/ react.createElement(SimpleCheckbox/* SimpleCheckbox */.A, {
        size: "xsmall",
        label: shared/* MARKETING_SMS_CONSENT.checkboxLabel */.$B.checkboxLabel,
        value: "value",
        analyticsName: "".concat(analyticsName, "-sms-checkbox"),
        onPress: function onPress(_, checked) {
            cov_eyrv5w61a().f[16]++;
            cov_eyrv5w61a().s[85]++;
            if (typeof checked === "boolean") {
                cov_eyrv5w61a().b[52][0]++;
                cov_eyrv5w61a().s[86]++;
                setSmsSubscribed(checked);
            } else {
                cov_eyrv5w61a().b[52][1]++;
            }
        },
        name: "marketing-opt-in"
    }))))), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        mt: shouldRenderDisclaimerAboveCTA ? (cov_eyrv5w61a().b[53][0]++, "$0x") : (cov_eyrv5w61a().b[53][1]++, "$4x"),
        $largerThanSM: {
            marginBottom: shouldRenderDisclaimerAboveCTA ? (cov_eyrv5w61a().b[54][0]++, "$10x") : (cov_eyrv5w61a().b[54][1]++, null)
        },
        $smallerThanMD: {
            marginBottom: shouldRenderDisclaimerAboveCTA ? (cov_eyrv5w61a().b[55][0]++, "$5x") : (cov_eyrv5w61a().b[55][1]++, null)
        }
    }, (cov_eyrv5w61a().b[56][0]++, shouldRenderDisclaimerAboveCTA) && (cov_eyrv5w61a().b[56][1]++, /*#__PURE__*/ react.createElement(shared/* EmailDisclaimerText */.lX, {
        analyticsName: analyticsName
    }))), /*#__PURE__*/ react.createElement(AccountFormControls/* AccountFormControls */.W, {
        actionText: actionText,
        analyticsName: analyticsName,
        loading: loading,
        showForgotPassword: !isNewHuman,
        onRequestPasswordlessLogin: onRequestPasswordlessLogin,
        isRequestingPasswordlessLogin: isRequestingPasswordlessLogin,
        disabled: shouldDisableSubmit,
        submitA11yProps: {
            "aria-label": ""
        },
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        forgotPasswordText: "Forgot your password?",
        forgotPasswordAriaNewWindow: "Opens a new window with the forgot password page",
        forgotPasswordAriaSameWindow: "Opens the forgot password page"
    }))), (cov_eyrv5w61a().b[57][0]++, showPasswordlessLogin) && (cov_eyrv5w61a().b[57][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        "data-testid": "passwordless-login",
        paddingTop: "$20x",
        marginBottom: "$20x",
        borderTopWidth: 1,
        borderTopColor: "$borderPrimary"
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$subheaderSmall",
        tag: "h3",
        paddingBottom: "$10x",
        textAlign: "left"
    }, "Tired of resetting your password?"), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$bodySmall",
        tag: "h3",
        textAlign: "left",
        paddingBottom: "$20x"
    }, "We can email you a link that will simply log you into your account."), /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        variant: "secondary",
        loading: isRequestingPasswordlessLogin,
        analyticsName: "".concat(analyticsName, "-email-login-link"),
        "aria-label": null,
        onPress: onRequestPasswordlessLogin,
        size: "medium",
        label: "Email login link"
    }))), (cov_eyrv5w61a().b[58][0]++, shouldRenderDisclaimerBelowCTA) && (cov_eyrv5w61a().b[58][1]++, /*#__PURE__*/ react.createElement(shared/* Disclaimer */.em, {
        mt: 5
    }, "Your information is protected by our\xa0", /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: "https://www.opendoor.com/w/privacy",
        target: "_blank",
        analyticsName: "".concat(analyticsName, "-privacy-policy"),
        "aria-label": "Opens a new page with Opendoor’s privacy policy",
        typography: "$bodyXsmall"
    }, "Privacy Policy"), ".", /*#__PURE__*/ react.createElement("br", null), /*#__PURE__*/ react.createElement("br", null))));
}));
cov_eyrv5w61a().s[87]++;
AccountPasswordForm.displayName = "AccountPasswordForm";
/* harmony default export */ var auth_AccountPasswordForm = (AccountPasswordForm); //# sourceMappingURL=AccountPasswordForm.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/CheckEmailForm.mjs
var CheckEmailForm = __webpack_require__(21250);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/ErrorPrompt.mjs
function cov_nbfgu5r1t() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/ErrorPrompt.tsx";
    var hash = "6408afa0da30a13f2048226e6da77b393380a648";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/ErrorPrompt.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 12,
                    column: 55
                },
                end: {
                    line: 24,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 13,
                    column: 2
                },
                end: {
                    line: 23,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 12,
                        column: 55
                    },
                    end: {
                        line: 12,
                        column: 56
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 72
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 12
            }
        },
        branchMap: {},
        s: {
            "0": 0,
            "1": 0
        },
        f: {
            "0": 0
        },
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "6408afa0da30a13f2048226e6da77b393380a648"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_nbfgu5r1t = function cov_nbfgu5r1t() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_nbfgu5r1t();


/**
 * Custom ErrorPrompt component to replace legacy Bricks ErrorPrompt
 */ cov_nbfgu5r1t().s[0]++;
var ErrorPrompt = function ErrorPrompt(_ref) {
    var message = _ref.message;
    cov_nbfgu5r1t().f[0]++;
    cov_nbfgu5r1t().s[1]++;
    return /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        "data-testid": "error-prompt",
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateErrorDefault",
        marginTop: "$1dot5x"
    }, message);
}; //# sourceMappingURL=ErrorPrompt.mjs.map

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.pad-end.js
var es_string_pad_end = __webpack_require__(66528);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(9924);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/iconCompatibility.js
var iconCompatibility = __webpack_require__(31944);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__(72443);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__(39341);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reverse.js
var es_array_reverse = __webpack_require__(65069);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__(73706);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__(10408);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
;// CONCATENATED MODULE: ./node_modules/@opendoor/shared-fe/es/googleOneTap.mjs
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




















/**
 * API Reference: https://developers.google.com/identity/gsi/web/reference/js-reference#CredentialResponse
 */

/**
 * Guide: https://developers.google.com/identity/gsi/web/guides/receive-notifications-prompt-ui-status
 * API Reference: https://developers.google.com/identity/gsi/web/reference/js-reference#PromptMomentNotification
 */

/**
 * OAuth2 Token Response from popup flow
 * API Reference: https://developers.google.com/identity/oauth2/web/reference/js-reference#TokenResponse
 */

/**
 * OAuth2 Token Client for popup flow
 * API Reference: https://developers.google.com/identity/oauth2/web/reference/js-reference#TokenClient
 */

/**
 * Button configuration for renderButton()
 * API Reference: https://developers.google.com/identity/gsi/web/reference/js-reference#GsiButtonConfiguration
 */

/**
 * Guide: https://developers.google.com/identity/gsi/web/guides/use-one-tap-js-api
 * API Reference: https://developers.google.com/identity/gsi/web/reference/js-reference
 *
 * use_fedcm_for_prompt: Allow the browser to control user sign-in prompts and mediate the sign-in flow between your website and Google.
 * https://developers.google.com/identity/gsi/web/reference/js-reference#use_fedcm_for_prompt
 */

var googleOneTapPromise;
function loadGoogleOneTap() {
  if (!googleOneTapPromise) {
    googleOneTapPromise = new Promise(function (resolve) {
      if (typeof window === 'undefined') {
        return undefined;
      }

      // eslint-disable-next-line no-var
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.src = ('https:' === document.location.protocol ? 'https://' : 'http://') + 'accounts.google.com/gsi/client';
      script.onload = function () {
        var _google$accounts, _google$accounts$id;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var google = window.google;
        if (google !== null && google !== void 0 && (_google$accounts = google.accounts) !== null && _google$accounts !== void 0 && (_google$accounts = _google$accounts.id) !== null && _google$accounts !== void 0 && _google$accounts.initialize && google !== null && google !== void 0 && (_google$accounts$id = google.accounts.id) !== null && _google$accounts$id !== void 0 && _google$accounts$id.prompt) {
          resolve(google);
        } else {
          resolve(undefined);
        }
      };
      script.onerror = function () {
        return resolve(undefined);
      };

      // Insert our script next to the first script element.
      // eslint-disable-next-line no-var
      var first = document.getElementsByTagName('script')[0];
      // @ts-expect-error fix later
      first.parentNode.insertBefore(script, first);
    });
  }
  return googleOneTapPromise;
}

/** Helper to add google-one-tap tracking actions to your app's tracking actions */

/** Helper to add google-one-tap category to your app's tracking categories */

function promptGoogleOneTap(_x) {
  return _promptGoogleOneTap.apply(this, arguments);
}
function _promptGoogleOneTap() {
  _promptGoogleOneTap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var analyticsName, clientId, onSuccess, onPrompted, onDismissed, onSkipped, trackEvent, trackError, google, _reason;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          analyticsName = _ref.analyticsName, clientId = _ref.clientId, onSuccess = _ref.onSuccess, onPrompted = _ref.onPrompted, onDismissed = _ref.onDismissed, onSkipped = _ref.onSkipped, trackEvent = _ref.trackEvent, trackError = _ref.trackError;
          _context.next = 3;
          return loadGoogleOneTap();
        case 3:
          google = _context.sent;
          if (google) {
            google.accounts.id.initialize({
              client_id: clientId,
              callback: function callback(response) {
                trackEvent('google-one-tap-success', analyticsName, undefined, {
                  categoryOverride: 'login'
                });
                onSuccess(response);
              },
              use_fedcm_for_prompt: true
            });
            google.accounts.id.prompt(function (n) {
              var momentType = n.getMomentType();
              if (momentType === 'display') {
                trackEvent('google-one-tap-displayed', analyticsName, undefined, {
                  categoryOverride: 'login'
                });
                onPrompted && onPrompted(true, undefined);
              } else if (n.isDismissedMoment()) {
                trackEvent('google-one-tap-dismissed', analyticsName, {
                  reason: n.getDismissedReason()
                }, {
                  categoryOverride: 'login'
                });
                onDismissed && onDismissed(n.getDismissedReason());
              } else if (n.isSkippedMoment()) {
                trackEvent('google-one-tap-skipped', analyticsName, undefined, {
                  categoryOverride: 'login'
                });
                onSkipped && onSkipped();
              } else {
                // google one-tap could not be displayed for multiple reasons now that FedCM is enabled (users can disable one-tap from the browser settings, etc.)
                // we can not get the exact reason due to privacy restrictions but we can still track when this is not displayed
                trackError('google-one-tap', new Error('google one tap not displayed'), {
                  reason: 'unknown'
                }, {
                  skipSentry: true
                });
                trackEvent('google-one-tap-not-displayed', analyticsName, {
                  reason: 'unknown'
                }, {
                  categoryOverride: 'login'
                });
                onPrompted && onPrompted(false, undefined);
              }
            });
          } else {
            _reason = 'script_load_failed';
            trackError('google-one-tap', new Error('google one tap not displayed'), {
              reason: _reason
            }, {
              skipSentry: true
            });
            trackEvent('google-one-tap-not-displayed', analyticsName, {
              reason: _reason
            }, {
              categoryOverride: 'login'
            });
            onPrompted && onPrompted(false, 'script_load_failed');
          }
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _promptGoogleOneTap.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/globals.mjs + 2 modules
var globals = __webpack_require__(47254);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(82110);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/GoogleIcon.mjs

function cov_2f2p72lihq() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/GoogleIcon.tsx";
    var hash = "cd9cada0d16301972bb553402facbb6c8d9f7b33";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/GoogleIcon.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 6,
                    column: 26
                },
                end: {
                    line: 146,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 8,
                    column: 25
                },
                end: {
                    line: 114,
                    column: 3
                }
            },
            "2": {
                start: {
                    line: 115,
                    column: 2
                },
                end: {
                    line: 145,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 6,
                        column: 26
                    },
                    end: {
                        line: 6,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 58
                    },
                    end: {
                        line: 146,
                        column: 1
                    }
                },
                line: 6
            }
        },
        branchMap: {},
        s: {
            "0": 0,
            "1": 0,
            "2": 0
        },
        f: {
            "0": 0
        },
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "cd9cada0d16301972bb553402facbb6c8d9f7b33"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2f2p72lihq = function cov_2f2p72lihq() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2f2p72lihq();
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


cov_2f2p72lihq().s[0]++;
var GoogleIcon = function GoogleIcon(_ref) {
    var size = _ref.size;
    cov_2f2p72lihq().f[0]++;
    // eslint-disable-next-line no-restricted-syntax
    var StyleContainer = (cov_2f2p72lihq().s[1]++, /*#__PURE__*/ (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
        target: "ea8fo1m0"
    } : 0)( true ? {
        name: "1vwy214",
        styles: ".gsi-material-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;-webkit-appearance:none;background-color:WHITE;background-image:none;border:1px solid #747775;-webkit-border-radius:4px;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;color:#1f1f1f;cursor:pointer;font-family:'Roboto',arial,sans-serif;font-size:14px;height:40px;letter-spacing:0.25px;outline:none;overflow:hidden;padding:0;position:relative;text-align:center;-webkit-transition:background-color 0.218s,border-color 0.218s,box-shadow 0.218s;transition:background-color 0.218s,border-color 0.218s,box-shadow 0.218s;vertical-align:middle;white-space:nowrap;width:40px;max-width:400px;min-width:min-content;}.gsi-material-button .gsi-material-button-icon{height:20px;margin-right:12px;min-width:20px;width:20px;margin:0;padding:9px;}.gsi-material-button .gsi-material-button-content-wrapper{-webkit-align-items:center;align-items:center;display:flex;-webkit-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;flex-wrap:nowrap;height:100%;justify-content:space-between;position:relative;width:100%;}.gsi-material-button .gsi-material-button-contents{-webkit-flex-grow:1;flex-grow:1;font-family:'Roboto',arial,sans-serif;font-weight:500;overflow:hidden;text-overflow:ellipsis;vertical-align:top;}.gsi-material-button .gsi-material-button-state{-webkit-transition:opacity 0.218s;transition:opacity 0.218s;bottom:0;left:0;opacity:0;position:absolute;right:0;top:0;}.gsi-material-button:disabled{cursor:default;background-color:#ffffff61;border-color:#1f1f1f1f;}.gsi-material-button:disabled .gsi-material-button-contents{opacity:38%;}.gsi-material-button:disabled .gsi-material-button-icon{opacity:38%;}.gsi-material-button:not(:disabled):active .gsi-material-button-state,.gsi-material-button:not(:disabled):focus .gsi-material-button-state{background-color:#303030;opacity:12%;}.gsi-material-button:not(:disabled):hover{-webkit-box-shadow:0 1px 2px 0 rgba(60, 64, 67, 0.3),0 1px 3px 1px rgba(60, 64, 67, 0.15);box-shadow:0 1px 2px 0 rgba(60, 64, 67, 0.3),0 1px 3px 1px rgba(60, 64, 67, 0.15);}.gsi-material-button:not(:disabled):hover .gsi-material-button-state{background-color:#303030;opacity:8%;}"
    } : 0));
    cov_2f2p72lihq().s[2]++;
    return /*#__PURE__*/ react.createElement(StyleContainer, null, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: "gsi-material-button-icon",
        height: size,
        width: size
    }, /*#__PURE__*/ react.createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            display: "block"
        }
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#EA4335",
        d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#4285F4",
        d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FBBC05",
        d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#34A853",
        d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "none",
        d: "M0 0h48v48H0z"
    }))));
}; //# sourceMappingURL=GoogleIcon.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/GoogleAuth.mjs

function cov_nh0p95hh3() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx";
    var hash = "57b6d3374e4ff3535e65b1efaea97b8b2c45e534";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 11,
                    column: 19
                },
                end: {
                    line: 11,
                    column: 51
                }
            },
            "1": {
                start: {
                    line: 18,
                    column: 23
                },
                end: {
                    line: 18,
                    column: 86
                }
            },
            "2": {
                start: {
                    line: 65,
                    column: 2
                },
                end: {
                    line: 78,
                    column: 3
                }
            },
            "3": {
                start: {
                    line: 66,
                    column: 22
                },
                end: {
                    line: 66,
                    column: 41
                }
            },
            "4": {
                start: {
                    line: 67,
                    column: 19
                },
                end: {
                    line: 67,
                    column: 66
                }
            },
            "5": {
                start: {
                    line: 68,
                    column: 19
                },
                end: {
                    line: 68,
                    column: 86
                }
            },
            "6": {
                start: {
                    line: 69,
                    column: 24
                },
                end: {
                    line: 74,
                    column: 5
                }
            },
            "7": {
                start: {
                    line: 72,
                    column: 20
                },
                end: {
                    line: 72,
                    column: 73
                }
            },
            "8": {
                start: {
                    line: 75,
                    column: 4
                },
                end: {
                    line: 75,
                    column: 35
                }
            },
            "9": {
                start: {
                    line: 77,
                    column: 4
                },
                end: {
                    line: 77,
                    column: 14
                }
            },
            "10": {
                start: {
                    line: 80,
                    column: 28
                },
                end: {
                    line: 84,
                    column: 1
                }
            },
            "11": {
                start: {
                    line: 81,
                    column: 2
                },
                end: {
                    line: 83,
                    column: 3
                }
            },
            "12": {
                start: {
                    line: 82,
                    column: 4
                },
                end: {
                    line: 82,
                    column: 9
                }
            },
            "13": {
                start: {
                    line: 94,
                    column: 44
                },
                end: {
                    line: 375,
                    column: 1
                }
            },
            "14": {
                start: {
                    line: 101,
                    column: 44
                },
                end: {
                    line: 101,
                    column: 86
                }
            },
            "15": {
                start: {
                    line: 102,
                    column: 42
                },
                end: {
                    line: 102,
                    column: 54
                }
            },
            "16": {
                start: {
                    line: 103,
                    column: 36
                },
                end: {
                    line: 103,
                    column: 51
                }
            },
            "17": {
                start: {
                    line: 104,
                    column: 44
                },
                end: {
                    line: 104,
                    column: 59
                }
            },
            "18": {
                start: {
                    line: 105,
                    column: 34
                },
                end: {
                    line: 105,
                    column: 58
                }
            },
            "19": {
                start: {
                    line: 106,
                    column: 48
                },
                end: {
                    line: 106,
                    column: 82
                }
            },
            "20": {
                start: {
                    line: 107,
                    column: 20
                },
                end: {
                    line: 107,
                    column: 63
                }
            },
            "21": {
                start: {
                    line: 108,
                    column: 37
                },
                end: {
                    line: 108,
                    column: 55
                }
            },
            "22": {
                start: {
                    line: 109,
                    column: 24
                },
                end: {
                    line: 109,
                    column: 42
                }
            },
            "23": {
                start: {
                    line: 110,
                    column: 24
                },
                end: {
                    line: 110,
                    column: 42
                }
            },
            "24": {
                start: {
                    line: 111,
                    column: 31
                },
                end: {
                    line: 111,
                    column: 44
                }
            },
            "25": {
                start: {
                    line: 112,
                    column: 22
                },
                end: {
                    line: 112,
                    column: 38
                }
            },
            "26": {
                start: {
                    line: 113,
                    column: 2
                },
                end: {
                    line: 113,
                    column: 37
                }
            },
            "27": {
                start: {
                    line: 114,
                    column: 2
                },
                end: {
                    line: 114,
                    column: 37
                }
            },
            "28": {
                start: {
                    line: 115,
                    column: 2
                },
                end: {
                    line: 115,
                    column: 33
                }
            },
            "29": {
                start: {
                    line: 117,
                    column: 29
                },
                end: {
                    line: 119,
                    column: 8
                }
            },
            "30": {
                start: {
                    line: 118,
                    column: 4
                },
                end: {
                    line: 118,
                    column: 29
                }
            },
            "31": {
                start: {
                    line: 121,
                    column: 25
                },
                end: {
                    line: 203,
                    column: 26
                }
            },
            "32": {
                start: {
                    line: 122,
                    column: 4
                },
                end: {
                    line: 202,
                    column: 5
                }
            },
            "33": {
                start: {
                    line: 124,
                    column: 6
                },
                end: {
                    line: 124,
                    column: 58
                }
            },
            "34": {
                start: {
                    line: 126,
                    column: 21
                },
                end: {
                    line: 126,
                    column: 45
                }
            },
            "35": {
                start: {
                    line: 128,
                    column: 6
                },
                end: {
                    line: 138,
                    column: 7
                }
            },
            "36": {
                start: {
                    line: 129,
                    column: 8
                },
                end: {
                    line: 129,
                    column: 44
                }
            },
            "37": {
                start: {
                    line: 130,
                    column: 8
                },
                end: {
                    line: 137,
                    column: 10
                }
            },
            "38": {
                start: {
                    line: 131,
                    column: 10
                },
                end: {
                    line: 136,
                    column: 11
                }
            },
            "39": {
                start: {
                    line: 140,
                    column: 6
                },
                end: {
                    line: 156,
                    column: 7
                }
            },
            "40": {
                start: {
                    line: 141,
                    column: 25
                },
                end: {
                    line: 141,
                    column: 94
                }
            },
            "41": {
                start: {
                    line: 142,
                    column: 8
                },
                end: {
                    line: 142,
                    column: 34
                }
            },
            "42": {
                start: {
                    line: 143,
                    column: 8
                },
                end: {
                    line: 146,
                    column: 11
                }
            },
            "43": {
                start: {
                    line: 147,
                    column: 8
                },
                end: {
                    line: 154,
                    column: 10
                }
            },
            "44": {
                start: {
                    line: 148,
                    column: 10
                },
                end: {
                    line: 153,
                    column: 11
                }
            },
            "45": {
                start: {
                    line: 155,
                    column: 8
                },
                end: {
                    line: 155,
                    column: 15
                }
            },
            "46": {
                start: {
                    line: 158,
                    column: 6
                },
                end: {
                    line: 187,
                    column: 9
                }
            },
            "47": {
                start: {
                    line: 161,
                    column: 10
                },
                end: {
                    line: 161,
                    column: 30
                }
            },
            "48": {
                start: {
                    line: 162,
                    column: 10
                },
                end: {
                    line: 162,
                    column: 30
                }
            },
            "49": {
                start: {
                    line: 163,
                    column: 10
                },
                end: {
                    line: 163,
                    column: 33
                }
            },
            "50": {
                start: {
                    line: 165,
                    column: 26
                },
                end: {
                    line: 165,
                    column: 63
                }
            },
            "51": {
                start: {
                    line: 167,
                    column: 10
                },
                end: {
                    line: 174,
                    column: 12
                }
            },
            "52": {
                start: {
                    line: 168,
                    column: 12
                },
                end: {
                    line: 173,
                    column: 13
                }
            },
            "53": {
                start: {
                    line: 176,
                    column: 10
                },
                end: {
                    line: 184,
                    column: 13
                }
            },
            "54": {
                start: {
                    line: 189,
                    column: 6
                },
                end: {
                    line: 189,
                    column: 33
                }
            },
            "55": {
                start: {
                    line: 190,
                    column: 6
                },
                end: {
                    line: 190,
                    column: 29
                }
            },
            "56": {
                start: {
                    line: 192,
                    column: 23
                },
                end: {
                    line: 192,
                    column: 92
                }
            },
            "57": {
                start: {
                    line: 193,
                    column: 6
                },
                end: {
                    line: 193,
                    column: 32
                }
            },
            "58": {
                start: {
                    line: 194,
                    column: 6
                },
                end: {
                    line: 194,
                    column: 98
                }
            },
            "59": {
                start: {
                    line: 195,
                    column: 6
                },
                end: {
                    line: 201,
                    column: 8
                }
            },
            "60": {
                start: {
                    line: 196,
                    column: 8
                },
                end: {
                    line: 200,
                    column: 9
                }
            },
            "61": {
                start: {
                    line: 206,
                    column: 2
                },
                end: {
                    line: 208,
                    column: 23
                }
            },
            "62": {
                start: {
                    line: 207,
                    column: 4
                },
                end: {
                    line: 207,
                    column: 21
                }
            },
            "63": {
                start: {
                    line: 211,
                    column: 2
                },
                end: {
                    line: 252,
                    column: 61
                }
            },
            "64": {
                start: {
                    line: 212,
                    column: 4
                },
                end: {
                    line: 251,
                    column: 5
                }
            },
            "65": {
                start: {
                    line: 214,
                    column: 18
                },
                end: {
                    line: 231,
                    column: 7
                }
            },
            "66": {
                start: {
                    line: 232,
                    column: 6
                },
                end: {
                    line: 250,
                    column: 7
                }
            },
            "67": {
                start: {
                    line: 233,
                    column: 8
                },
                end: {
                    line: 241,
                    column: 11
                }
            },
            "68": {
                start: {
                    line: 243,
                    column: 8
                },
                end: {
                    line: 249,
                    column: 10
                }
            },
            "69": {
                start: {
                    line: 244,
                    column: 10
                },
                end: {
                    line: 248,
                    column: 11
                }
            },
            "70": {
                start: {
                    line: 254,
                    column: 22
                },
                end: {
                    line: 315,
                    column: 8
                }
            },
            "71": {
                start: {
                    line: 255,
                    column: 4
                },
                end: {
                    line: 265,
                    column: 5
                }
            },
            "72": {
                start: {
                    line: 256,
                    column: 23
                },
                end: {
                    line: 256,
                    column: 92
                }
            },
            "73": {
                start: {
                    line: 257,
                    column: 6
                },
                end: {
                    line: 257,
                    column: 32
                }
            },
            "74": {
                start: {
                    line: 258,
                    column: 6
                },
                end: {
                    line: 258,
                    column: 91
                }
            },
            "75": {
                start: {
                    line: 259,
                    column: 6
                },
                end: {
                    line: 263,
                    column: 8
                }
            },
            "76": {
                start: {
                    line: 260,
                    column: 8
                },
                end: {
                    line: 262,
                    column: 10
                }
            },
            "77": {
                start: {
                    line: 264,
                    column: 6
                },
                end: {
                    line: 264,
                    column: 13
                }
            },
            "78": {
                start: {
                    line: 267,
                    column: 4
                },
                end: {
                    line: 267,
                    column: 23
                }
            },
            "79": {
                start: {
                    line: 268,
                    column: 4
                },
                end: {
                    line: 268,
                    column: 24
                }
            },
            "80": {
                start: {
                    line: 269,
                    column: 4
                },
                end: {
                    line: 269,
                    column: 27
                }
            },
            "81": {
                start: {
                    line: 271,
                    column: 4
                },
                end: {
                    line: 314,
                    column: 5
                }
            },
            "82": {
                start: {
                    line: 272,
                    column: 6
                },
                end: {
                    line: 301,
                    column: 9
                }
            },
            "83": {
                start: {
                    line: 274,
                    column: 18
                },
                end: {
                    line: 278,
                    column: 9
                }
            },
            "84": {
                start: {
                    line: 280,
                    column: 8
                },
                end: {
                    line: 300,
                    column: 9
                }
            },
            "85": {
                start: {
                    line: 284,
                    column: 10
                },
                end: {
                    line: 284,
                    column: 29
                }
            },
            "86": {
                start: {
                    line: 285,
                    column: 10
                },
                end: {
                    line: 285,
                    column: 30
                }
            },
            "87": {
                start: {
                    line: 287,
                    column: 25
                },
                end: {
                    line: 287,
                    column: 99
                }
            },
            "88": {
                start: {
                    line: 289,
                    column: 10
                },
                end: {
                    line: 296,
                    column: 12
                }
            },
            "89": {
                start: {
                    line: 290,
                    column: 12
                },
                end: {
                    line: 295,
                    column: 13
                }
            },
            "90": {
                start: {
                    line: 299,
                    column: 10
                },
                end: {
                    line: 299,
                    column: 30
                }
            },
            "91": {
                start: {
                    line: 303,
                    column: 6
                },
                end: {
                    line: 303,
                    column: 26
                }
            },
            "92": {
                start: {
                    line: 304,
                    column: 23
                },
                end: {
                    line: 304,
                    column: 92
                }
            },
            "93": {
                start: {
                    line: 305,
                    column: 6
                },
                end: {
                    line: 305,
                    column: 32
                }
            },
            "94": {
                start: {
                    line: 306,
                    column: 6
                },
                end: {
                    line: 306,
                    column: 93
                }
            },
            "95": {
                start: {
                    line: 307,
                    column: 6
                },
                end: {
                    line: 313,
                    column: 8
                }
            },
            "96": {
                start: {
                    line: 308,
                    column: 8
                },
                end: {
                    line: 312,
                    column: 9
                }
            },
            "97": {
                start: {
                    line: 317,
                    column: 19
                },
                end: {
                    line: 317,
                    column: 78
                }
            },
            "98": {
                start: {
                    line: 318,
                    column: 23
                },
                end: {
                    line: 318,
                    column: 55
                }
            },
            "99": {
                start: {
                    line: 320,
                    column: 4
                },
                end: {
                    line: 320,
                    column: 93
                }
            },
            "100": {
                start: {
                    line: 322,
                    column: 2
                },
                end: {
                    line: 374,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "decodeJwtPayload",
                decl: {
                    start: {
                        line: 64,
                        column: 9
                    },
                    end: {
                        line: 64,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 76
                    },
                    end: {
                        line: 79,
                        column: 1
                    }
                },
                line: 64
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 72,
                        column: 13
                    },
                    end: {
                        line: 72,
                        column: 14
                    }
                },
                loc: {
                    start: {
                        line: 72,
                        column: 20
                    },
                    end: {
                        line: 72,
                        column: 73
                    }
                },
                line: 72
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 80,
                        column: 28
                    },
                    end: {
                        line: 80,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 80,
                        column: 48
                    },
                    end: {
                        line: 84,
                        column: 1
                    }
                },
                line: 80
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 94,
                        column: 44
                    },
                    end: {
                        line: 94,
                        column: 45
                    }
                },
                loc: {
                    start: {
                        line: 100,
                        column: 6
                    },
                    end: {
                        line: 375,
                        column: 1
                    }
                },
                line: 100
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 117,
                        column: 41
                    },
                    end: {
                        line: 117,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 117,
                        column: 71
                    },
                    end: {
                        line: 119,
                        column: 3
                    }
                },
                line: 117
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 121,
                        column: 37
                    },
                    end: {
                        line: 121,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 121,
                        column: 49
                    },
                    end: {
                        line: 203,
                        column: 3
                    }
                },
                line: 121
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 130,
                        column: 28
                    },
                    end: {
                        line: 130,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 131,
                        column: 10
                    },
                    end: {
                        line: 136,
                        column: 11
                    }
                },
                line: 131
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 147,
                        column: 28
                    },
                    end: {
                        line: 147,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 148,
                        column: 10
                    },
                    end: {
                        line: 153,
                        column: 11
                    }
                },
                line: 148
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 160,
                        column: 18
                    },
                    end: {
                        line: 160,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 160,
                        column: 32
                    },
                    end: {
                        line: 185,
                        column: 9
                    }
                },
                line: 160
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 167,
                        column: 30
                    },
                    end: {
                        line: 167,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 168,
                        column: 12
                    },
                    end: {
                        line: 173,
                        column: 13
                    }
                },
                line: 168
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 195,
                        column: 26
                    },
                    end: {
                        line: 195,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 196,
                        column: 8
                    },
                    end: {
                        line: 200,
                        column: 9
                    }
                },
                line: 196
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 206,
                        column: 12
                    },
                    end: {
                        line: 206,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 206,
                        column: 18
                    },
                    end: {
                        line: 208,
                        column: 3
                    }
                },
                line: 206
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 211,
                        column: 12
                    },
                    end: {
                        line: 211,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 211,
                        column: 18
                    },
                    end: {
                        line: 252,
                        column: 3
                    }
                },
                line: 211
            },
            "13": {
                name: "(anonymous_13)",
                decl: {
                    start: {
                        line: 243,
                        column: 28
                    },
                    end: {
                        line: 243,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 244,
                        column: 10
                    },
                    end: {
                        line: 248,
                        column: 11
                    }
                },
                line: 244
            },
            "14": {
                name: "(anonymous_14)",
                decl: {
                    start: {
                        line: 254,
                        column: 34
                    },
                    end: {
                        line: 254,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 254,
                        column: 40
                    },
                    end: {
                        line: 315,
                        column: 3
                    }
                },
                line: 254
            },
            "15": {
                name: "(anonymous_15)",
                decl: {
                    start: {
                        line: 259,
                        column: 26
                    },
                    end: {
                        line: 259,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 260,
                        column: 8
                    },
                    end: {
                        line: 262,
                        column: 10
                    }
                },
                line: 260
            },
            "16": {
                name: "(anonymous_16)",
                decl: {
                    start: {
                        line: 272,
                        column: 43
                    },
                    end: {
                        line: 272,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 272,
                        column: 61
                    },
                    end: {
                        line: 301,
                        column: 7
                    }
                },
                line: 272
            },
            "17": {
                name: "(anonymous_17)",
                decl: {
                    start: {
                        line: 289,
                        column: 30
                    },
                    end: {
                        line: 289,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 290,
                        column: 12
                    },
                    end: {
                        line: 295,
                        column: 13
                    }
                },
                line: 290
            },
            "18": {
                name: "(anonymous_18)",
                decl: {
                    start: {
                        line: 307,
                        column: 26
                    },
                    end: {
                        line: 307,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 308,
                        column: 8
                    },
                    end: {
                        line: 312,
                        column: 9
                    }
                },
                line: 308
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 18,
                        column: 23
                    },
                    end: {
                        line: 18,
                        column: 86
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 18,
                            column: 23
                        },
                        end: {
                            line: 18,
                            column: 52
                        }
                    },
                    {
                        start: {
                            line: 18,
                            column: 56
                        },
                        end: {
                            line: 18,
                            column: 86
                        }
                    }
                ],
                line: 18
            },
            "1": {
                loc: {
                    start: {
                        line: 81,
                        column: 2
                    },
                    end: {
                        line: 83,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 81,
                            column: 2
                        },
                        end: {
                            line: 83,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 81
            },
            "2": {
                loc: {
                    start: {
                        line: 97,
                        column: 2
                    },
                    end: {
                        line: 97,
                        column: 29
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 97,
                            column: 13
                        },
                        end: {
                            line: 97,
                            column: 29
                        }
                    }
                ],
                line: 97
            },
            "3": {
                loc: {
                    start: {
                        line: 98,
                        column: 2
                    },
                    end: {
                        line: 98,
                        column: 29
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 98,
                            column: 18
                        },
                        end: {
                            line: 98,
                            column: 29
                        }
                    }
                ],
                line: 98
            },
            "4": {
                loc: {
                    start: {
                        line: 99,
                        column: 2
                    },
                    end: {
                        line: 99,
                        column: 23
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 99,
                            column: 15
                        },
                        end: {
                            line: 99,
                            column: 23
                        }
                    }
                ],
                line: 99
            },
            "5": {
                loc: {
                    start: {
                        line: 128,
                        column: 6
                    },
                    end: {
                        line: 138,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 128,
                            column: 6
                        },
                        end: {
                            line: 138,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 128
            },
            "6": {
                loc: {
                    start: {
                        line: 133,
                        column: 12
                    },
                    end: {
                        line: 133,
                        column: 68
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 133,
                            column: 29
                        },
                        end: {
                            line: 133,
                            column: 46
                        }
                    },
                    {
                        start: {
                            line: 133,
                            column: 49
                        },
                        end: {
                            line: 133,
                            column: 68
                        }
                    }
                ],
                line: 133
            },
            "7": {
                loc: {
                    start: {
                        line: 140,
                        column: 6
                    },
                    end: {
                        line: 156,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 140,
                            column: 6
                        },
                        end: {
                            line: 156,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 140
            },
            "8": {
                loc: {
                    start: {
                        line: 181,
                        column: 21
                    },
                    end: {
                        line: 181,
                        column: 40
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 181,
                            column: 21
                        },
                        end: {
                            line: 181,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 181,
                            column: 38
                        },
                        end: {
                            line: 181,
                            column: 40
                        }
                    }
                ],
                line: 181
            },
            "9": {
                loc: {
                    start: {
                        line: 182,
                        column: 20
                    },
                    end: {
                        line: 182,
                        column: 38
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 182,
                            column: 20
                        },
                        end: {
                            line: 182,
                            column: 32
                        }
                    },
                    {
                        start: {
                            line: 182,
                            column: 36
                        },
                        end: {
                            line: 182,
                            column: 38
                        }
                    }
                ],
                line: 182
            },
            "10": {
                loc: {
                    start: {
                        line: 198,
                        column: 10
                    },
                    end: {
                        line: 198,
                        column: 68
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 198,
                            column: 35
                        },
                        end: {
                            line: 198,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 198,
                            column: 43
                        },
                        end: {
                            line: 198,
                            column: 68
                        }
                    }
                ],
                line: 198
            },
            "11": {
                loc: {
                    start: {
                        line: 212,
                        column: 4
                    },
                    end: {
                        line: 251,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 212,
                            column: 4
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 212
            },
            "12": {
                loc: {
                    start: {
                        line: 212,
                        column: 8
                    },
                    end: {
                        line: 212,
                        column: 74
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 212,
                            column: 8
                        },
                        end: {
                            line: 212,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 212,
                            column: 21
                        },
                        end: {
                            line: 212,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 212,
                            column: 38
                        },
                        end: {
                            line: 212,
                            column: 55
                        }
                    },
                    {
                        start: {
                            line: 212,
                            column: 59
                        },
                        end: {
                            line: 212,
                            column: 74
                        }
                    }
                ],
                line: 212
            },
            "13": {
                loc: {
                    start: {
                        line: 236,
                        column: 16
                    },
                    end: {
                        line: 236,
                        column: 95
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 236,
                            column: 42
                        },
                        end: {
                            line: 236,
                            column: 49
                        }
                    },
                    {
                        start: {
                            line: 236,
                            column: 52
                        },
                        end: {
                            line: 236,
                            column: 95
                        }
                    }
                ],
                line: 236
            },
            "14": {
                loc: {
                    start: {
                        line: 236,
                        column: 52
                    },
                    end: {
                        line: 236,
                        column: 95
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 236,
                            column: 77
                        },
                        end: {
                            line: 236,
                            column: 84
                        }
                    },
                    {
                        start: {
                            line: 236,
                            column: 87
                        },
                        end: {
                            line: 236,
                            column: 95
                        }
                    }
                ],
                line: 236
            },
            "15": {
                loc: {
                    start: {
                        line: 240,
                        column: 17
                    },
                    end: {
                        line: 240,
                        column: 57
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 240,
                            column: 17
                        },
                        end: {
                            line: 240,
                            column: 44
                        }
                    },
                    {
                        start: {
                            line: 240,
                            column: 48
                        },
                        end: {
                            line: 240,
                            column: 57
                        }
                    }
                ],
                line: 240
            },
            "16": {
                loc: {
                    start: {
                        line: 246,
                        column: 12
                    },
                    end: {
                        line: 246,
                        column: 79
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 246,
                            column: 37
                        },
                        end: {
                            line: 246,
                            column: 42
                        }
                    },
                    {
                        start: {
                            line: 246,
                            column: 45
                        },
                        end: {
                            line: 246,
                            column: 79
                        }
                    }
                ],
                line: 246
            },
            "17": {
                loc: {
                    start: {
                        line: 255,
                        column: 4
                    },
                    end: {
                        line: 265,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 255,
                            column: 4
                        },
                        end: {
                            line: 265,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 255
            },
            "18": {
                loc: {
                    start: {
                        line: 280,
                        column: 8
                    },
                    end: {
                        line: 300,
                        column: 9
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 280,
                            column: 8
                        },
                        end: {
                            line: 300,
                            column: 9
                        }
                    },
                    {
                        start: {
                            line: 297,
                            column: 15
                        },
                        end: {
                            line: 300,
                            column: 9
                        }
                    }
                ],
                line: 280
            },
            "19": {
                loc: {
                    start: {
                        line: 280,
                        column: 12
                    },
                    end: {
                        line: 280,
                        column: 55
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 280,
                            column: 12
                        },
                        end: {
                            line: 280,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 280,
                            column: 35
                        },
                        end: {
                            line: 280,
                            column: 55
                        }
                    }
                ],
                line: 280
            },
            "20": {
                loc: {
                    start: {
                        line: 287,
                        column: 25
                    },
                    end: {
                        line: 287,
                        column: 99
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 287,
                            column: 47
                        },
                        end: {
                            line: 287,
                            column: 69
                        }
                    },
                    {
                        start: {
                            line: 287,
                            column: 72
                        },
                        end: {
                            line: 287,
                            column: 99
                        }
                    }
                ],
                line: 287
            },
            "21": {
                loc: {
                    start: {
                        line: 310,
                        column: 10
                    },
                    end: {
                        line: 310,
                        column: 70
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 310,
                            column: 35
                        },
                        end: {
                            line: 310,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 310,
                            column: 43
                        },
                        end: {
                            line: 310,
                            column: 70
                        }
                    }
                ],
                line: 310
            },
            "22": {
                loc: {
                    start: {
                        line: 317,
                        column: 19
                    },
                    end: {
                        line: 317,
                        column: 78
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 317,
                            column: 71
                        },
                        end: {
                            line: 317,
                            column: 73
                        }
                    },
                    {
                        start: {
                            line: 317,
                            column: 76
                        },
                        end: {
                            line: 317,
                            column: 78
                        }
                    }
                ],
                line: 317
            },
            "23": {
                loc: {
                    start: {
                        line: 317,
                        column: 19
                    },
                    end: {
                        line: 317,
                        column: 68
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 317,
                            column: 19
                        },
                        end: {
                            line: 317,
                            column: 42
                        }
                    },
                    {
                        start: {
                            line: 317,
                            column: 46
                        },
                        end: {
                            line: 317,
                            column: 68
                        }
                    }
                ],
                line: 317
            },
            "24": {
                loc: {
                    start: {
                        line: 318,
                        column: 23
                    },
                    end: {
                        line: 318,
                        column: 55
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 318,
                            column: 23
                        },
                        end: {
                            line: 318,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 318,
                            column: 41
                        },
                        end: {
                            line: 318,
                            column: 55
                        }
                    }
                ],
                line: 318
            },
            "25": {
                loc: {
                    start: {
                        line: 320,
                        column: 4
                    },
                    end: {
                        line: 320,
                        column: 93
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 320,
                            column: 29
                        },
                        end: {
                            line: 320,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 320,
                            column: 34
                        },
                        end: {
                            line: 320,
                            column: 93
                        }
                    }
                ],
                line: 320
            },
            "26": {
                loc: {
                    start: {
                        line: 320,
                        column: 34
                    },
                    end: {
                        line: 320,
                        column: 93
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 320,
                            column: 86
                        },
                        end: {
                            line: 320,
                            column: 88
                        }
                    },
                    {
                        start: {
                            line: 320,
                            column: 91
                        },
                        end: {
                            line: 320,
                            column: 93
                        }
                    }
                ],
                line: 320
            },
            "27": {
                loc: {
                    start: {
                        line: 320,
                        column: 34
                    },
                    end: {
                        line: 320,
                        column: 83
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 320,
                            column: 34
                        },
                        end: {
                            line: 320,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 320,
                            column: 60
                        },
                        end: {
                            line: 320,
                            column: 83
                        }
                    }
                ],
                line: 320
            },
            "28": {
                loc: {
                    start: {
                        line: 325,
                        column: 7
                    },
                    end: {
                        line: 339,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 325,
                            column: 7
                        },
                        end: {
                            line: 325,
                            column: 19
                        }
                    },
                    {
                        start: {
                            line: 326,
                            column: 8
                        },
                        end: {
                            line: 338,
                            column: 14
                        }
                    }
                ],
                line: 325
            },
            "29": {
                loc: {
                    start: {
                        line: 336,
                        column: 18
                    },
                    end: {
                        line: 336,
                        column: 64
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 336,
                            column: 44
                        },
                        end: {
                            line: 336,
                            column: 51
                        }
                    },
                    {
                        start: {
                            line: 336,
                            column: 54
                        },
                        end: {
                            line: 336,
                            column: 64
                        }
                    }
                ],
                line: 336
            },
            "30": {
                loc: {
                    start: {
                        line: 342,
                        column: 7
                    },
                    end: {
                        line: 363,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 342,
                            column: 7
                        },
                        end: {
                            line: 342,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 342,
                            column: 24
                        },
                        end: {
                            line: 342,
                            column: 32
                        }
                    },
                    {
                        start: {
                            line: 343,
                            column: 8
                        },
                        end: {
                            line: 362,
                            column: 14
                        }
                    }
                ],
                line: 342
            },
            "31": {
                loc: {
                    start: {
                        line: 346,
                        column: 19
                    },
                    end: {
                        line: 346,
                        column: 56
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 346,
                            column: 19
                        },
                        end: {
                            line: 346,
                            column: 30
                        }
                    },
                    {
                        start: {
                            line: 346,
                            column: 34
                        },
                        end: {
                            line: 346,
                            column: 56
                        }
                    }
                ],
                line: 346
            },
            "32": {
                loc: {
                    start: {
                        line: 350,
                        column: 22
                    },
                    end: {
                        line: 350,
                        column: 49
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 350,
                            column: 22
                        },
                        end: {
                            line: 350,
                            column: 36
                        }
                    },
                    {
                        start: {
                            line: 350,
                            column: 40
                        },
                        end: {
                            line: 350,
                            column: 49
                        }
                    }
                ],
                line: 350
            },
            "33": {
                loc: {
                    start: {
                        line: 366,
                        column: 7
                    },
                    end: {
                        line: 366,
                        column: 97
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 366,
                            column: 7
                        },
                        end: {
                            line: 366,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 366,
                            column: 24
                        },
                        end: {
                            line: 366,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 366,
                            column: 37
                        },
                        end: {
                            line: 366,
                            column: 97
                        }
                    }
                ],
                line: 366
            },
            "34": {
                loc: {
                    start: {
                        line: 368,
                        column: 7
                    },
                    end: {
                        line: 372,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 368,
                            column: 7
                        },
                        end: {
                            line: 368,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 369,
                            column: 8
                        },
                        end: {
                            line: 371,
                            column: 14
                        }
                    }
                ],
                line: 368
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0,
            "64": 0,
            "65": 0,
            "66": 0,
            "67": 0,
            "68": 0,
            "69": 0,
            "70": 0,
            "71": 0,
            "72": 0,
            "73": 0,
            "74": 0,
            "75": 0,
            "76": 0,
            "77": 0,
            "78": 0,
            "79": 0,
            "80": 0,
            "81": 0,
            "82": 0,
            "83": 0,
            "84": 0,
            "85": 0,
            "86": 0,
            "87": 0,
            "88": 0,
            "89": 0,
            "90": 0,
            "91": 0,
            "92": 0,
            "93": 0,
            "94": 0,
            "95": 0,
            "96": 0,
            "97": 0,
            "98": 0,
            "99": 0,
            "100": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0
            ],
            "3": [
                0
            ],
            "4": [
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0,
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0
            ],
            "15": [
                0,
                0
            ],
            "16": [
                0,
                0
            ],
            "17": [
                0,
                0
            ],
            "18": [
                0,
                0
            ],
            "19": [
                0,
                0
            ],
            "20": [
                0,
                0
            ],
            "21": [
                0,
                0
            ],
            "22": [
                0,
                0
            ],
            "23": [
                0,
                0
            ],
            "24": [
                0,
                0
            ],
            "25": [
                0,
                0
            ],
            "26": [
                0,
                0
            ],
            "27": [
                0,
                0
            ],
            "28": [
                0,
                0
            ],
            "29": [
                0,
                0
            ],
            "30": [
                0,
                0,
                0
            ],
            "31": [
                0,
                0
            ],
            "32": [
                0,
                0
            ],
            "33": [
                0,
                0,
                0
            ],
            "34": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "57b6d3374e4ff3535e65b1efaea97b8b2c45e534"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_nh0p95hh3 = function cov_nh0p95hh3() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_nh0p95hh3();
function _regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_instanceof/* default */.Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return _regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
        return this;
    }), _regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            _regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine2(e, r, n, t);
}
function GoogleAuth_asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function GoogleAuth_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                GoogleAuth_asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                GoogleAuth_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function GoogleAuth_slicedToArray(r, e) {
    return GoogleAuth_arrayWithHoles(r) || GoogleAuth_iterableToArrayLimit(r, e) || GoogleAuth_unsupportedIterableToArray(r, e) || GoogleAuth_nonIterableRest();
}
function GoogleAuth_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GoogleAuth_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return GoogleAuth_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? GoogleAuth_arrayLikeToArray(r, a) : void 0;
    }
}
function GoogleAuth_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function GoogleAuth_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function GoogleAuth_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}































var GoogleAuth_GoogleIcon = (cov_nh0p95hh3().s[0]++, (0,iconCompatibility/* adaptExternalIcon */.f)(GoogleIcon));
/**
 * IdentityCredential only exists in Chromium browsers with FedCM support.
 * Safari has navigator.credentials (WebAuthn) but not IdentityCredential.
 * Evaluated once at module load — browser capabilities don't change at runtime.
 */ var fedCMAvailable = (cov_nh0p95hh3().s[1]++, (cov_nh0p95hh3().b[0][0]++, "object" !== "undefined") && (cov_nh0p95hh3().b[0][1]++, "IdentityCredential" in window));
/**
 * Response shape for Google authentication.
 * Compatible with the credential format from Google Identity Services.
 */ /**
 * @deprecated Use GoogleAuthResponse instead.
 * Legacy response type maintained for backward compatibility.
 */ /**
 * Decodes a JWT to extract the payload (without verification).
 * Used to extract user info from Google's ID token for analytics.
 */ function decodeJwtPayload(token) {
    cov_nh0p95hh3().f[0]++;
    cov_nh0p95hh3().s[2]++;
    try {
        var base64Url = (cov_nh0p95hh3().s[3]++, token.split(".")[1]);
        var base64 = (cov_nh0p95hh3().s[4]++, base64Url.replace(/-/g, "+").replace(/_/g, "/"));
        var padded = (cov_nh0p95hh3().s[5]++, base64.padEnd(base64.length + (4 - base64.length % 4) % 4, "="));
        var jsonPayload = (cov_nh0p95hh3().s[6]++, decodeURIComponent(atob(padded).split("").map(function(c) {
            cov_nh0p95hh3().f[1]++;
            cov_nh0p95hh3().s[7]++;
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join("")));
        cov_nh0p95hh3().s[8]++;
        return JSON.parse(jsonPayload);
    } catch (_unused) {
        cov_nh0p95hh3().s[9]++;
        return {};
    }
}
cov_nh0p95hh3().s[10]++;
var safeObservableEvent = function safeObservableEvent(fn) {
    cov_nh0p95hh3().f[2]++;
    cov_nh0p95hh3().s[11]++;
    if (observability_slim/* globalObservability.isInitialized */.w.isInitialized()) {
        cov_nh0p95hh3().b[1][0]++;
        cov_nh0p95hh3().s[12]++;
        fn();
    } else {
        cov_nh0p95hh3().b[1][1]++;
    }
};
/**
 * Google authentication button component using FedCM-ready Google Identity Services.
 *
 * Uses the modern Google Sign-In library (accounts.google.com/gsi/client) with
 * FedCM enabled for privacy-preserving authentication.
 *
 * @param clientId - Google OAuth client ID (defaults to env-specific value from globals)
 */ cov_nh0p95hh3().s[13]++;
var GoogleAuth = function GoogleAuth(_ref) {
    var buttonLabel = _ref.buttonLabel, onAuthed = _ref.onAuthed, _ref$clientId = _ref.clientId, clientId = _ref$clientId === void 0 ? (cov_nh0p95hh3().b[2][0]++, globals/* GOOGLE_CLIENT_ID */.wL) : _ref$clientId, _ref$buttonVariant = _ref.buttonVariant, buttonVariant = _ref$buttonVariant === void 0 ? (cov_nh0p95hh3().b[3][0]++, "secondary") : _ref$buttonVariant, _ref$buttonSize = _ref.buttonSize, buttonSize = _ref$buttonSize === void 0 ? (cov_nh0p95hh3().b[4][0]++, "medium") : _ref$buttonSize;
    cov_nh0p95hh3().f[3]++;
    var _ref2 = (cov_nh0p95hh3().s[14]++, (0,react.useState)(null)), _ref3 = GoogleAuth_slicedToArray(_ref2, 2), errorResponse = _ref3[0], setErrorResponse = _ref3[1];
    var _ref4 = (cov_nh0p95hh3().s[15]++, (0,react.useState)("")), _ref5 = GoogleAuth_slicedToArray(_ref4, 2), errorMessage = _ref5[0], setErrorMessage = _ref5[1];
    var _ref6 = (cov_nh0p95hh3().s[16]++, (0,react.useState)(false)), _ref7 = GoogleAuth_slicedToArray(_ref6, 2), isLoading = _ref7[0], setIsLoading = _ref7[1];
    var _ref8 = (cov_nh0p95hh3().s[17]++, (0,react.useState)(false)), _ref9 = GoogleAuth_slicedToArray(_ref8, 2), isInitialized = _ref9[0], setIsInitialized = _ref9[1];
    var _ref0 = (cov_nh0p95hh3().s[18]++, (0,react.useState)(fedCMAvailable)), _ref1 = GoogleAuth_slicedToArray(_ref0, 2), useFedCM = _ref1[0], setUseFedCM = _ref1[1];
    var _ref10 = (cov_nh0p95hh3().s[19]++, (0,react.useState)(null)), _ref11 = GoogleAuth_slicedToArray(_ref10, 2), buttonContainer = _ref11[0], setButtonContainer = _ref11[1];
    var googleRef = (cov_nh0p95hh3().s[20]++, (0,react.useRef)(undefined));
    var _ref12 = (cov_nh0p95hh3().s[21]++, (0,observability_slim/* useObservability */.C3)()), trackError = _ref12.trackError, trackEvent = _ref12.trackEvent;
    var trackErrorRef = (cov_nh0p95hh3().s[22]++, (0,react.useRef)(trackError));
    var trackEventRef = (cov_nh0p95hh3().s[23]++, (0,react.useRef)(trackEvent));
    var hasTrackedCapability = (cov_nh0p95hh3().s[24]++, (0,react.useRef)(false));
    var onAuthedRef = (cov_nh0p95hh3().s[25]++, (0,react.useRef)(onAuthed));
    cov_nh0p95hh3().s[26]++;
    trackErrorRef.current = trackError;
    cov_nh0p95hh3().s[27]++;
    trackEventRef.current = trackEvent;
    cov_nh0p95hh3().s[28]++;
    onAuthedRef.current = onAuthed;
    var buttonContainerRef = (cov_nh0p95hh3().s[29]++, (0,react.useCallback)(function(node) {
        cov_nh0p95hh3().f[4]++;
        cov_nh0p95hh3().s[30]++;
        setButtonContainer(node);
    }, []));
    var initGoogleAuth = (cov_nh0p95hh3().s[31]++, (0,react.useCallback)(/*#__PURE__*/ GoogleAuth_asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
        var _googleRef$current, _googleRef$current$ca, google, errorMsg, _errorMsg, _t;
        return _regenerator().w(function(_context) {
            while(1)switch(_context.p = _context.n){
                case 0:
                    cov_nh0p95hh3().f[5]++;
                    cov_nh0p95hh3().s[32]++;
                    _context.p = 1;
                    cov_nh0p95hh3().s[33]++;
                    // Cancel any in-flight prompt before re-initializing
                    (_googleRef$current = googleRef.current) === null || _googleRef$current === void 0 || (_googleRef$current = _googleRef$current.accounts.id) === null || _googleRef$current === void 0 || (_googleRef$current$ca = _googleRef$current.cancel) === null || _googleRef$current$ca === void 0 || _googleRef$current$ca.call(_googleRef$current);
                    cov_nh0p95hh3().s[34]++;
                    _context.n = 2;
                    return loadGoogleOneTap();
                case 2:
                    google = _context.v;
                    cov_nh0p95hh3().s[35]++;
                    if (!hasTrackedCapability.current) {
                        cov_nh0p95hh3().b[5][0]++;
                        cov_nh0p95hh3().s[36]++;
                        hasTrackedCapability.current = true;
                        cov_nh0p95hh3().s[37]++;
                        safeObservableEvent(function() {
                            cov_nh0p95hh3().f[6]++;
                            cov_nh0p95hh3().s[38]++;
                            return trackEventRef.current("google-auth", fedCMAvailable ? (cov_nh0p95hh3().b[6][0]++, "fedcm-available") : (cov_nh0p95hh3().b[6][1]++, "fedcm-unavailable"), {}, {
                                categoryOverride: "login"
                            });
                        });
                    } else {
                        cov_nh0p95hh3().b[5][1]++;
                    }
                    cov_nh0p95hh3().s[39]++;
                    if (google) {
                        _context.n = 3;
                        break;
                    }
                    cov_nh0p95hh3().b[7][0]++;
                    errorMsg = (cov_nh0p95hh3().s[40]++, "Sorry, the attempt to sign in with Google failed. Please try again.");
                    cov_nh0p95hh3().s[41]++;
                    setErrorMessage(errorMsg);
                    cov_nh0p95hh3().s[42]++;
                    setErrorResponse({
                        error: "script_load_failure",
                        details: "Failed to load Google Identity Services"
                    });
                    cov_nh0p95hh3().s[43]++;
                    safeObservableEvent(function() {
                        cov_nh0p95hh3().f[7]++;
                        cov_nh0p95hh3().s[44]++;
                        return trackErrorRef.current("google-auth", new Error("script load failure"), {
                            details: "Failed to load Google Identity Services"
                        }, {
                            skipSentry: true
                        });
                    });
                    cov_nh0p95hh3().s[45]++;
                    return _context.a(2);
                case 3:
                    cov_nh0p95hh3().b[7][1]++;
                case 4:
                    cov_nh0p95hh3().s[46]++;
                    google.accounts.id.initialize({
                        client_id: clientId,
                        callback: function callback(response) {
                            cov_nh0p95hh3().f[8]++;
                            cov_nh0p95hh3().s[47]++;
                            setIsLoading(false);
                            cov_nh0p95hh3().s[48]++;
                            setErrorMessage("");
                            cov_nh0p95hh3().s[49]++;
                            setErrorResponse(null);
                            var payload = (cov_nh0p95hh3().s[50]++, decodeJwtPayload(response.credential));
                            cov_nh0p95hh3().s[51]++;
                            safeObservableEvent(function() {
                                cov_nh0p95hh3().f[9]++;
                                cov_nh0p95hh3().s[52]++;
                                return trackEventRef.current("google-auth", "authed", {
                                    email: payload.email,
                                    name: payload.name
                                }, {
                                    categoryOverride: "login"
                                });
                            });
                            cov_nh0p95hh3().s[53]++;
                            onAuthedRef.current({
                                credential: response.credential,
                                // Legacy compatibility - tokenId is the same as credential
                                tokenId: response.credential,
                                profileObj: {
                                    email: (cov_nh0p95hh3().b[8][0]++, payload.email) || (cov_nh0p95hh3().b[8][1]++, ""),
                                    name: (cov_nh0p95hh3().b[9][0]++, payload.name) || (cov_nh0p95hh3().b[9][1]++, "")
                                }
                            });
                        },
                        use_fedcm_for_prompt: useFedCM
                    });
                    cov_nh0p95hh3().s[54]++;
                    googleRef.current = google;
                    cov_nh0p95hh3().s[55]++;
                    setIsInitialized(true);
                    _context.n = 6;
                    break;
                case 5:
                    _context.p = 5;
                    _t = _context.v;
                    _errorMsg = (cov_nh0p95hh3().s[56]++, "Sorry, the attempt to sign in with Google failed. Please try again.");
                    cov_nh0p95hh3().s[57]++;
                    setErrorMessage(_errorMsg);
                    cov_nh0p95hh3().s[58]++;
                    setErrorResponse({
                        error: "init_failure",
                        details: "Google Sign-In failed to initialize"
                    });
                    cov_nh0p95hh3().s[59]++;
                    safeObservableEvent(function() {
                        cov_nh0p95hh3().f[10]++;
                        cov_nh0p95hh3().s[60]++;
                        return trackErrorRef.current("google-auth", (0,_instanceof/* default */.Z)(_t, Error) ? (cov_nh0p95hh3().b[10][0]++, _t) : (cov_nh0p95hh3().b[10][1]++, new Error("init_failure")), {
                            details: "Unexpected error during Google Sign-In initialization"
                        });
                    });
                case 6:
                    return _context.a(2);
            }
        }, _callee, null, [
            [
                1,
                5
            ]
        ]);
    })), [
        clientId,
        useFedCM
    ]));
    // Probe FedCM and initialize Google Identity Services on mount
    cov_nh0p95hh3().s[61]++;
    (0,react.useEffect)(function() {
        cov_nh0p95hh3().f[11]++;
        cov_nh0p95hh3().s[62]++;
        initGoogleAuth();
    }, [
        initGoogleAuth
    ]);
    // Render Google's fallback button when FedCM is unavailable
    cov_nh0p95hh3().s[63]++;
    (0,react.useEffect)(function() {
        cov_nh0p95hh3().f[12]++;
        cov_nh0p95hh3().s[64]++;
        if ((cov_nh0p95hh3().b[12][0]++, !useFedCM) && (cov_nh0p95hh3().b[12][1]++, isInitialized) && (cov_nh0p95hh3().b[12][2]++, googleRef.current) && (cov_nh0p95hh3().b[12][3]++, buttonContainer)) {
            cov_nh0p95hh3().b[11][0]++;
            // Cast to access renderButton - temporary backstop during migration to unified component
            var gsi = (cov_nh0p95hh3().s[65]++, googleRef.current);
            cov_nh0p95hh3().s[66]++;
            try {
                cov_nh0p95hh3().s[67]++;
                gsi.accounts.id.renderButton(buttonContainer, {
                    type: "standard",
                    theme: "outline",
                    size: buttonSize === "xsmall" ? (cov_nh0p95hh3().b[13][0]++, "small") : (cov_nh0p95hh3().b[13][1]++, buttonSize === "large" ? (cov_nh0p95hh3().b[14][0]++, "large") : (cov_nh0p95hh3().b[14][1]++, "medium")),
                    text: "continue_with",
                    shape: "rectangular",
                    logo_alignment: "left",
                    width: (cov_nh0p95hh3().b[15][0]++, buttonContainer.offsetWidth) || (cov_nh0p95hh3().b[15][1]++, undefined)
                });
            } catch (error) {
                cov_nh0p95hh3().s[68]++;
                safeObservableEvent(function() {
                    cov_nh0p95hh3().f[13]++;
                    cov_nh0p95hh3().s[69]++;
                    return trackErrorRef.current("google-auth", (0,_instanceof/* default */.Z)(error, Error) ? (cov_nh0p95hh3().b[16][0]++, error) : (cov_nh0p95hh3().b[16][1]++, new Error("render_button_failure")), {
                        details: "Failed to render Google Sign-In button"
                    });
                });
            }
        } else {
            cov_nh0p95hh3().b[11][1]++;
        }
    }, [
        useFedCM,
        isInitialized,
        buttonSize,
        buttonContainer
    ]);
    var handleClick = (cov_nh0p95hh3().s[70]++, (0,react.useCallback)(function() {
        cov_nh0p95hh3().f[14]++;
        cov_nh0p95hh3().s[71]++;
        if (!googleRef.current) {
            cov_nh0p95hh3().b[17][0]++;
            var errorMsg = (cov_nh0p95hh3().s[72]++, "Sorry, the attempt to sign in with Google failed. Please try again.");
            cov_nh0p95hh3().s[73]++;
            setErrorMessage(errorMsg);
            cov_nh0p95hh3().s[74]++;
            setErrorResponse({
                error: "not_initialized",
                details: "Google Sign-In not loaded"
            });
            cov_nh0p95hh3().s[75]++;
            safeObservableEvent(function() {
                cov_nh0p95hh3().f[15]++;
                cov_nh0p95hh3().s[76]++;
                return trackErrorRef.current("google-auth", new Error(errorMsg), {
                    error_code: "not_initialized"
                });
            });
            cov_nh0p95hh3().s[77]++;
            return;
        } else {
            cov_nh0p95hh3().b[17][1]++;
        }
        cov_nh0p95hh3().s[78]++;
        setIsLoading(true);
        cov_nh0p95hh3().s[79]++;
        setErrorMessage("");
        cov_nh0p95hh3().s[80]++;
        setErrorResponse(null);
        cov_nh0p95hh3().s[81]++;
        try {
            cov_nh0p95hh3().s[82]++;
            googleRef.current.accounts.id.prompt(function(notification) {
                var _n$isNotDisplayed;
                cov_nh0p95hh3().f[16]++;
                // Cast to access methods that exist at runtime but aren't in shared-fe types
                var n = (cov_nh0p95hh3().s[83]++, notification);
                cov_nh0p95hh3().s[84]++;
                if ((cov_nh0p95hh3().b[19][0]++, n.isSkippedMoment()) || (cov_nh0p95hh3().b[19][1]++, (_n$isNotDisplayed = n.isNotDisplayed) !== null && _n$isNotDisplayed !== void 0 && _n$isNotDisplayed.call(n))) {
                    var _n$getSkippedReason, _n$getNotDisplayedRea;
                    cov_nh0p95hh3().b[18][0]++;
                    cov_nh0p95hh3().s[85]++;
                    // FedCM failed at runtime — fall back to Google's rendered button (popup OAuth).
                    // Flipping useFedCM triggers re-init with use_fedcm_for_prompt:false
                    // and re-render to show Google's native button.
                    setUseFedCM(false);
                    cov_nh0p95hh3().s[86]++;
                    setIsLoading(false);
                    var reason = (cov_nh0p95hh3().s[87]++, n.isSkippedMoment() ? (cov_nh0p95hh3().b[20][0]++, (_n$getSkippedReason = n.getSkippedReason) === null || _n$getSkippedReason === void 0 ? void 0 : _n$getSkippedReason.call(n)) : (cov_nh0p95hh3().b[20][1]++, (_n$getNotDisplayedRea = n.getNotDisplayedReason) === null || _n$getNotDisplayedRea === void 0 ? void 0 : _n$getNotDisplayedRea.call(n)));
                    cov_nh0p95hh3().s[88]++;
                    safeObservableEvent(function() {
                        cov_nh0p95hh3().f[17]++;
                        cov_nh0p95hh3().s[89]++;
                        return trackEventRef.current("google-auth", "fedcm-failed-using-popup-fallback", {
                            reason: reason
                        }, {
                            categoryOverride: "login"
                        });
                    });
                } else {
                    cov_nh0p95hh3().b[18][1]++;
                    cov_nh0p95hh3().s[90]++;
                    // Success handled by initialize() callback, always re-enable button
                    setIsLoading(false);
                }
            });
        } catch (error) {
            cov_nh0p95hh3().s[91]++;
            setIsLoading(false);
            var _errorMsg2 = (cov_nh0p95hh3().s[92]++, "Sorry, the attempt to sign in with Google failed. Please try again.");
            cov_nh0p95hh3().s[93]++;
            setErrorMessage(_errorMsg2);
            cov_nh0p95hh3().s[94]++;
            setErrorResponse({
                error: "prompt_failure",
                details: "Google Sign-In prompt failed"
            });
            cov_nh0p95hh3().s[95]++;
            safeObservableEvent(function() {
                cov_nh0p95hh3().f[18]++;
                cov_nh0p95hh3().s[96]++;
                return trackErrorRef.current("google-auth", (0,_instanceof/* default */.Z)(error, Error) ? (cov_nh0p95hh3().b[21][0]++, error) : (cov_nh0p95hh3().b[21][1]++, new Error("prompt_failure")), {
                    details: "Unexpected error calling Google Sign-In prompt"
                });
            });
        }
    }, []));
    var iconSize = (cov_nh0p95hh3().s[97]++, (cov_nh0p95hh3().b[23][0]++, buttonSize === "xsmall") || (cov_nh0p95hh3().b[23][1]++, buttonSize === "small") ? (cov_nh0p95hh3().b[22][0]++, 20) : (cov_nh0p95hh3().b[22][1]++, 24));
    var showSkeleton = (cov_nh0p95hh3().s[98]++, (cov_nh0p95hh3().b[24][0]++, !isInitialized) && (cov_nh0p95hh3().b[24][1]++, !errorResponse));
    var skeletonHeight = (cov_nh0p95hh3().s[99]++, buttonSize === "large" ? (cov_nh0p95hh3().b[25][0]++, 40) : (cov_nh0p95hh3().b[25][1]++, (cov_nh0p95hh3().b[27][0]++, buttonSize === "small") || (cov_nh0p95hh3().b[27][1]++, buttonSize === "xsmall") ? (cov_nh0p95hh3().b[26][0]++, 20) : (cov_nh0p95hh3().b[26][1]++, 32)));
    cov_nh0p95hh3().s[100]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, (cov_nh0p95hh3().b[28][0]++, showSkeleton) && (cov_nh0p95hh3().b[28][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        height: skeletonHeight,
        width: "100%",
        maxWidth: 400,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ react.createElement(Button/* ButtonLoadingAnimation */.V, {
        variant: "secondary",
        size: buttonSize === "xsmall" ? (cov_nh0p95hh3().b[29][0]++, "small") : (cov_nh0p95hh3().b[29][1]++, buttonSize)
    }))), (cov_nh0p95hh3().b[30][0]++, !showSkeleton) && (cov_nh0p95hh3().b[30][1]++, useFedCM) && (cov_nh0p95hh3().b[30][2]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        position: "relative",
        width: "100%",
        maxWidth: 400
    }, /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        analyticsName: "google-auth",
        label: (cov_nh0p95hh3().b[31][0]++, buttonLabel) || (cov_nh0p95hh3().b[31][1]++, "Continue with Google"),
        size: buttonSize,
        variant: buttonVariant,
        onPress: handleClick,
        disabled: (cov_nh0p95hh3().b[32][0]++, !isInitialized) || (cov_nh0p95hh3().b[32][1]++, isLoading),
        loading: isLoading
    }), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        position: "absolute",
        left: "$12x",
        top: "50%",
        style: {
            transform: [
                {
                    translateY: "-50%"
                }
            ]
        },
        pointerEvents: "none"
    }, /*#__PURE__*/ react.createElement(GoogleAuth_GoogleIcon, {
        size: iconSize,
        "aria-label": "Google"
    })))), (cov_nh0p95hh3().b[33][0]++, !showSkeleton) && (cov_nh0p95hh3().b[33][1]++, !useFedCM) && (cov_nh0p95hh3().b[33][2]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref: buttonContainerRef,
        width: "100%",
        maxWidth: 400
    })), (cov_nh0p95hh3().b[34][0]++, errorResponse) && (cov_nh0p95hh3().b[34][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        paddingBottom: "$8x"
    }, /*#__PURE__*/ react.createElement(ErrorPrompt, {
        message: errorMessage
    }))));
}; //# sourceMappingURL=GoogleAuth.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/PasswordlessResultPage.mjs
function cov_bubt6svvh() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/PasswordlessResultPage.tsx";
    var hash = "1b18c619b936ef737182f0c6ea81fe19c536aea0";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/PasswordlessResultPage.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 21,
                    column: 31
                },
                end: {
                    line: 58,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 26,
                    column: 2
                },
                end: {
                    line: 57,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 21,
                        column: 31
                    },
                    end: {
                        line: 21,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 35
                    },
                    end: {
                        line: 58,
                        column: 1
                    }
                },
                line: 25
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 29,
                        column: 9
                    },
                    end: {
                        line: 29,
                        column: 68
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 29,
                            column: 24
                        },
                        end: {
                            line: 29,
                            column: 42
                        }
                    },
                    {
                        start: {
                            line: 29,
                            column: 45
                        },
                        end: {
                            line: 29,
                            column: 68
                        }
                    }
                ],
                line: 29
            },
            "1": {
                loc: {
                    start: {
                        line: 32,
                        column: 9
                    },
                    end: {
                        line: 54,
                        column: 9
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 33,
                            column: 10
                        },
                        end: {
                            line: 39,
                            column: 13
                        }
                    },
                    {
                        start: {
                            line: 41,
                            column: 10
                        },
                        end: {
                            line: 53,
                            column: 13
                        }
                    }
                ],
                line: 32
            }
        },
        s: {
            "0": 0,
            "1": 0
        },
        f: {
            "0": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "1b18c619b936ef737182f0c6ea81fe19c536aea0"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_bubt6svvh = function cov_bubt6svvh() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_bubt6svvh();


cov_bubt6svvh().s[0]++;
var PasswordlessResultPage = function PasswordlessResultPage(_ref) {
    var email = _ref.email, hasSucceeded = _ref.hasSucceeded, analyticsName = _ref.analyticsName;
    cov_bubt6svvh().f[0]++;
    cov_bubt6svvh().s[1]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        py: "$36x",
        px: "$12x",
        gap: "$10x",
        $largerThanSM: {
            width: 480
        }
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "h1",
        typography: "$headerMedium"
    }, hasSucceeded ? (cov_bubt6svvh().b[0][0]++, "Check your email") : (cov_bubt6svvh().b[0][1]++, "Something went wrong.")), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "p",
        typography: "$bodySmall"
    }, hasSucceeded ? (cov_bubt6svvh().b[1][0]++, /*#__PURE__*/ react.createElement(react.Fragment, null, "We sent an email to", " ", /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall"
    }, email), ". It includes a link that will sign you in.")) : (cov_bubt6svvh().b[1][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, "We are unable to send you an email. Please reach out to", " ", /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        typography: "$bodySmall",
        variant: "secondary",
        href: "mailto:contact@opendoor.com",
        "aria-label": null,
        analyticsName: "".concat(analyticsName, "-passwordless-error-contact-us")
    }, "contact@opendoor.com"), " ", "for support"))));
};
/* harmony default export */ var auth_PasswordlessResultPage = (PasswordlessResultPage); //# sourceMappingURL=PasswordlessResultPage.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/AccountForm.mjs


















var _excluded = [
    "analyticsName",
    "phone",
    "email",
    "name",
    "loginHeaderText",
    "registrationHeaderText",
    "loginSubHeaderText",
    "registrationSubHeaderText",
    "emailLoading",
    "passwordLoading",
    "error",
    "phoneNumberInputOptional",
    "phoneNumberInputHidden",
    "openForgotPasswordInNewTab",
    "showGoogleAuth",
    "overrideHasSubmittedEmailCheckForLogin",
    "emailMismatch",
    "customEmailValidityCheck",
    "customEmailValidityCheckDelay",
    "requestResetPassword",
    "hidePasswordField",
    "onPasswordlessLoginRequest",
    "onboardingAccountPageCTA",
    "fullNamePlaceholder",
    "fullNameLabel",
    "disclaimerProps",
    "passwordFormActionText",
    "onHumanStatusRequest",
    "onLogin",
    "onRegister",
    "postEmailCtaSection",
    "unsetContainer",
    "fullNameOptional",
    "fullNameHidden",
    "EmailInput",
    "PasswordInput",
    "NameInput",
    "PhoneInput"
];
function cov_243c6bebk2() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/AccountForm.tsx";
    var hash = "1be7294a31d8380e2ef1dafdb6f9c804b8101968";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/AccountForm.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 24,
                    column: 26
                },
                end: {
                    line: 26,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 25,
                    column: 2
                },
                end: {
                    line: 25,
                    column: 77
                }
            },
            "2": {
                start: {
                    line: 187,
                    column: 49
                },
                end: {
                    line: 524,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 228,
                    column: 28
                },
                end: {
                    line: 228,
                    column: 58
                }
            },
            "4": {
                start: {
                    line: 230,
                    column: 24
                },
                end: {
                    line: 230,
                    column: 36
                }
            },
            "5": {
                start: {
                    line: 231,
                    column: 27
                },
                end: {
                    line: 231,
                    column: 39
                }
            },
            "6": {
                start: {
                    line: 233,
                    column: 2
                },
                end: {
                    line: 238,
                    column: 9
                }
            },
            "7": {
                start: {
                    line: 234,
                    column: 4
                },
                end: {
                    line: 237,
                    column: 5
                }
            },
            "8": {
                start: {
                    line: 235,
                    column: 25
                },
                end: {
                    line: 235,
                    column: 66
                }
            },
            "9": {
                start: {
                    line: 236,
                    column: 6
                },
                end: {
                    line: 236,
                    column: 25
                }
            },
            "10": {
                start: {
                    line: 240,
                    column: 26
                },
                end: {
                    line: 240,
                    column: 55
                }
            },
            "11": {
                start: {
                    line: 244,
                    column: 38
                },
                end: {
                    line: 244,
                    column: 73
                }
            },
            "12": {
                start: {
                    line: 246,
                    column: 58
                },
                end: {
                    line: 248,
                    column: 3
                }
            },
            "13": {
                start: {
                    line: 250,
                    column: 54
                },
                end: {
                    line: 250,
                    column: 78
                }
            },
            "14": {
                start: {
                    line: 253,
                    column: 4
                },
                end: {
                    line: 253,
                    column: 28
                }
            },
            "15": {
                start: {
                    line: 256,
                    column: 4
                },
                end: {
                    line: 256,
                    column: 23
                }
            },
            "16": {
                start: {
                    line: 259,
                    column: 4
                },
                end: {
                    line: 259,
                    column: 38
                }
            },
            "17": {
                start: {
                    line: 261,
                    column: 22
                },
                end: {
                    line: 264,
                    column: 3
                }
            },
            "18": {
                start: {
                    line: 262,
                    column: 4
                },
                end: {
                    line: 262,
                    column: 33
                }
            },
            "19": {
                start: {
                    line: 263,
                    column: 4
                },
                end: {
                    line: 263,
                    column: 29
                }
            },
            "20": {
                start: {
                    line: 266,
                    column: 28
                },
                end: {
                    line: 269,
                    column: 3
                }
            },
            "21": {
                start: {
                    line: 267,
                    column: 4
                },
                end: {
                    line: 267,
                    column: 32
                }
            },
            "22": {
                start: {
                    line: 268,
                    column: 4
                },
                end: {
                    line: 268,
                    column: 68
                }
            },
            "23": {
                start: {
                    line: 271,
                    column: 25
                },
                end: {
                    line: 274,
                    column: 3
                }
            },
            "24": {
                start: {
                    line: 272,
                    column: 4
                },
                end: {
                    line: 272,
                    column: 33
                }
            },
            "25": {
                start: {
                    line: 273,
                    column: 4
                },
                end: {
                    line: 273,
                    column: 45
                }
            },
            "26": {
                start: {
                    line: 276,
                    column: 28
                },
                end: {
                    line: 285,
                    column: 3
                }
            },
            "27": {
                start: {
                    line: 278,
                    column: 6
                },
                end: {
                    line: 280,
                    column: 7
                }
            },
            "28": {
                start: {
                    line: 279,
                    column: 8
                },
                end: {
                    line: 279,
                    column: 48
                }
            },
            "29": {
                start: {
                    line: 281,
                    column: 6
                },
                end: {
                    line: 281,
                    column: 22
                }
            },
            "30": {
                start: {
                    line: 282,
                    column: 6
                },
                end: {
                    line: 282,
                    column: 20
                }
            },
            "31": {
                start: {
                    line: 287,
                    column: 41
                },
                end: {
                    line: 295,
                    column: 3
                }
            },
            "32": {
                start: {
                    line: 288,
                    column: 4
                },
                end: {
                    line: 294,
                    column: 5
                }
            },
            "33": {
                start: {
                    line: 289,
                    column: 6
                },
                end: {
                    line: 289,
                    column: 45
                }
            },
            "34": {
                start: {
                    line: 291,
                    column: 26
                },
                end: {
                    line: 291,
                    column: 65
                }
            },
            "35": {
                start: {
                    line: 292,
                    column: 6
                },
                end: {
                    line: 292,
                    column: 46
                }
            },
            "36": {
                start: {
                    line: 293,
                    column: 6
                },
                end: {
                    line: 293,
                    column: 58
                }
            },
            "37": {
                start: {
                    line: 298,
                    column: 26
                },
                end: {
                    line: 303,
                    column: 3
                }
            },
            "38": {
                start: {
                    line: 299,
                    column: 4
                },
                end: {
                    line: 299,
                    column: 24
                }
            },
            "39": {
                start: {
                    line: 300,
                    column: 4
                },
                end: {
                    line: 300,
                    column: 17
                }
            },
            "40": {
                start: {
                    line: 301,
                    column: 4
                },
                end: {
                    line: 301,
                    column: 35
                }
            },
            "41": {
                start: {
                    line: 302,
                    column: 4
                },
                end: {
                    line: 302,
                    column: 25
                }
            },
            "42": {
                start: {
                    line: 305,
                    column: 34
                },
                end: {
                    line: 311,
                    column: 3
                }
            },
            "43": {
                start: {
                    line: 306,
                    column: 4
                },
                end: {
                    line: 308,
                    column: 5
                }
            },
            "44": {
                start: {
                    line: 307,
                    column: 6
                },
                end: {
                    line: 307,
                    column: 132
                }
            },
            "45": {
                start: {
                    line: 310,
                    column: 4
                },
                end: {
                    line: 310,
                    column: 90
                }
            },
            "46": {
                start: {
                    line: 313,
                    column: 2
                },
                end: {
                    line: 323,
                    column: 9
                }
            },
            "47": {
                start: {
                    line: 314,
                    column: 4
                },
                end: {
                    line: 314,
                    column: 27
                }
            },
            "48": {
                start: {
                    line: 319,
                    column: 4
                },
                end: {
                    line: 321,
                    column: 5
                }
            },
            "49": {
                start: {
                    line: 320,
                    column: 6
                },
                end: {
                    line: 320,
                    column: 38
                }
            },
            "50": {
                start: {
                    line: 325,
                    column: 2
                },
                end: {
                    line: 328,
                    column: 53
                }
            },
            "51": {
                start: {
                    line: 326,
                    column: 4
                },
                end: {
                    line: 326,
                    column: 38
                }
            },
            "52": {
                start: {
                    line: 327,
                    column: 4
                },
                end: {
                    line: 327,
                    column: 56
                }
            },
            "53": {
                start: {
                    line: 330,
                    column: 29
                },
                end: {
                    line: 330,
                    column: 42
                }
            },
            "54": {
                start: {
                    line: 331,
                    column: 2
                },
                end: {
                    line: 343,
                    column: 4
                }
            },
            "55": {
                start: {
                    line: 333,
                    column: 6
                },
                end: {
                    line: 335,
                    column: 7
                }
            },
            "56": {
                start: {
                    line: 334,
                    column: 8
                },
                end: {
                    line: 334,
                    column: 62
                }
            },
            "57": {
                start: {
                    line: 336,
                    column: 6
                },
                end: {
                    line: 339,
                    column: 7
                }
            },
            "58": {
                start: {
                    line: 337,
                    column: 8
                },
                end: {
                    line: 337,
                    column: 42
                }
            },
            "59": {
                start: {
                    line: 338,
                    column: 8
                },
                end: {
                    line: 338,
                    column: 42
                }
            },
            "60": {
                start: {
                    line: 345,
                    column: 32
                },
                end: {
                    line: 345,
                    column: 87
                }
            },
            "61": {
                start: {
                    line: 347,
                    column: 28
                },
                end: {
                    line: 347,
                    column: 96
                }
            },
            "62": {
                start: {
                    line: 357,
                    column: 4
                },
                end: {
                    line: 362,
                    column: 21
                }
            },
            "63": {
                start: {
                    line: 364,
                    column: 2
                },
                end: {
                    line: 373,
                    column: 74
                }
            },
            "64": {
                start: {
                    line: 365,
                    column: 4
                },
                end: {
                    line: 368,
                    column: 5
                }
            },
            "65": {
                start: {
                    line: 366,
                    column: 6
                },
                end: {
                    line: 366,
                    column: 41
                }
            },
            "66": {
                start: {
                    line: 367,
                    column: 6
                },
                end: {
                    line: 367,
                    column: 13
                }
            },
            "67": {
                start: {
                    line: 370,
                    column: 4
                },
                end: {
                    line: 372,
                    column: 5
                }
            },
            "68": {
                start: {
                    line: 371,
                    column: 6
                },
                end: {
                    line: 371,
                    column: 42
                }
            },
            "69": {
                start: {
                    line: 375,
                    column: 2
                },
                end: {
                    line: 387,
                    column: 3
                }
            },
            "70": {
                start: {
                    line: 376,
                    column: 4
                },
                end: {
                    line: 386,
                    column: 6
                }
            },
            "71": {
                start: {
                    line: 389,
                    column: 2
                },
                end: {
                    line: 397,
                    column: 3
                }
            },
            "72": {
                start: {
                    line: 390,
                    column: 4
                },
                end: {
                    line: 396,
                    column: 6
                }
            },
            "73": {
                start: {
                    line: 400,
                    column: 25
                },
                end: {
                    line: 400,
                    column: 71
                }
            },
            "74": {
                start: {
                    line: 401,
                    column: 26
                },
                end: {
                    line: 401,
                    column: 28
                }
            },
            "75": {
                start: {
                    line: 402,
                    column: 2
                },
                end: {
                    line: 413,
                    column: 3
                }
            },
            "76": {
                start: {
                    line: 403,
                    column: 4
                },
                end: {
                    line: 403,
                    column: 140
                }
            },
            "77": {
                start: {
                    line: 404,
                    column: 9
                },
                end: {
                    line: 413,
                    column: 3
                }
            },
            "78": {
                start: {
                    line: 405,
                    column: 4
                },
                end: {
                    line: 412,
                    column: 5
                }
            },
            "79": {
                start: {
                    line: 406,
                    column: 6
                },
                end: {
                    line: 406,
                    column: 76
                }
            },
            "80": {
                start: {
                    line: 407,
                    column: 11
                },
                end: {
                    line: 412,
                    column: 5
                }
            },
            "81": {
                start: {
                    line: 408,
                    column: 6
                },
                end: {
                    line: 409,
                    column: 155
                }
            },
            "82": {
                start: {
                    line: 411,
                    column: 6
                },
                end: {
                    line: 411,
                    column: 54
                }
            },
            "83": {
                start: {
                    line: 414,
                    column: 19
                },
                end: {
                    line: 414,
                    column: 93
                }
            },
            "84": {
                start: {
                    line: 416,
                    column: 2
                },
                end: {
                    line: 421,
                    column: 3
                }
            },
            "85": {
                start: {
                    line: 417,
                    column: 4
                },
                end: {
                    line: 418,
                    column: 93
                }
            },
            "86": {
                start: {
                    line: 419,
                    column: 9
                },
                end: {
                    line: 421,
                    column: 3
                }
            },
            "87": {
                start: {
                    line: 420,
                    column: 4
                },
                end: {
                    line: 420,
                    column: 32
                }
            },
            "88": {
                start: {
                    line: 423,
                    column: 2
                },
                end: {
                    line: 523,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 24,
                        column: 26
                    },
                    end: {
                        line: 24,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 2
                    },
                    end: {
                        line: 25,
                        column: 77
                    }
                },
                line: 25
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 187,
                        column: 49
                    },
                    end: {
                        line: 187,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 227,
                        column: 6
                    },
                    end: {
                        line: 524,
                        column: 1
                    }
                },
                line: 227
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 233,
                        column: 12
                    },
                    end: {
                        line: 233,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 233,
                        column: 18
                    },
                    end: {
                        line: 238,
                        column: 3
                    }
                },
                line: 233
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 261,
                        column: 22
                    },
                    end: {
                        line: 261,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 261,
                        column: 44
                    },
                    end: {
                        line: 264,
                        column: 3
                    }
                },
                line: 261
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 266,
                        column: 28
                    },
                    end: {
                        line: 266,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 266,
                        column: 80
                    },
                    end: {
                        line: 269,
                        column: 3
                    }
                },
                line: 266
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 271,
                        column: 25
                    },
                    end: {
                        line: 271,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 271,
                        column: 76
                    },
                    end: {
                        line: 274,
                        column: 3
                    }
                },
                line: 271
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 277,
                        column: 4
                    },
                    end: {
                        line: 277,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 277,
                        column: 44
                    },
                    end: {
                        line: 283,
                        column: 5
                    }
                },
                line: 277
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 287,
                        column: 41
                    },
                    end: {
                        line: 287,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 287,
                        column: 53
                    },
                    end: {
                        line: 295,
                        column: 3
                    }
                },
                line: 287
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 298,
                        column: 26
                    },
                    end: {
                        line: 298,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 298,
                        column: 33
                    },
                    end: {
                        line: 303,
                        column: 3
                    }
                },
                line: 298
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 305,
                        column: 34
                    },
                    end: {
                        line: 305,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 305,
                        column: 95
                    },
                    end: {
                        line: 311,
                        column: 3
                    }
                },
                line: 305
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 313,
                        column: 12
                    },
                    end: {
                        line: 313,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 313,
                        column: 18
                    },
                    end: {
                        line: 323,
                        column: 3
                    }
                },
                line: 313
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 325,
                        column: 12
                    },
                    end: {
                        line: 325,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 325,
                        column: 18
                    },
                    end: {
                        line: 328,
                        column: 3
                    }
                },
                line: 325
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 332,
                        column: 4
                    },
                    end: {
                        line: 332,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 332,
                        column: 10
                    },
                    end: {
                        line: 340,
                        column: 5
                    }
                },
                line: 332
            },
            "13": {
                name: "(anonymous_13)",
                decl: {
                    start: {
                        line: 364,
                        column: 12
                    },
                    end: {
                        line: 364,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 364,
                        column: 18
                    },
                    end: {
                        line: 373,
                        column: 3
                    }
                },
                line: 364
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 189,
                        column: 2
                    },
                    end: {
                        line: 189,
                        column: 12
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 189,
                            column: 10
                        },
                        end: {
                            line: 189,
                            column: 12
                        }
                    }
                ],
                line: 189
            },
            "1": {
                loc: {
                    start: {
                        line: 190,
                        column: 9
                    },
                    end: {
                        line: 190,
                        column: 26
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 190,
                            column: 24
                        },
                        end: {
                            line: 190,
                            column: 26
                        }
                    }
                ],
                line: 190
            },
            "2": {
                loc: {
                    start: {
                        line: 191,
                        column: 8
                    },
                    end: {
                        line: 191,
                        column: 24
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 191,
                            column: 22
                        },
                        end: {
                            line: 191,
                            column: 24
                        }
                    }
                ],
                line: 191
            },
            "3": {
                loc: {
                    start: {
                        line: 202,
                        column: 2
                    },
                    end: {
                        line: 202,
                        column: 24
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 202,
                            column: 19
                        },
                        end: {
                            line: 202,
                            column: 24
                        }
                    }
                ],
                line: 202
            },
            "4": {
                loc: {
                    start: {
                        line: 208,
                        column: 2
                    },
                    end: {
                        line: 208,
                        column: 27
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 208,
                            column: 22
                        },
                        end: {
                            line: 208,
                            column: 27
                        }
                    }
                ],
                line: 208
            },
            "5": {
                loc: {
                    start: {
                        line: 234,
                        column: 4
                    },
                    end: {
                        line: 237,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 234,
                            column: 4
                        },
                        end: {
                            line: 237,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 234
            },
            "6": {
                loc: {
                    start: {
                        line: 278,
                        column: 6
                    },
                    end: {
                        line: 280,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 278,
                            column: 6
                        },
                        end: {
                            line: 280,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 278
            },
            "7": {
                loc: {
                    start: {
                        line: 288,
                        column: 4
                    },
                    end: {
                        line: 294,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 288,
                            column: 4
                        },
                        end: {
                            line: 294,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 288
            },
            "8": {
                loc: {
                    start: {
                        line: 306,
                        column: 4
                    },
                    end: {
                        line: 308,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 306,
                            column: 4
                        },
                        end: {
                            line: 308,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 306
            },
            "9": {
                loc: {
                    start: {
                        line: 306,
                        column: 8
                    },
                    end: {
                        line: 306,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 306,
                            column: 8
                        },
                        end: {
                            line: 306,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 306,
                            column: 25
                        },
                        end: {
                            line: 306,
                            column: 30
                        }
                    },
                    {
                        start: {
                            line: 306,
                            column: 34
                        },
                        end: {
                            line: 306,
                            column: 46
                        }
                    }
                ],
                line: 306
            },
            "10": {
                loc: {
                    start: {
                        line: 319,
                        column: 4
                    },
                    end: {
                        line: 321,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 319,
                            column: 4
                        },
                        end: {
                            line: 321,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 319
            },
            "11": {
                loc: {
                    start: {
                        line: 333,
                        column: 6
                    },
                    end: {
                        line: 335,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 333,
                            column: 6
                        },
                        end: {
                            line: 335,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 333
            },
            "12": {
                loc: {
                    start: {
                        line: 336,
                        column: 6
                    },
                    end: {
                        line: 339,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 336,
                            column: 6
                        },
                        end: {
                            line: 339,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 336
            },
            "13": {
                loc: {
                    start: {
                        line: 345,
                        column: 32
                    },
                    end: {
                        line: 345,
                        column: 87
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 345,
                            column: 32
                        },
                        end: {
                            line: 345,
                            column: 59
                        }
                    },
                    {
                        start: {
                            line: 345,
                            column: 63
                        },
                        end: {
                            line: 345,
                            column: 87
                        }
                    }
                ],
                line: 345
            },
            "14": {
                loc: {
                    start: {
                        line: 347,
                        column: 28
                    },
                    end: {
                        line: 347,
                        column: 96
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 347,
                            column: 28
                        },
                        end: {
                            line: 347,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 347,
                            column: 37
                        },
                        end: {
                            line: 347,
                            column: 53
                        }
                    },
                    {
                        start: {
                            line: 347,
                            column: 57
                        },
                        end: {
                            line: 347,
                            column: 70
                        }
                    },
                    {
                        start: {
                            line: 347,
                            column: 74
                        },
                        end: {
                            line: 347,
                            column: 96
                        }
                    }
                ],
                line: 347
            },
            "15": {
                loc: {
                    start: {
                        line: 357,
                        column: 4
                    },
                    end: {
                        line: 362,
                        column: 21
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 357,
                            column: 4
                        },
                        end: {
                            line: 357,
                            column: 14
                        }
                    },
                    {
                        start: {
                            line: 358,
                            column: 4
                        },
                        end: {
                            line: 358,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 359,
                            column: 4
                        },
                        end: {
                            line: 359,
                            column: 18
                        }
                    },
                    {
                        start: {
                            line: 360,
                            column: 4
                        },
                        end: {
                            line: 360,
                            column: 26
                        }
                    },
                    {
                        start: {
                            line: 361,
                            column: 4
                        },
                        end: {
                            line: 361,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 362,
                            column: 4
                        },
                        end: {
                            line: 362,
                            column: 21
                        }
                    }
                ],
                line: 357
            },
            "16": {
                loc: {
                    start: {
                        line: 365,
                        column: 4
                    },
                    end: {
                        line: 368,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 365,
                            column: 4
                        },
                        end: {
                            line: 368,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 365
            },
            "17": {
                loc: {
                    start: {
                        line: 370,
                        column: 4
                    },
                    end: {
                        line: 372,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 370,
                            column: 4
                        },
                        end: {
                            line: 372,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 370
            },
            "18": {
                loc: {
                    start: {
                        line: 370,
                        column: 8
                    },
                    end: {
                        line: 370,
                        column: 45
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 370,
                            column: 8
                        },
                        end: {
                            line: 370,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 370,
                            column: 29
                        },
                        end: {
                            line: 370,
                            column: 45
                        }
                    }
                ],
                line: 370
            },
            "19": {
                loc: {
                    start: {
                        line: 375,
                        column: 2
                    },
                    end: {
                        line: 387,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 375,
                            column: 2
                        },
                        end: {
                            line: 387,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 375
            },
            "20": {
                loc: {
                    start: {
                        line: 375,
                        column: 6
                    },
                    end: {
                        line: 375,
                        column: 47
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 375,
                            column: 6
                        },
                        end: {
                            line: 375,
                            column: 23
                        }
                    },
                    {
                        start: {
                            line: 375,
                            column: 27
                        },
                        end: {
                            line: 375,
                            column: 47
                        }
                    }
                ],
                line: 375
            },
            "21": {
                loc: {
                    start: {
                        line: 377,
                        column: 36
                    },
                    end: {
                        line: 377,
                        column: 65
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 377,
                            column: 53
                        },
                        end: {
                            line: 377,
                            column: 59
                        }
                    },
                    {
                        start: {
                            line: 377,
                            column: 62
                        },
                        end: {
                            line: 377,
                            column: 65
                        }
                    }
                ],
                line: 377
            },
            "22": {
                loc: {
                    start: {
                        line: 389,
                        column: 2
                    },
                    end: {
                        line: 397,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 389,
                            column: 2
                        },
                        end: {
                            line: 397,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 389
            },
            "23": {
                loc: {
                    start: {
                        line: 400,
                        column: 25
                    },
                    end: {
                        line: 400,
                        column: 71
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 400,
                            column: 25
                        },
                        end: {
                            line: 400,
                            column: 43
                        }
                    },
                    {
                        start: {
                            line: 400,
                            column: 48
                        },
                        end: {
                            line: 400,
                            column: 61
                        }
                    },
                    {
                        start: {
                            line: 400,
                            column: 65
                        },
                        end: {
                            line: 400,
                            column: 70
                        }
                    }
                ],
                line: 400
            },
            "24": {
                loc: {
                    start: {
                        line: 402,
                        column: 2
                    },
                    end: {
                        line: 413,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 402,
                            column: 2
                        },
                        end: {
                            line: 413,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: 404,
                            column: 9
                        },
                        end: {
                            line: 413,
                            column: 3
                        }
                    }
                ],
                line: 402
            },
            "25": {
                loc: {
                    start: {
                        line: 402,
                        column: 6
                    },
                    end: {
                        line: 402,
                        column: 28
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 402,
                            column: 6
                        },
                        end: {
                            line: 402,
                            column: 19
                        }
                    },
                    {
                        start: {
                            line: 402,
                            column: 23
                        },
                        end: {
                            line: 402,
                            column: 28
                        }
                    }
                ],
                line: 402
            },
            "26": {
                loc: {
                    start: {
                        line: 404,
                        column: 9
                    },
                    end: {
                        line: 413,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 404,
                            column: 9
                        },
                        end: {
                            line: 413,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 404
            },
            "27": {
                loc: {
                    start: {
                        line: 404,
                        column: 13
                    },
                    end: {
                        line: 404,
                        column: 41
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 404,
                            column: 13
                        },
                        end: {
                            line: 404,
                            column: 18
                        }
                    },
                    {
                        start: {
                            line: 404,
                            column: 22
                        },
                        end: {
                            line: 404,
                            column: 41
                        }
                    }
                ],
                line: 404
            },
            "28": {
                loc: {
                    start: {
                        line: 405,
                        column: 4
                    },
                    end: {
                        line: 412,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 405,
                            column: 4
                        },
                        end: {
                            line: 412,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 407,
                            column: 11
                        },
                        end: {
                            line: 412,
                            column: 5
                        }
                    }
                ],
                line: 405
            },
            "29": {
                loc: {
                    start: {
                        line: 407,
                        column: 11
                    },
                    end: {
                        line: 412,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 407,
                            column: 11
                        },
                        end: {
                            line: 412,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 410,
                            column: 11
                        },
                        end: {
                            line: 412,
                            column: 5
                        }
                    }
                ],
                line: 407
            },
            "30": {
                loc: {
                    start: {
                        line: 414,
                        column: 19
                    },
                    end: {
                        line: 414,
                        column: 93
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 414,
                            column: 45
                        },
                        end: {
                            line: 414,
                            column: 60
                        }
                    },
                    {
                        start: {
                            line: 414,
                            column: 63
                        },
                        end: {
                            line: 414,
                            column: 93
                        }
                    }
                ],
                line: 414
            },
            "31": {
                loc: {
                    start: {
                        line: 416,
                        column: 2
                    },
                    end: {
                        line: 421,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 416,
                            column: 2
                        },
                        end: {
                            line: 421,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: 419,
                            column: 9
                        },
                        end: {
                            line: 421,
                            column: 3
                        }
                    }
                ],
                line: 416
            },
            "32": {
                loc: {
                    start: {
                        line: 416,
                        column: 6
                    },
                    end: {
                        line: 416,
                        column: 37
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 416,
                            column: 6
                        },
                        end: {
                            line: 416,
                            column: 23
                        }
                    },
                    {
                        start: {
                            line: 416,
                            column: 27
                        },
                        end: {
                            line: 416,
                            column: 37
                        }
                    }
                ],
                line: 416
            },
            "33": {
                loc: {
                    start: {
                        line: 418,
                        column: 6
                    },
                    end: {
                        line: 418,
                        column: 92
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 418,
                            column: 39
                        },
                        end: {
                            line: 418,
                            column: 61
                        }
                    },
                    {
                        start: {
                            line: 418,
                            column: 64
                        },
                        end: {
                            line: 418,
                            column: 92
                        }
                    }
                ],
                line: 418
            },
            "34": {
                loc: {
                    start: {
                        line: 419,
                        column: 9
                    },
                    end: {
                        line: 421,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 419,
                            column: 9
                        },
                        end: {
                            line: 421,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 419
            },
            "35": {
                loc: {
                    start: {
                        line: 424,
                        column: 34
                    },
                    end: {
                        line: 424,
                        column: 89
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 424,
                            column: 51
                        },
                        end: {
                            line: 424,
                            column: 57
                        }
                    },
                    {
                        start: {
                            line: 424,
                            column: 60
                        },
                        end: {
                            line: 424,
                            column: 89
                        }
                    }
                ],
                line: 424
            },
            "36": {
                loc: {
                    start: {
                        line: 424,
                        column: 60
                    },
                    end: {
                        line: 424,
                        column: 89
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 424,
                            column: 80
                        },
                        end: {
                            line: 424,
                            column: 83
                        }
                    },
                    {
                        start: {
                            line: 424,
                            column: 86
                        },
                        end: {
                            line: 424,
                            column: 89
                        }
                    }
                ],
                line: 424
            },
            "37": {
                loc: {
                    start: {
                        line: 426,
                        column: 7
                    },
                    end: {
                        line: 426,
                        column: 72
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 426,
                            column: 7
                        },
                        end: {
                            line: 426,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 426,
                            column: 21
                        },
                        end: {
                            line: 426,
                            column: 72
                        }
                    }
                ],
                line: 426
            },
            "38": {
                loc: {
                    start: {
                        line: 427,
                        column: 7
                    },
                    end: {
                        line: 429,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 427,
                            column: 7
                        },
                        end: {
                            line: 427,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 427,
                            column: 29
                        },
                        end: {
                            line: 427,
                            column: 67
                        }
                    },
                    {
                        start: {
                            line: 428,
                            column: 8
                        },
                        end: {
                            line: 428,
                            column: 61
                        }
                    }
                ],
                line: 427
            },
            "39": {
                loc: {
                    start: {
                        line: 440,
                        column: 7
                    },
                    end: {
                        line: 448,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 440,
                            column: 7
                        },
                        end: {
                            line: 440,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 440,
                            column: 26
                        },
                        end: {
                            line: 440,
                            column: 44
                        }
                    },
                    {
                        start: {
                            line: 440,
                            column: 48
                        },
                        end: {
                            line: 440,
                            column: 86
                        }
                    },
                    {
                        start: {
                            line: 441,
                            column: 8
                        },
                        end: {
                            line: 447,
                            column: 14
                        }
                    }
                ],
                line: 440
            },
            "40": {
                loc: {
                    start: {
                        line: 444,
                        column: 21
                    },
                    end: {
                        line: 444,
                        column: 95
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 444,
                            column: 85
                        },
                        end: {
                            line: 444,
                            column: 91
                        }
                    },
                    {
                        start: {
                            line: 444,
                            column: 94
                        },
                        end: {
                            line: 444,
                            column: 95
                        }
                    }
                ],
                line: 444
            },
            "41": {
                loc: {
                    start: {
                        line: 444,
                        column: 21
                    },
                    end: {
                        line: 444,
                        column: 82
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 444,
                            column: 21
                        },
                        end: {
                            line: 444,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 444,
                            column: 35
                        },
                        end: {
                            line: 444,
                            column: 53
                        }
                    },
                    {
                        start: {
                            line: 444,
                            column: 57
                        },
                        end: {
                            line: 444,
                            column: 82
                        }
                    }
                ],
                line: 444
            },
            "42": {
                loc: {
                    start: {
                        line: 449,
                        column: 7
                    },
                    end: {
                        line: 451,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 449,
                            column: 7
                        },
                        end: {
                            line: 449,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 450,
                            column: 8
                        },
                        end: {
                            line: 450,
                            column: 89
                        }
                    }
                ],
                line: 449
            },
            "43": {
                loc: {
                    start: {
                        line: 452,
                        column: 7
                    },
                    end: {
                        line: 470,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 452,
                            column: 7
                        },
                        end: {
                            line: 452,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 452,
                            column: 26
                        },
                        end: {
                            line: 452,
                            column: 44
                        }
                    },
                    {
                        start: {
                            line: 452,
                            column: 48
                        },
                        end: {
                            line: 452,
                            column: 86
                        }
                    },
                    {
                        start: {
                            line: 453,
                            column: 8
                        },
                        end: {
                            line: 469,
                            column: 14
                        }
                    }
                ],
                line: 452
            },
            "44": {
                loc: {
                    start: {
                        line: 472,
                        column: 9
                    },
                    end: {
                        line: 520,
                        column: 9
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 473,
                            column: 10
                        },
                        end: {
                            line: 501,
                            column: 12
                        }
                    },
                    {
                        start: {
                            line: 503,
                            column: 10
                        },
                        end: {
                            line: 519,
                            column: 16
                        }
                    }
                ],
                line: 472
            },
            "45": {
                loc: {
                    start: {
                        line: 472,
                        column: 9
                    },
                    end: {
                        line: 472,
                        column: 47
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 472,
                            column: 9
                        },
                        end: {
                            line: 472,
                            column: 26
                        }
                    },
                    {
                        start: {
                            line: 472,
                            column: 30
                        },
                        end: {
                            line: 472,
                            column: 47
                        }
                    }
                ],
                line: 472
            },
            "46": {
                loc: {
                    start: {
                        line: 483,
                        column: 38
                    },
                    end: {
                        line: 483,
                        column: 69
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 483,
                            column: 38
                        },
                        end: {
                            line: 483,
                            column: 60
                        }
                    },
                    {
                        start: {
                            line: 483,
                            column: 64
                        },
                        end: {
                            line: 483,
                            column: 69
                        }
                    }
                ],
                line: 483
            },
            "47": {
                loc: {
                    start: {
                        line: 486,
                        column: 35
                    },
                    end: {
                        line: 486,
                        column: 78
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 486,
                            column: 35
                        },
                        end: {
                            line: 486,
                            column: 46
                        }
                    },
                    {
                        start: {
                            line: 486,
                            column: 50
                        },
                        end: {
                            line: 486,
                            column: 78
                        }
                    }
                ],
                line: 486
            },
            "48": {
                loc: {
                    start: {
                        line: 491,
                        column: 33
                    },
                    end: {
                        line: 491,
                        column: 79
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 491,
                            column: 55
                        },
                        end: {
                            line: 491,
                            column: 74
                        }
                    },
                    {
                        start: {
                            line: 491,
                            column: 77
                        },
                        end: {
                            line: 491,
                            column: 79
                        }
                    }
                ],
                line: 491
            },
            "49": {
                loc: {
                    start: {
                        line: 492,
                        column: 27
                    },
                    end: {
                        line: 492,
                        column: 70
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 492,
                            column: 43
                        },
                        end: {
                            line: 492,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 492,
                            column: 59
                        },
                        end: {
                            line: 492,
                            column: 70
                        }
                    }
                ],
                line: 492
            },
            "50": {
                loc: {
                    start: {
                        line: 516,
                        column: 13
                    },
                    end: {
                        line: 518,
                        column: 13
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 516,
                            column: 13
                        },
                        end: {
                            line: 516,
                            column: 51
                        }
                    },
                    {
                        start: {
                            line: 517,
                            column: 14
                        },
                        end: {
                            line: 517,
                            column: 67
                        }
                    }
                ],
                line: 516
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0,
            "64": 0,
            "65": 0,
            "66": 0,
            "67": 0,
            "68": 0,
            "69": 0,
            "70": 0,
            "71": 0,
            "72": 0,
            "73": 0,
            "74": 0,
            "75": 0,
            "76": 0,
            "77": 0,
            "78": 0,
            "79": 0,
            "80": 0,
            "81": 0,
            "82": 0,
            "83": 0,
            "84": 0,
            "85": 0,
            "86": 0,
            "87": 0,
            "88": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0
            ],
            "3": [
                0
            ],
            "4": [
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0,
                0,
                0
            ],
            "15": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "16": [
                0,
                0
            ],
            "17": [
                0,
                0
            ],
            "18": [
                0,
                0
            ],
            "19": [
                0,
                0
            ],
            "20": [
                0,
                0
            ],
            "21": [
                0,
                0
            ],
            "22": [
                0,
                0
            ],
            "23": [
                0,
                0,
                0
            ],
            "24": [
                0,
                0
            ],
            "25": [
                0,
                0
            ],
            "26": [
                0,
                0
            ],
            "27": [
                0,
                0
            ],
            "28": [
                0,
                0
            ],
            "29": [
                0,
                0
            ],
            "30": [
                0,
                0
            ],
            "31": [
                0,
                0
            ],
            "32": [
                0,
                0
            ],
            "33": [
                0,
                0
            ],
            "34": [
                0,
                0
            ],
            "35": [
                0,
                0
            ],
            "36": [
                0,
                0
            ],
            "37": [
                0,
                0
            ],
            "38": [
                0,
                0,
                0
            ],
            "39": [
                0,
                0,
                0,
                0
            ],
            "40": [
                0,
                0
            ],
            "41": [
                0,
                0,
                0
            ],
            "42": [
                0,
                0
            ],
            "43": [
                0,
                0,
                0,
                0
            ],
            "44": [
                0,
                0
            ],
            "45": [
                0,
                0
            ],
            "46": [
                0,
                0
            ],
            "47": [
                0,
                0
            ],
            "48": [
                0,
                0
            ],
            "49": [
                0,
                0
            ],
            "50": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "1be7294a31d8380e2ef1dafdb6f9c804b8101968"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_243c6bebk2 = function cov_243c6bebk2() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_243c6bebk2();
function AccountForm_regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_instanceof/* default */.Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return AccountForm_regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, AccountForm_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (AccountForm_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, AccountForm_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), AccountForm_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", AccountForm_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), AccountForm_regeneratorDefine2(u), AccountForm_regeneratorDefine2(u, o, "Generator"), AccountForm_regeneratorDefine2(u, n, function() {
        return this;
    }), AccountForm_regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (AccountForm_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function AccountForm_regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    AccountForm_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            AccountForm_regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, AccountForm_regeneratorDefine2(e, r, n, t);
}
function AccountForm_asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function AccountForm_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                AccountForm_asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                AccountForm_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function AccountForm_slicedToArray(r, e) {
    return AccountForm_arrayWithHoles(r) || AccountForm_iterableToArrayLimit(r, e) || AccountForm_unsupportedIterableToArray(r, e) || AccountForm_nonIterableRest();
}
function AccountForm_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AccountForm_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return AccountForm_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? AccountForm_arrayLikeToArray(r, a) : void 0;
    }
}
function AccountForm_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function AccountForm_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function AccountForm_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}



function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}













// Simple Divider component to replace legacy Bricks Divider
cov_243c6bebk2().s[0]++;
var Divider = function Divider() {
    cov_243c6bebk2().f[0]++;
    cov_243c6bebk2().s[1]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        height: 1,
        backgroundColor: "$borderSecondary",
        width: "100%",
        my: "$4x"
    });
};
/**
 * @deprecated Legacy interface for custom input components. Use bricks-next form components directly instead.
 * This interface is maintained for backward compatibility with Reception-FE only.
 */ /**
 * @deprecated Legacy interface for custom input component types. Use bricks-next form components directly instead.
 * This interface is maintained for backward compatibility with Reception-FE only.
 */ cov_243c6bebk2().s[2]++;
var AccountForm = function AccountForm(_ref) {
    var _ref19;
    var analyticsName = _ref.analyticsName, _ref$phone = _ref.phone, phone = _ref$phone === void 0 ? (cov_243c6bebk2().b[0][0]++, "") : _ref$phone, _ref$email = _ref.email, initialEmail = _ref$email === void 0 ? (cov_243c6bebk2().b[1][0]++, "") : _ref$email, _ref$name = _ref.name, initialName = _ref$name === void 0 ? (cov_243c6bebk2().b[2][0]++, "") : _ref$name, loginHeaderText = _ref.loginHeaderText, registrationHeaderText = _ref.registrationHeaderText, loginSubHeaderText = _ref.loginSubHeaderText, registrationSubHeaderText = _ref.registrationSubHeaderText, emailLoading = _ref.emailLoading, passwordLoading = _ref.passwordLoading, error = _ref.error, phoneNumberInputOptional = _ref.phoneNumberInputOptional, phoneNumberInputHidden = _ref.phoneNumberInputHidden, openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab, _ref$showGoogleAuth = _ref.showGoogleAuth, showGoogleAuth = _ref$showGoogleAuth === void 0 ? (cov_243c6bebk2().b[3][0]++, false) : _ref$showGoogleAuth, overrideHasSubmittedEmailCheckForLogin = _ref.overrideHasSubmittedEmailCheckForLogin, emailMismatch = _ref.emailMismatch, customEmailValidityCheck = _ref.customEmailValidityCheck, customEmailValidityCheckDelay = _ref.customEmailValidityCheckDelay, requestResetPassword = _ref.requestResetPassword, _ref$hidePasswordFiel = _ref.hidePasswordField, hidePasswordField = _ref$hidePasswordFiel === void 0 ? (cov_243c6bebk2().b[4][0]++, false) : _ref$hidePasswordFiel, onPasswordlessLoginRequest = _ref.onPasswordlessLoginRequest, onboardingAccountPageCTA = _ref.onboardingAccountPageCTA, fullNamePlaceholder = _ref.fullNamePlaceholder, fullNameLabel = _ref.fullNameLabel, disclaimerProps = _ref.disclaimerProps, passwordFormActionText = _ref.passwordFormActionText, onHumanStatusRequest = _ref.onHumanStatusRequest, onLogin = _ref.onLogin, onRegister = _ref.onRegister, postEmailCtaSection = _ref.postEmailCtaSection, unsetContainer = _ref.unsetContainer, fullNameOptional = _ref.fullNameOptional, fullNameHidden = _ref.fullNameHidden, EmailInput = _ref.EmailInput, PasswordInput = _ref.PasswordInput, NameInput = _ref.NameInput, PhoneInput = _ref.PhoneInput, props = _objectWithoutProperties(_ref, _excluded);
    cov_243c6bebk2().f[1]++;
    var _ref2 = (cov_243c6bebk2().s[3]++, (0,react.useState)(initialEmail)), _ref3 = AccountForm_slicedToArray(_ref2, 2), email = _ref3[0], setEmail = _ref3[1];
    var emailInputRef = (cov_243c6bebk2().s[4]++, (0,react.useRef)(null));
    var passwordInputRef = (cov_243c6bebk2().s[5]++, (0,react.useRef)(null));
    cov_243c6bebk2().s[6]++;
    (0,react.useEffect)(function() {
        cov_243c6bebk2().f[2]++;
        cov_243c6bebk2().s[7]++;
        if (emailInputRef.current) {
            cov_243c6bebk2().b[5][0]++;
            var emailInput = (cov_243c6bebk2().s[8]++, emailInputRef.current);
            cov_243c6bebk2().s[9]++;
            emailInput.focus();
        } else {
            cov_243c6bebk2().b[5][1]++;
        }
    }, []);
    var _ref4 = (cov_243c6bebk2().s[10]++, (0,react.useState)(initialName)), _ref5 = AccountForm_slicedToArray(_ref4, 2), name = _ref5[0], setName = _ref5[1];
    //Login States
    var _ref6 = (cov_243c6bebk2().s[11]++, (0,react.useState)(props.isNewHuman)), _ref7 = AccountForm_slicedToArray(_ref6, 2), isNewHuman = _ref7[0], setIsNewHuman = _ref7[1];
    var _ref8 = (cov_243c6bebk2().s[12]++, (0,react.useState)(props.hasGeneratedPassword)), _ref9 = AccountForm_slicedToArray(_ref8, 2), hasGeneratedPassword = _ref9[0], setHasGeneratedPassword = _ref9[1];
    var _ref0 = (cov_243c6bebk2().s[13]++, (0,react.useState)(false)), _ref1 = AccountForm_slicedToArray(_ref0, 2), googleLoginAttempt = _ref1[0], setGoogleLoginAttempt = _ref1[1];
    var _ref10 = (cov_243c6bebk2().s[14]++, (0,react.useState)(false)), _ref11 = AccountForm_slicedToArray(_ref10, 2), isRequestingPasswordlessLogin = _ref11[0], setIsRequestingPasswordlessLogin = _ref11[1];
    var _ref12 = (cov_243c6bebk2().s[15]++, (0,react.useState)()), _ref13 = AccountForm_slicedToArray(_ref12, 2), hasPasswordlessLoginRequestSucceeded = _ref13[0], setHasPasswordlessLogingRequestSucceeded = _ref13[1];
    var _ref14 = (cov_243c6bebk2().s[16]++, (0,react.useContext)(NamelessAccountContext)), shouldRegisterOnEmailSubmit = _ref14.shouldRegisterOnEmailSubmit, emailRegistrationError = _ref14.emailRegistrationError, onAccountUpdate = _ref14.onAccountUpdate;
    cov_243c6bebk2().s[17]++;
    var handleLogin = function handleLogin(password) {
        cov_243c6bebk2().f[3]++;
        cov_243c6bebk2().s[18]++;
        setGoogleLoginAttempt(false);
        cov_243c6bebk2().s[19]++;
        onLogin(email, password);
    };
    cov_243c6bebk2().s[20]++;
    var handleGoogleLogin = /*#__PURE__*/ function() {
        var _ref15 = AccountForm_asyncToGenerator(/*#__PURE__*/ AccountForm_regenerator().m(function _callee(googleLoginResponse) {
            return AccountForm_regenerator().w(function(_context) {
                while(1)switch(_context.n){
                    case 0:
                        cov_243c6bebk2().f[4]++;
                        cov_243c6bebk2().s[21]++;
                        setGoogleLoginAttempt(true);
                        cov_243c6bebk2().s[22]++;
                        onRegister(null, null, null, null, googleLoginResponse.tokenId);
                    case 1:
                        return _context.a(2);
                }
            }, _callee);
        }));
        return function handleGoogleLogin(_x) {
            return _ref15.apply(this, arguments);
        };
    }();
    cov_243c6bebk2().s[23]++;
    var handleRegister = function handleRegister(password, name, phone) {
        cov_243c6bebk2().f[5]++;
        cov_243c6bebk2().s[24]++;
        setGoogleLoginAttempt(false);
        cov_243c6bebk2().s[25]++;
        onRegister(email, name, password, phone);
    };
    var handleEmailSubmit = (cov_243c6bebk2().s[26]++, (0,react.useCallback)(/*#__PURE__*/ function() {
        var _ref16 = AccountForm_asyncToGenerator(/*#__PURE__*/ AccountForm_regenerator().m(function _callee2(email, name) {
            return AccountForm_regenerator().w(function(_context2) {
                while(1)switch(_context2.n){
                    case 0:
                        cov_243c6bebk2().f[6]++;
                        cov_243c6bebk2().s[27]++;
                        if (!onHumanStatusRequest) {
                            _context2.n = 2;
                            break;
                        }
                        cov_243c6bebk2().b[6][0]++;
                        cov_243c6bebk2().s[28]++;
                        _context2.n = 1;
                        return onHumanStatusRequest(email, name);
                    case 1:
                        _context2.n = 3;
                        break;
                    case 2:
                        cov_243c6bebk2().b[6][1]++;
                    case 3:
                        cov_243c6bebk2().s[29]++;
                        setEmail(email);
                        cov_243c6bebk2().s[30]++;
                        setName(name);
                    case 4:
                        return _context2.a(2);
                }
            }, _callee2);
        }));
        return function(_x2, _x3) {
            return _ref16.apply(this, arguments);
        };
    }(), [
        onHumanStatusRequest
    ]));
    cov_243c6bebk2().s[31]++;
    var handleRequestPasswordlessLogin = /*#__PURE__*/ function() {
        var _ref17 = AccountForm_asyncToGenerator(/*#__PURE__*/ AccountForm_regenerator().m(function _callee3() {
            var _ref18, success;
            return AccountForm_regenerator().w(function(_context3) {
                while(1)switch(_context3.n){
                    case 0:
                        cov_243c6bebk2().f[7]++;
                        cov_243c6bebk2().s[32]++;
                        if (!onPasswordlessLoginRequest) {
                            _context3.n = 2;
                            break;
                        }
                        cov_243c6bebk2().b[7][0]++;
                        cov_243c6bebk2().s[33]++;
                        setIsRequestingPasswordlessLogin(true);
                        cov_243c6bebk2().s[34]++;
                        _context3.n = 1;
                        return onPasswordlessLoginRequest(email);
                    case 1:
                        _ref18 = _context3.v;
                        success = _ref18.success;
                        cov_243c6bebk2().s[35]++;
                        setIsRequestingPasswordlessLogin(false);
                        cov_243c6bebk2().s[36]++;
                        setHasPasswordlessLogingRequestSucceeded(!!success);
                        _context3.n = 3;
                        break;
                    case 2:
                        cov_243c6bebk2().b[7][1]++;
                    case 3:
                        return _context3.a(2);
                }
            }, _callee3);
        }));
        return function handleRequestPasswordlessLogin() {
            return _ref17.apply(this, arguments);
        };
    }();
    // Toggles to the email request view and allows user to change the email being used to log in
    cov_243c6bebk2().s[37]++;
    var resetValidEmail = function resetValidEmail(e) {
        cov_243c6bebk2().f[8]++;
        cov_243c6bebk2().s[38]++;
        e === null || e === void 0 || e.preventDefault();
        cov_243c6bebk2().s[39]++;
        setEmail("");
        cov_243c6bebk2().s[40]++;
        setHasGeneratedPassword(false);
        cov_243c6bebk2().s[41]++;
        setIsNewHuman(false);
    };
    cov_243c6bebk2().s[42]++;
    var socialLoginErrorMessage = function socialLoginErrorMessage(provider, emailMismatch, email) {
        cov_243c6bebk2().f[9]++;
        cov_243c6bebk2().s[43]++;
        if ((cov_243c6bebk2().b[9][0]++, emailMismatch) && (cov_243c6bebk2().b[9][1]++, email) && (cov_243c6bebk2().b[9][2]++, email !== "")) {
            cov_243c6bebk2().b[8][0]++;
            cov_243c6bebk2().s[44]++;
            return "You tried to sign in with an email that isn’t associated with this home address. Please sign in again with ".concat(email, ".");
        } else {
            cov_243c6bebk2().b[8][1]++;
        }
        cov_243c6bebk2().s[45]++;
        return "".concat(provider, " authorization failed. Please try again or use the general login.");
    };
    cov_243c6bebk2().s[46]++;
    (0,react.useEffect)(function() {
        cov_243c6bebk2().f[10]++;
        cov_243c6bebk2().s[47]++;
        setEmail(initialEmail);
        /**
     * If an email was passed check its status so that we can know whether to show
     * the log in or sign up page
     */ cov_243c6bebk2().s[48]++;
        if (initialEmail) {
            cov_243c6bebk2().b[10][0]++;
            cov_243c6bebk2().s[49]++;
            handleEmailSubmit(initialEmail);
        } else {
            cov_243c6bebk2().b[10][1]++;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //Making sure to only call on onmount with the initial Email
    cov_243c6bebk2().s[50]++;
    (0,react.useEffect)(function() {
        cov_243c6bebk2().f[11]++;
        cov_243c6bebk2().s[51]++;
        setIsNewHuman(!!props.isNewHuman);
        cov_243c6bebk2().s[52]++;
        setHasGeneratedPassword(props.hasGeneratedPassword);
    }, [
        props.hasGeneratedPassword,
        props.isNewHuman
    ]);
    var updatingIsNewHuman = (cov_243c6bebk2().s[53]++, (0,react.useRef)(false));
    cov_243c6bebk2().s[54]++;
    (0,react.useEffect)(function() {
        cov_243c6bebk2().f[12]++;
        cov_243c6bebk2().s[55]++;
        if (props.hasGeneratedPassword !== hasGeneratedPassword) {
            cov_243c6bebk2().b[11][0]++;
            cov_243c6bebk2().s[56]++;
            setHasGeneratedPassword(!!props.hasGeneratedPassword);
        } else {
            cov_243c6bebk2().b[11][1]++;
        }
        cov_243c6bebk2().s[57]++;
        if (props.isNewHuman !== isNewHuman) {
            cov_243c6bebk2().b[12][0]++;
            cov_243c6bebk2().s[58]++;
            setIsNewHuman(!!props.isNewHuman);
            cov_243c6bebk2().s[59]++;
            updatingIsNewHuman.current = true;
        } else {
            cov_243c6bebk2().b[12][1]++;
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        initialEmail,
        props.hasGeneratedPassword,
        props.isNewHuman
    ]);
    var hasEmailRegisterError = (cov_243c6bebk2().s[60]++, (cov_243c6bebk2().b[13][0]++, shouldRegisterOnEmailSubmit) && (cov_243c6bebk2().b[13][1]++, !!emailRegistrationError));
    var hasSubmittedEmail = (cov_243c6bebk2().s[61]++, (cov_243c6bebk2().b[14][0]++, email) && (cov_243c6bebk2().b[14][1]++, email.length > 0) && (cov_243c6bebk2().b[14][2]++, !emailLoading) && (cov_243c6bebk2().b[14][3]++, !hasEmailRegisterError));
    // This logic allows skipping the password page in cases where an onAccountUpdate method is configured
    // using the NamelessAccountContext, all password page fields are hidden, and the account is for a new
    // human. Due to the way the isNewHuman state is maintained, an additional check must be performed to
    // make sure we don't invoke the callback before the state in this component is updated after the email
    // is entered and onHumanStatusRequest is invoked to actually update the isNewHuman state via a prop.
    // Note that we are not using onRegister because onRegister requires a password, and thus we wouldn't
    // be skipping the password page.
    var skipPasswordPage = (cov_243c6bebk2().s[62]++, (cov_243c6bebk2().b[15][0]++, isNewHuman) && (cov_243c6bebk2().b[15][1]++, hidePasswordField) && (cov_243c6bebk2().b[15][2]++, fullNameHidden) && (cov_243c6bebk2().b[15][3]++, phoneNumberInputHidden) && (cov_243c6bebk2().b[15][4]++, shouldRegisterOnEmailSubmit) && (cov_243c6bebk2().b[15][5]++, !!onAccountUpdate));
    cov_243c6bebk2().s[63]++;
    (0,react.useEffect)(function() {
        cov_243c6bebk2().f[13]++;
        cov_243c6bebk2().s[64]++;
        if (updatingIsNewHuman.current) {
            cov_243c6bebk2().b[16][0]++;
            cov_243c6bebk2().s[65]++;
            updatingIsNewHuman.current = false;
            cov_243c6bebk2().s[66]++;
            return;
        } else {
            cov_243c6bebk2().b[16][1]++;
        }
        cov_243c6bebk2().s[67]++;
        if ((cov_243c6bebk2().b[18][0]++, hasSubmittedEmail) && (cov_243c6bebk2().b[18][1]++, skipPasswordPage)) {
            cov_243c6bebk2().b[17][0]++;
            cov_243c6bebk2().s[68]++;
            onAccountUpdate(name, phone, false);
        } else {
            cov_243c6bebk2().b[17][1]++;
        }
    }, [
        hasSubmittedEmail,
        name,
        onAccountUpdate,
        phone,
        skipPasswordPage
    ]);
    cov_243c6bebk2().s[69]++;
    if ((cov_243c6bebk2().b[20][0]++, hasSubmittedEmail) && (cov_243c6bebk2().b[20][1]++, hasGeneratedPassword)) {
        cov_243c6bebk2().b[19][0]++;
        cov_243c6bebk2().s[70]++;
        return /*#__PURE__*/ react.createElement(shared/* AccountFormWrapper */.OR, {
            maxWidth: unsetContainer ? (cov_243c6bebk2().b[21][0]++, "100%") : (cov_243c6bebk2().b[21][1]++, 480)
        }, /*#__PURE__*/ react.createElement(CheckEmailForm/* default */.Z, {
            analyticsName: analyticsName,
            email: email,
            hasGeneratedPassword: hasGeneratedPassword,
            onResetValidEmail: resetValidEmail,
            requestResetPassword: requestResetPassword
        }));
    } else {
        cov_243c6bebk2().b[19][1]++;
    }
    cov_243c6bebk2().s[71]++;
    if (hasPasswordlessLoginRequestSucceeded !== undefined) {
        cov_243c6bebk2().b[22][0]++;
        cov_243c6bebk2().s[72]++;
        return /*#__PURE__*/ react.createElement(auth_PasswordlessResultPage, {
            hasSucceeded: hasPasswordlessLoginRequestSucceeded,
            email: email,
            analyticsName: analyticsName
        });
    } else {
        cov_243c6bebk2().b[22][1]++;
    }
    // TODO: Clean up error handling
    var hasGoogleError = (cov_243c6bebk2().s[73]++, (cov_243c6bebk2().b[23][0]++, googleLoginAttempt) && ((cov_243c6bebk2().b[23][1]++, emailMismatch) || (cov_243c6bebk2().b[23][2]++, error)));
    var loginErrorMessage = (cov_243c6bebk2().s[74]++, "");
    cov_243c6bebk2().s[75]++;
    if ((cov_243c6bebk2().b[25][0]++, emailMismatch) && (cov_243c6bebk2().b[25][1]++, email)) {
        cov_243c6bebk2().b[24][0]++;
        cov_243c6bebk2().s[76]++;
        loginErrorMessage = "You are logged in with an email that isn’t associated with this home address. Please sign in again with ".concat(email, ".");
    } else {
        cov_243c6bebk2().b[24][1]++;
        cov_243c6bebk2().s[77]++;
        if ((cov_243c6bebk2().b[27][0]++, error) && (cov_243c6bebk2().b[27][1]++, !googleLoginAttempt)) {
            cov_243c6bebk2().b[26][0]++;
            cov_243c6bebk2().s[78]++;
            if (error.includes("You have one more attempt before your account is locked.")) {
                cov_243c6bebk2().b[28][0]++;
                cov_243c6bebk2().s[79]++;
                loginErrorMessage = "You’ll be locked out after this failed attempt.";
            } else {
                cov_243c6bebk2().b[28][1]++;
                cov_243c6bebk2().s[80]++;
                if (error.includes("Your account is locked.")) {
                    cov_243c6bebk2().b[29][0]++;
                    cov_243c6bebk2().s[81]++;
                    loginErrorMessage = "You’re locked out of your account due to the number of failed password attempts. Check your email to reset your password or try again in 1 hour.";
                } else {
                    cov_243c6bebk2().b[29][1]++;
                    cov_243c6bebk2().s[82]++;
                    loginErrorMessage = "Invalid email or password";
                }
            }
        } else {
            cov_243c6bebk2().b[26][1]++;
        }
    }
    var headerText = (cov_243c6bebk2().s[83]++, loginHeaderText != null ? (cov_243c6bebk2().b[30][0]++, loginHeaderText) : (cov_243c6bebk2().b[30][1]++, "Sign in or create an account"));
    cov_243c6bebk2().s[84]++;
    if ((cov_243c6bebk2().b[32][0]++, hasSubmittedEmail) && (cov_243c6bebk2().b[32][1]++, isNewHuman)) {
        cov_243c6bebk2().b[31][0]++;
        cov_243c6bebk2().s[85]++;
        headerText = registrationHeaderText != null ? (cov_243c6bebk2().b[33][0]++, registrationHeaderText) : (cov_243c6bebk2().b[33][1]++, "Finish creating an account");
    } else {
        cov_243c6bebk2().b[31][1]++;
        cov_243c6bebk2().s[86]++;
        if (hasSubmittedEmail) {
            cov_243c6bebk2().b[34][0]++;
            cov_243c6bebk2().s[87]++;
            headerText = "Welcome back";
        } else {
            cov_243c6bebk2().b[34][1]++;
        }
    }
    cov_243c6bebk2().s[88]++;
    return /*#__PURE__*/ react.createElement(shared/* AccountFormWrapper */.OR, {
        maxWidth: unsetContainer ? (cov_243c6bebk2().b[35][0]++, "100%") : (cov_243c6bebk2().b[35][1]++, hasSubmittedEmail ? (cov_243c6bebk2().b[36][0]++, 560) : (cov_243c6bebk2().b[36][1]++, 400))
    }, (cov_243c6bebk2().b[37][0]++, headerText) && (cov_243c6bebk2().b[37][1]++, /*#__PURE__*/ react.createElement(shared/* AccountFormHeader */.N4, null, headerText)), (cov_243c6bebk2().b[38][0]++, !hasSubmittedEmail) && (cov_243c6bebk2().b[38][1]++, (disclaimerProps === null || disclaimerProps === void 0 ? void 0 : disclaimerProps.location) !== "bottom") && (cov_243c6bebk2().b[38][2]++, /*#__PURE__*/ react.createElement(shared/* EmailDisclaimerText */.lX, {
        analyticsName: analyticsName
    })), /*#__PURE__*/ react.createElement(auth_AccountFormSubHeader, {
        isNewHuman: isNewHuman,
        email: email,
        hasSubmittedEmail: hasSubmittedEmail,
        loginSubHeaderText: loginSubHeaderText,
        registrationSubHeaderText: registrationSubHeaderText,
        onValidEmailReset: resetValidEmail,
        hidePasswordField: hidePasswordField,
        phoneNumberInputHidden: phoneNumberInputHidden
    }), (cov_243c6bebk2().b[39][0]++, showGoogleAuth) && ((cov_243c6bebk2().b[39][1]++, !hasSubmittedEmail) || (cov_243c6bebk2().b[39][2]++, overrideHasSubmittedEmailCheckForLogin)) && (cov_243c6bebk2().b[39][3]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        justifyContent: "center",
        alignItems: "center",
        marginTop: (cov_243c6bebk2().b[41][0]++, headerText) || (cov_243c6bebk2().b[41][1]++, loginSubHeaderText) || (cov_243c6bebk2().b[41][2]++, registrationSubHeaderText) ? (cov_243c6bebk2().b[40][0]++, "$20x") : (cov_243c6bebk2().b[40][1]++, 0)
    }, /*#__PURE__*/ react.createElement(GoogleAuth, {
        onAuthed: handleGoogleLogin
    }))), (cov_243c6bebk2().b[42][0]++, hasGoogleError) && (cov_243c6bebk2().b[42][1]++, /*#__PURE__*/ react.createElement(ErrorPrompt, {
        message: socialLoginErrorMessage("Google", emailMismatch, email)
    })), (cov_243c6bebk2().b[43][0]++, showGoogleAuth) && ((cov_243c6bebk2().b[43][1]++, !hasSubmittedEmail) || (cov_243c6bebk2().b[43][2]++, overrideHasSubmittedEmailCheckForLogin)) && (cov_243c6bebk2().b[43][3]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$4x",
        marginTop: "$20x",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flex: 1
    }, /*#__PURE__*/ react.createElement(Divider, null)), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$bodyMedium",
        tag: "p",
        color: "$contentTertiary",
        paddingHorizontal: 7
    }, "or"), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flex: 1
    }, /*#__PURE__*/ react.createElement(Divider, null)))), /*#__PURE__*/ react.createElement(shared/* FormWrapper */.n5, {
        marginTop: "$20x"
    }, (cov_243c6bebk2().b[45][0]++, hasSubmittedEmail) && (cov_243c6bebk2().b[45][1]++, !skipPasswordPage) ? (cov_243c6bebk2().b[44][0]++, /*#__PURE__*/ react.createElement(auth_AccountPasswordForm, {
        analyticsName: analyticsName,
        email: email,
        name: name,
        phone: phone,
        loading: passwordLoading,
        isNewHuman: isNewHuman,
        loginError: loginErrorMessage,
        onLogin: handleLogin,
        onRegister: handleRegister,
        phoneNumberInputOptional: (_ref19 = (cov_243c6bebk2().b[46][0]++, phoneNumberInputHidden)) !== null && _ref19 !== void 0 ? _ref19 : (cov_243c6bebk2().b[46][1]++, false),
        phoneNumberInputHidden: phoneNumberInputHidden,
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        showPasswordlessLogin: (cov_243c6bebk2().b[47][0]++, !isNewHuman) && (cov_243c6bebk2().b[47][1]++, !!onPasswordlessLoginRequest),
        onRequestPasswordlessLogin: handleRequestPasswordlessLogin,
        isRequestingPasswordlessLogin: isRequestingPasswordlessLogin,
        hidePasswordField: hidePasswordField,
        onboardingAccountPageCTA: onboardingAccountPageCTA,
        fullNamePlaceholder: fullNamePlaceholder ? (cov_243c6bebk2().b[48][0]++, fullNamePlaceholder) : (cov_243c6bebk2().b[48][1]++, ""),
        fullNameLabel: fullNameLabel ? (cov_243c6bebk2().b[49][0]++, fullNameLabel) : (cov_243c6bebk2().b[49][1]++, "Full name"),
        disclaimerProps: disclaimerProps,
        ref: passwordInputRef,
        passwordFormActionText: passwordFormActionText,
        fullNameOptional: fullNameOptional,
        fullNameHidden: fullNameHidden,
        CustomPasswordInput: PasswordInput,
        CustomNameInput: NameInput,
        CustomPhoneInput: PhoneInput
    })) : (cov_243c6bebk2().b[44][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$12x"
    }, /*#__PURE__*/ react.createElement(auth_AccountEmailForm, {
        analyticsName: analyticsName,
        email: email,
        ref: emailInputRef,
        loading: emailLoading,
        onSubmit: handleEmailSubmit,
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        customEmailValidityCheck: customEmailValidityCheck,
        customEmailValidityCheckDelay: customEmailValidityCheckDelay,
        showForgotPassword: !hidePasswordField,
        CustomEmailInput: EmailInput
    }), (cov_243c6bebk2().b[50][0]++, (disclaimerProps === null || disclaimerProps === void 0 ? void 0 : disclaimerProps.location) === "bottom") && (cov_243c6bebk2().b[50][1]++, /*#__PURE__*/ react.createElement(shared/* EmailDisclaimerText */.lX, {
        analyticsName: analyticsName
    }))))));
};
/* harmony default export */ var auth_AccountForm = (AccountForm); //# sourceMappingURL=AccountForm.mjs.map


/***/ }),

/***/ 62566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ AccountFormControls; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46523);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25923);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22470);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);





var AccountFormControls = function(param) {
    var analyticsName = param.analyticsName, loading = param.loading, _onRequestPasswordlessLogin = param.onRequestPasswordlessLogin, isRequestingPasswordlessLogin = param.isRequestingPasswordlessLogin, disabled = param.disabled, _actionText = param.actionText, actionText = _actionText === void 0 ? "Confirm" : _actionText, _showForgotPassword = param.showForgotPassword, showForgotPassword = _showForgotPassword === void 0 ? !0 : _showForgotPassword, openForgotPasswordInNewTab = param.openForgotPasswordInNewTab, _forgotPasswordText = param.forgotPasswordText, forgotPasswordText = _forgotPasswordText === void 0 ? "Forgot password?" : _forgotPasswordText, _forgotPasswordAriaNewWindow = param.forgotPasswordAriaNewWindow, forgotPasswordAriaNewWindow = _forgotPasswordAriaNewWindow === void 0 ? "Forgot password? Opens in a new window" : _forgotPasswordAriaNewWindow, _forgotPasswordAriaSameWindow = param.forgotPasswordAriaSameWindow, forgotPasswordAriaSameWindow = _forgotPasswordAriaSameWindow === void 0 ? "Forgot password?" : _forgotPasswordAriaSameWindow, submitA11yProps = param.submitA11yProps;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        gap: "$20x",
        children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                testID: "account-form-submit-button",
                variant: "primary",
                type: "submit",
                label: actionText,
                size: "medium",
                analyticsName: "".concat(analyticsName, "-account-form-control-action-button"),
                width: "100%",
                loading: loading && !isRequestingPasswordlessLogin,
                disabled: disabled
            }, submitA11yProps)),
            showForgotPassword && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r, {
                variant: "primary",
                href: "/reset-password",
                analyticsName: "".concat(analyticsName, "-forgot-password"),
                target: openForgotPasswordInNewTab ? "_blank" : "_self",
                "aria-label": openForgotPasswordInNewTab ? forgotPasswordAriaNewWindow : forgotPasswordAriaSameWindow,
                margin: "auto",
                children: forgotPasswordText
            })
        ]
    });
};



/***/ }),

/***/ 30342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ AccountPasswordInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _inputs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94746);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var AccountPasswordInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) /* @__PURE__ */ {
    var analyticsName = _param.analyticsName, _supportText = _param.supportText, supportText = _supportText === void 0 ? "5-128 characters" : _supportText, customValidator = _param.customValidator, validationErrorText = _param.validationErrorText, _title = _param.title, title = _title === void 0 ? "Password" : _title, _size = _param.size, size = _size === void 0 ? "medium" : _size, _required = _param.required, required = _required === void 0 ? !0 : _required, ariaLabelledBy = _param.ariaLabelledBy, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "supportText",
        "customValidator",
        "validationErrorText",
        "title",
        "size",
        "required",
        "ariaLabelledBy"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_inputs__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        id: "password",
        analyticsName: "".concat(analyticsName, "-password"),
        size: size,
        required: required,
        textContentType: "password",
        supportText: supportText
    }, ariaLabelledBy ? {
        ariaLabelledBy: ariaLabelledBy
    } : {
        title: title
    }, props));
});
AccountPasswordInput.displayName = "AccountPasswordInput";



/***/ }),

/***/ 4958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ EmailInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _inputs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60869);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var EmailInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) /* @__PURE__ */ {
    var analyticsName = _param.analyticsName, _fieldRequiredError = _param.fieldRequiredError, fieldRequiredError = _fieldRequiredError === void 0 ? "This field is required." : _fieldRequiredError, _invalidEmailError = _param.invalidEmailError, invalidEmailError = _invalidEmailError === void 0 ? "Please enter a valid email address." : _invalidEmailError, _disableSuggestions = _param.disableSuggestions, disableSuggestions = _disableSuggestions === void 0 ? !1 : _disableSuggestions, _title = _param.title, title = _title === void 0 ? "Email" : _title, _size = _param.size, size = _size === void 0 ? "medium" : _size, _required = _param.required, required = _required === void 0 ? !0 : _required, ariaLabelledBy = _param.ariaLabelledBy, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "fieldRequiredError",
        "invalidEmailError",
        "disableSuggestions",
        "title",
        "size",
        "required",
        "ariaLabelledBy"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_inputs__WEBPACK_IMPORTED_MODULE_3__/* .ValidatedTextInput */ .O, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        id: "email-login-input",
        analyticsName: "".concat(analyticsName, "-email"),
        format: "emailAddress",
        size: size,
        required: required,
        allowSuggestions: !disableSuggestions,
        customErrorMessages: {
            fieldRequired: fieldRequiredError,
            invalidEmail: invalidEmailError
        }
    }, ariaLabelledBy ? {
        ariaLabelledBy: ariaLabelledBy
    } : {
        title: title
    }, props));
});
EmailInput.displayName = "EmailInput";



/***/ }),

/***/ 38251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ NameInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _inputs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94746);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var NameInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) /* @__PURE__ */ {
    var analyticsName = _param.analyticsName, _invalidNameError = _param.invalidNameError, invalidNameError = _invalidNameError === void 0 ? "Please enter your full name." : _invalidNameError, _title = _param.title, title = _title === void 0 ? "Full name" : _title, _size = _param.size, size = _size === void 0 ? "medium" : _size, _autoComplete = _param.autoComplete, autoComplete = _autoComplete === void 0 ? "name" : _autoComplete, ariaLabelledBy = _param.ariaLabelledBy, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "invalidNameError",
        "title",
        "size",
        "autoComplete",
        "ariaLabelledBy"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_inputs__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        id: "name",
        analyticsName: "".concat(analyticsName, "-name"),
        size: size,
        autoComplete: autoComplete,
        errorText: props.errorText || invalidNameError
    }, ariaLabelledBy ? {
        ariaLabelledBy: ariaLabelledBy
    } : {
        title: title
    }, props));
});
NameInput.displayName = "NameInput";



/***/ }),

/***/ 66213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PhoneInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _inputs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60869);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var PhoneInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) /* @__PURE__ */ {
    var analyticsName = _param.analyticsName, _invalidPhoneError = _param.invalidPhoneError, invalidPhoneError = _invalidPhoneError === void 0 ? "Please enter a valid phone number." : _invalidPhoneError, _fieldRequiredError = _param.fieldRequiredError, fieldRequiredError = _fieldRequiredError === void 0 ? "This field is required." : _fieldRequiredError, _title = _param.title, title = _title === void 0 ? "Phone number" : _title, _size = _param.size, size = _size === void 0 ? "medium" : _size, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "000-000-0000" : _placeholder, ariaLabelledBy = _param.ariaLabelledBy, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "invalidPhoneError",
        "fieldRequiredError",
        "title",
        "size",
        "placeholder",
        "ariaLabelledBy"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_inputs__WEBPACK_IMPORTED_MODULE_3__/* .ValidatedTextInput */ .O, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        id: "phone",
        analyticsName: "".concat(analyticsName, "-phone"),
        format: "telephoneNumber",
        size: size,
        placeholder: placeholder,
        customErrorMessages: {
            fieldRequired: fieldRequiredError,
            invalidPhoneNumber: invalidPhoneError
        }
    }, ariaLabelledBy ? {
        ariaLabelledBy: ariaLabelledBy
    } : {
        title: title
    }, props));
});
PhoneInput.displayName = "PhoneInput";



/***/ })

}]);